// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: Poppins;
}
.tablepreper {
  display: flex;
  justify-content: center;
  background-color: #e1e1e1;
  padding: 50px 0px;
}
/* Custom CSS for the table */
.loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.loading-spinner {
  border: 8px solid rgba(0, 0, 0, 0.1);
  border-left-color: #7986cb;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

p {
  margin-top: 20px;
  font-size: 18px;
}
.custom-table {
  width: 80%;
  border-collapse: collapse;
}

.custom-table th,
.custom-table td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.custom-table th {
  background-color: #f2f2f2;
}

.custom-table tbody tr:hover {
  background-color: #f2f2f2;
}

.custom-table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.custom-table a {
  color: blue;
  text-decoration: none;
}

.custom-table a:hover {
  text-decoration: underline;
}

@media (min-width: 320px) and (max-width: 420px) {
  .slider-image-div img {
    height: 400px !important;
    object-fit: cover !important;
    padding: 0px 10px;
  }
  .slider-image-div {
    height: auto;
    padding: 0 0px !important;
  }
  .socialmediagridicon {
    display: grid !important;
  }

  .graph-newdesign11 {
    display: flex;
    margin-left: 11px !important;
  }
}

@media (min-width: 320px) and (max-width: 767px) {
  .main-vediopage {
    display: block !important;
  }

  .vediopage {
    width: 100% !important;
  }

  .socialmediagridicon {
    /* display: flex !important; */
    justify-content: center !important;
  }

  p.dataTitle {
    font-size: 16px !important;
  }

  .form-outline.mb-2 {
    height: 80px !important;
  }

  p.Subscription {
    font-size: 18px !important;
  }

  .homepagepay {
    background: #42c1f4 !important;
    padding-bottom: 12px !important;
  }

  .auth-divide-section {
    display: block !important;
  }

  .Registerpage {
    margin: 0px 20px !important;
  }

  .forgotpage {
    margin: 0px 20px !important;
  }
  .spaceonright {
    left: 40% !important;
    top: 90% !important;
  }

  select.custom-select.custom-select-sm.form-control.form-control-sm {
    width: 80% !important;
  }

  .tobtext {
    top: 30% !important;
  }

  table {
    border-collapse: collapse !important;
    width: 100% !important;
  }
  .dataTable td {
    font-size: 11px !important;
  }

  /* .table-responsive {
  margin: 130px 0 0;
  font-family: "Figtree", sans-serif;
} */

  input.form-control.form-control-sm.ml-0.my-1 {
    max-width: auto !important;
    height: 45px !important;
    float: none !important;
  }

  .dataTable th {
    font-size: 12px !important;
    padding: 10px 10px !important;
  }

  .thanktexthome.userlist {
    padding: 0px 10px !important;
  }

  img.logo-dashboard {
    width: 110px !important;
  }

  .rounded-border-contnet {
    width: 40px !important;
    height: 40px !important;
  }

  img.imgPro {
    width: 16px !important;
  }

  p.count {
    font-size: 13px !important;
  }

  .heading h1 {
    font-size: 23px !important;
    margin-bottom: 12px !important;
  }

  .elementor-widget-container {
    font-size: 22px !important;
  }
  .spaceonright {
    margin-top: 90px !important;
    /* padding-bottom: 12px !important; */
    /* display: flex;
    align-items: center;
    justify-content: center !important;
    text-align: center; */
  }
  .logo-m img {
    max-width: 120px !important;
    margin: 0 auto !important;
  }
  .container-text {
    width: 100% !important;
  }
  .mobl {
    display: block !important;
  }
  .topdiv {
    overflow: unset !important;
  }
  .logo-m {
    display: block !important;
  }
  .togglediv {
    display: flex;
    padding: 0 20px;
  }

  .logo-m {
    width: 100%;
  }
  button.togglebtn {
    display: block !important;
  }
  .logomenu {
    width: 100% !important;
    display: block !important;
    padding: 0 !important;
  }
  .logomenu li {
    padding: 10px 0 !important;
    border-bottom: 1px solid #dddd !important;
  }
  .scrolled .logonavbar {
    position: absolute !important;
  }
  .newlogo {
    width: 150px;
    display: none;
  }
  .mobl .newlogomenu {
    position: absolute;
    background: #000;
    width: 230px;
    z-index: 9999;
    top: 30px;
    left: 20px;
    padding: 0 10px;
  }
  .logonavbar {
    width: 200px !important;
    padding: 20px 10px;
    z-index: 999;
    border-top: unset !important;
    margin-top: 34px !important;
    background: #000;
    display: none;
  }
  p.emailtext {
    display: none;
  }
  .oneinputtitle {
    margin-top: 0 !important;
  }

  .Data-plotting {
    display: block !important;
  }
  .Data-plotting .graphplot {
    width: 100% !important;
  }
  .graphdetail {
    width: 100% !important;
  }
  .graphdetail > div {
    margin-top: 0 !important;
    display: unset !important;
  }
  .icondown {
    margin-left: 5px !important;
    margin-top: 10px !important;
    float: unset !important;
    display: unset !important;
  }
  .select-steps-contnet {
    font-size: 16px !important;
  }
  .clusterPlot141 {
    display: block !important;
  }
  button.i-contnet-btn {
    border-radius: 100% !important;
    width: 30px !important;
    height: 30px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin-left: 5px !important;
  }

  .confidenceContainer {
    display: block !important;
    margin-left: -9px !important;
  }

  .confidence {
    width: 97% !important;
    margin-left: 0 auto !important;
  }

  .clusterPlot.clusterPlot141 {
    width: 97% !important;
    margin-left: 10px !important;
  }

  .clustergraph svg.recharts-surface {
    margin-top: 16px !important;
    height: auto !important;
  }

  .oneinputtitle.select-method {
    margin-top: 13px !important;
  }

  .dataresult {
    display: block !important;
    margin-bottom: 12px !important;
  }

  .datashow {
    width: 100% !important;
    margin-bottom: 18px !important;
  }

  .result {
    width: 100% !important;
  }

  .Data-plotting {
    margin-left: 0 !important;
  }

  /* .Data-plotting .graphplot {
  width: auto !important;
} */

  /* .recharts-wrapper {
    width: 270px !important;
  } */

  p.dataTitle.preprosesing-cont {
    margin-top: 40px !important;
  }

  p.dataTitle.confidence-cont {
    margin-top: 46px !important;
  }

  label.select-toggle-btn {
    font-size: 12px !important;
  }

  h2.number-lenght.text-red-800 {
    margin-bottom: 21px !important;
  }

  .straoght-border {

    margin-top: -11px !important;
    width: 65px !important;

    margin-left: -10px !important;
  }

  h2.number-lenght.text-red-800 {
    display: flex !important;
    justify-content: center !important;
    width: 40px !important;
  }
  .Services1 {
    width: 100% !important;
  }
  .allServices {
    display: block !important;
  }
  .Services {
    background-size: cover !important;
  }
  .Services-top .grid {
    display: unset !important;
  }
  .Services-top {
    padding: 0 30px !important;
  }

  .changing-content {
    font-size: 22px !important;

    line-height: inherit !important;
  }
  .test-1 {
    font-size: 13px !important;
  }
  h1.Servicestitle {
    font-size: 24px !important;
    text-align: center !important;
  }
  h1.Contacttitle {
    font-size: 24px !important;
    text-align: center !important;
  }
  .Contactsecdiv-text {
    width: 100% !important;
    display: unset !important;
  }
  h2.contactlink {
    font-size: 18px !important;

    margin: 0px 0 30px !important;
    text-align: center !important;
  }
  .Services-icon {
    margin: 5px auto 2px !important;
    transform: rotate(90deg) !important;
  }
  .footer {
    display: block !important;
  }
  .topdiv {
    height: auto !important;
  }
  .Contactsecdiv {
    display: block !important;
    margin: 30px 0 !important;
  }
  .Contactsecdiv-img {
    width: 100% !important;
  }
  .tobtext h1 {
    font-size: 18px !important;
    padding: 0 20px !important;
    text-align: center !important;
  }
}

@media (min-width: 767px) and (max-width: 1170px) {
}

.loginRight .loginsigin li {
  list-style: none;
}
.topdiv {
  height: auto !important;
}
/* .elementor-widget-container {

  font-size: 32px !important;
  
} */
/* .changing-content {
  font-size: 32px !important;
} */
.Services-top {
  padding: 0 15px !important;
}
.Services1 {
  padding: 10px 10px !important;
}
.tobtext h1 {
  font-size: 30px;
  padding: 0 20px !important;
}
.bgCo {
  background: #42c1f4 !important;
}

.loginRight {
  position: absolute;
  background: #fff;
  width: 150px;
  box-shadow: 0px 13px 18px #eee;
  padding: 20px;
  right: 0;
  top: 98px;
  border-top: 4px solid #1acb1a;
  border-radius: 4px 3px 0px 0px;
}

.drop_down_open {
  cursor: pointer;
}

.home_active .Header-main-div {
  position: absolute;
  top: 0;
  z-index: 9999;
  left: 0;
  right: 0;
  background: transparent !important;
}

.home_active {
  position: relative;
}

.active-header-info {
  border-bottom: 2.5px solid #1e40af;
  color: #000 !important;
  font-weight: 500;
  padding: 0px 0px 8px 0px;
}

img.HomeimgSize {
  width: 100%;
  max-width: 40px;
  padding: 6px 0px;
}

.active > .page-link,
.page-link.active {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: #0746a5;
  border-color: var(--bs-pagination-active-border-color);
}

.first-tab,
.second-tab,
.third-tab {
  padding: 3px 0px;
}

.blogs_forms {
  width: 100%;
  max-width: 600px;
}

/* css dec 14  */

.toggle-data-main {
  display: none;
}

.contactuspage {
  margin: 0 0 10px;
}

.menu-icon,
.cross-icon {
  color: white;
}

/* SWAL  */

.errorAlert .swal-text,
.errorAlert-login .swal-text {
  color: #d14f4f;
}

.successAlert .swal-text,
.successAlert-login .swal-text {
  color: #59cf65;
}

.swal-button--danger {
  background-color: #e64942 !important;
  width: 86px !important;
}

.swal-button--cancel {
  color: #555;
  background-color: #efefef;
  width: 86px !important;
  border: none;
  outline: none;
}

.swal-text {
  text-align: center;
  font-family: "Figtree", sans-serif;
}

/* .swal-icon:first-child {
  margin-top: 55px;
} */
.swal-icon:first-child {
  margin-top: 27px;
}

/* .swal-icon:first-child {
  margin-top: 45px;
} */

.swal-icon {
  margin: 10px auto;
}

.errorAlert .swal-title,
.errorAlert-login .swal-title {
  color: #d14f4f;
  font-family: "Figtree", sans-serif;
  letter-spacing: 0.5px;
}

.warningAlert .swal-title,
.warningAlert-login .swal-title {
  color: #d99836;
  font-family: "Figtree", sans-serif;
  letter-spacing: 0.5px;
}

.successAl1ert .swal-title,
.successAlert-login .swal-title {
  color: #59cf65;
  font-family: "Figtree", sans-serif;
  letter-spacing: 0.5px;
}

.swal-modal .swal-text {
  color: #49454f;
  font-family: "Figtree", sans-serif;
  letter-spacing: 0.25px;
  margin-top: 0px;
}

.swal-title {
  padding: 0px 16px !important;
  font-size: 16px !important;
}

.swal-footer {
  text-align: center !important;
}

.css-1qqsdnr-MuiAutocomplete-root
  .MuiAutocomplete-inputRoot
  .MuiAutocomplete-input {
  width: 0;
  min-width: 30px;
  max-height: 12px !important;
}

.css-1qqsdnr-MuiAutocomplete-root .MuiOutlinedInput-root {
  height: 40px !important;
}

.eventSearchbar
  .css-1qqsdnr-MuiAutocomplete-root
  .MuiOutlinedInput-root
  .MuiAutocomplete-input {
  padding: 12px 15px !important;
  outline: none !important;
  border-radius: 0 !important;
}

svg.MuiSvgIcon-root.MuiSvgIcon-fontSizeSmall.css-ptiqhd-MuiSvgIcon-root {
  background: #1e40af;
  color: white !important;
  font-weight: bolder !important;
  border-radius: 33px !important;
  width: 25px !important;
  height: 25px !important;
  margin: -3px -5px !important;
}

/* .swal-icon img {
  max-width: 100%;
  max-height: 100%;
  display: unset;
} */

.swal-icon img {
  max-width: 100%;
  max-width: 60px !important;
  max-height: 100%;
  display: unset;
}

.swal-footer {
  text-align: right;
  padding-top: 13px;
  margin-top: 0 !important;
  padding: 13px 16px;
  border-radius: inherit;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.table-responsive {
  margin: 40px 0 0;
  font-family: "Figtree", sans-serif;
}

.table > :not(:first-child) {
  border-top: 0 !important;
}

.dataTable td {
  font-size: 16px;
  font-weight: 500;
}

.dataTable tr td:nth-child(2) {
  align-items: center;
  /* padding-top: 12px; */
  padding-left: 10px;
  /* padding-bottom: 10px; */
  text-align: center;
  height: 44px;
}

.dataTable tr td:nth-child(1) {
  align-items: center;
  /* padding-top: 12px; */
  padding-left: 11px;
  /* padding-bottom: 10px; */
  text-align: center;
  height: 44px;
}

/* .dataTable tr:nth-child(2n + 2) {
  background: rgba(36, 114, 252, 0.08);
  font-family: poppins !important;
} */

.dataTable tr:nth-child(2n + 2) {
  background: rgb(148 142 209 / 37%);
  font-family: poppins !important;
}

.dataTable
  button.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.MuiButtonBase-root.deletebutt.css-1e6y48t-MuiButtonBase-root-MuiButton-root {
  margin: 0 !important;
  min-width: auto !important;
}

.dataTable a:hover {
  background: none;
}

.table > thead {
  vertical-align: bottom;
  background: rgb(136 121 201 / 82%);
}

.col-sm-12.col-md-6 {
  display: unset !important;
  font-family: poppins !important;
}

.col-md-6 {
  flex: 0 0 auto;
  width: 50%;
}

.savebtn {
  width: 160px !important;
  height: 47px;
  grid-gap: 10px;
  gap: 10px;
  background: #2472fc00 !important;
  font-size: 16px !important;
  font-family: "Figtree", sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px !important;
  border: 1px solid #084ec5;
  font-family: poppins !important;
  float: right;
}

.dataTable th {
  font-size: 16px;
  padding: 8px 25px;
  font-weight: 700;
  color: #000;
  font-family: "poppins", sans-serif !important;
}

.table-bordered > :not(caption) > * > * {
  border-width: 0 !important;
}

.table-bordered > :not(caption) > * {
  border-width: 0px 0;
}

.homepagepay.usr {
  background: #42c1f4;
  padding-bottom: 35px;
}
.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-accent-bg: rgb(255 255 255);
  color: var(--bs-table-striped-color);
  font-family: poppins !important;
}

.css-1d3z3hw-MuiOutlinedInput-notchedOutline {
  text-align: left;
  position: absolute;
  bottom: 0;
  right: 0;
  top: -5px;
  left: 0;
  margin: 0;
  padding: 0 8px;
  pointer-events: none;
  border-radius: inherit;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  min-width: 0%;
}

thead[data-test="table-foot"] {
  display: none;
}

select.custom-select.custom-select-sm.form-control.form-control-sm {
  height: 44px;
  border-radius: 8px;
  text-align: center;
}

.bs-select select {
  display: inline-block !important;
  float: left;
  width: 100%;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: 0.25rem;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  appearance: none;
  border-radius: 0.375rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.custom-select-sm {
  margin: 0 !important;
  height: 50px;
  width: 150px;
  border-radius: 8px;
}

/* input.form-control.form-control-sm.ml-0.my-1 {
  height: 47px;
  margin: 0 11px;
  max-width: 335px;
  border-radius: 8px;
  display: flex;
  align-items: flex-end !important;
  justify-content: flex-end !important;
  float: right;
} */

input.form-control.form-control-sm.ml-0.my-1 {
  height: 34px;
  /* margin: 0 11px; */
  max-width: 335px;
  /* border-radius: 8px; */
  display: flex;
  align-items: flex-end !important;
  justify-content: flex-end !important;
  float: right;
}

button.MuiButtonBase-root.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.close_btn.css-1e6y48t-MuiButtonBase-root-MuiButton-root {
  background: #2472fc !important;
  color: #fff !important;
  font-family: "Figtree", sans-serif !important;
  font-size: 16px !important;
  border-radius: 4px !important;
  margin-right: 16px !important;
  padding: 6px 25px !important;
  margin: 0px 16px 0 0 !important;
  text-transform: capitalize !important;
  width: 107px;
}

button.MuiButtonBase-root.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.submit_block.css-1e6y48t-MuiButtonBase-root-MuiButton-root {
  border: 2px solid #2472fc;
  border-radius: 4px;
  padding: 4px 25px;
  color: #2472fc;
  font-family: "Figtree", sans-serif !important;
  text-transform: none;
  font-weight: 600 !important;
  font-size: 16px !important;
  width: 107px;
  background: none;
}

/* h2#\\:r1\\: {
  border-bottom: 1px solid rgb(204, 194, 194);
  padding: 10px 30px;
} */

select.active_blockinput {
  width: 100%;
  border: 1px solid;
  padding: 7px 13px;
  font-size: 19px;
  font-weight: 62%;
  height: 50px;
  border-radius: 4px;
}

/* DEC 15  */

/* .toggle-data-main {
  position: absolute;
  top: 23px;
} */

.logout-section {
  position: fixed;
  top: 50%;
  right: 0;
  background: #3bd56a;
  padding: 14px;
  border-radius: 50%;
  z-index: 11111;
}

.swal-modal {
  max-width: 348px;
  background-color: #fff;
  min-width: 340px;
  border-radius: 8px;
  box-shadow: 3px 4px 5px 1px #00000080;
  height: auto;
}

/* Dec 16  */
.contact-email-logo {
  background: #3730a3;
  font-size: 15px;
  color: #fff;
  border-radius: 50px;
  padding: 15px;
}

.log-out-icon {
  color: #fff;
  padding: 5px 7px 0 0;
}

.profile_dialog-box
  .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation24.MuiDialog-paper {
  width: 100%;
  min-width: 950px;
  height: 100%;
  min-height: 600px;
}

i.fa-solid.fa-xmark {
  float: right;
}

button.add-event-btn {
  color: blue;
  border: 1px solid blue;
  border-radius: 4px;
  font-size: 13px;
  padding: 6px;
}

button.remove-event-btn {
  color: red;
  border: 1px solid red;
  border-radius: 4px;
  font-size: 13px;
  padding: 6px;
}

/* side bar icon css0 */
img.iconimage-path {
  max-width: 30px;
}

span.ml-3.flex-1.whitespace-nowrap {
  /* font-size: 18px; */
  font-weight: 400;
}

/* 20 Dec 2022 */
.Topdiv {
  background: rgba(36, 114, 252, 0.06);
  width: 100%;
  float: left;
  position: relative;
}

.verifydiv {
  background: rgba(36, 114, 252, 0.06);
}

.verifyemail {
  max-width: 600px;
}

.login-content {
  max-width: 380px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 90%;
}

.verifylogo {
  text-align: center;
}

img.login-logo {
  max-width: 200px;
  display: unset;
}

.verifyemailtext {
  text-align: center;
}

.verifyemailtext h1 {
  padding: 17px 0 12px;
}

a.successfullyButton {
  padding: 10px;
  color: #1e22aa;
  text-transform: capitalize;
  font-size: 16px;
  width: 160px;
  display: inline-block;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 47px;
  border-radius: 8px;
  margin: 31px auto 0;
  border: 1px solid #1e22aa;
}

.thankyoupage {
  background: rgba(36, 114, 252, 0.06);
}

.login-content-registering {
  max-width: 500px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 90%;
}

.thanktext {
  padding: 25px;
  width: 100%;
  border: 1px solid #0d6efd00;
  border-radius: 8px;
  box-shadow: 0px 1px 5px #0d6efd45;
  background: #fff;
}

.logo-content {
  text-align: center;
  margin: 10px 0 20px;
}

.thanktext p {
  line-height: 28px;
  text-align: center;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

/* 20 Dec 2022 */

/* 21 Dec 2022 */
.login-links a {
  color: #4338ca;
}

.login-links.last-link a {
  color: #c74646;
  margin-top: 20px;
}

ul.navbar-link-items {
  display: flex;
  justify-content: center;
  align-items: baseline;
}

.blog-item.first {
  border-top: 0px solid;
  padding-top: 0;
}

.blog-item {
  border-top: 2px solid #ddd;
  padding-top: 15px;
}

/* .container.fighting-imges {
  max-width: 1180px;
} */

@media (min-width: 1550px) and (max-width: 1900px) {
  img.fight-finder-ligo {
    width: 80% !important;
  }

  /* .box-div {
    padding: 119px;
  } */
  .container.absolute.top-50.text-center {
    left: 12rem;
  }
}

.grop-box-content.relative.flex.flex-col.items-start.px-6.bg-white.border.border-t-0.border-gray-200.py-7.rounded-b-2xl {
  min-height: 70%;
}

h1.empty-data {
  font-size: 24px;
  text-align: center;
  color: black;
  padding: 54px 10px;
  text-transform: uppercase;
}

.event-dataimg img {
  float: left;
  margin-right: 15px;
  margin-bottom: 2px;
}

.eventimg-contnet img {
  height: 100%;
}

.eventimg-contnet {
  height: 240px;
  overflow: hidden;
}

.heading-contnet-fight {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 11%;
  top: 0 !important;
  width: 100%;
}

.focus\\:ring-4:focus {
  box-shadow: unset;
}

iframe.map_image {
  height: 400px;
}

/* .related-blogs-contnet {
  float: left;
} */
.fontsize20 {
  font-size: 24px;
  font-weight: bold;
}

input.form-control.input-groups {
  border-radius: 50px 0px 0px 50px;
}

.search_bar .form-control:focus {
  box-shadow: unset;
}

.search_bar button:hover {
  background: #060692;
}

/* 
.Home-events-img {
  height: 410px;
}
.Home-events-img.relative img {
  height: 100%;
} */

/* .Home-events-actives {
  height: 440px !important;
} */

/* .Home-events-actives img {
  height: 100%;
  width: 100%;
} */
.fighter-images-events1 {
  height: 400px;
  overflow: hidden;
}

.fighter-images-events1 img {
  width: 100%;
  height: 400px;
  object-fit: cover;
}

.Home-events-img-contnet {
  height: 410px;
  width: 100%;
}

.Home-events-img-contnet img {
  height: 100%;
  width: 100%;
}

.eventimg-contnet img {
  width: 100%;
}

.dataTable tr td:nth-child(3) {
  align-items: center;
  /* padding-top: 12px; */
  padding-left: 10px;
  /* padding-bottom: 10px; */
  text-align: center;
  height: 44px;
}

.dataTable tr td:nth-child(4) {
  align-items: center;
  /* padding-top: 12px; */
  padding-left: 10px;
  /* padding-bottom: 10px; */
  text-align: center;
  height: 44px;
}

.dataTable tr td:nth-child(5) {
  align-items: center;
  /* padding-top: 12px; */
  padding-left: 10px;
  /* padding-bottom: 10px; */
  height: 44px;
}

.dataTable tr td:nth-child(7) {
  align-items: center;
  /* padding-top: 12px; */
  padding-left: 10px;
  /* padding-bottom: 10px; */
  height: 44px;
}

.box-div.bg-blue-800.py-8.pb-5.px-3.my-4.transition.ease-in-out.delay-150.hover\\:-translate-y-1.hover\\:scale-70.hover\\:bg-blue-500.duration-300.hover\\:text-white.w3-animate-zoom.ease-in {
  height: 193px;
}

.welcome-event-home {
  top: 30% !important;
  font-family: "Rajdhani", sans-serif;
  left: 30px;
}

.welcome-event-home11 {
  top: 25% !important;
  font-family: "Rajdhani", sans-serif;
  left: 30px;
}

button.blog-btn.bg-blue-800.hover\\:bg-blue-700.text-white.uppercase {
  font-size: 12px;
  width: 60px;
  padding: 3px;
  border-radius: 3px;
  margin-right: 17px;
  letter-spacing: 2px;
  font-weight: 500;
  font-family: "Rajdhani";
}

.not-fount-data {
  font-size: 27px;
  color: black;
  text-align: center !important;
  width: 100%;
}

.not-fount-data_content {
  text-align: center;
  font-size: 25px;
  color: black;
}

.fight-finder-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  transition: all 0.3s ease-out 0s;
  padding: 24px;
  background-color: white;
  font-family: poppins !important;
}

/* 9-01-2023 */
.userpage {
  background: #fff;
  width: 97%;
  margin: 0px auto;
  padding: 40px;
  border-radius: 8px;
}

.SelectEventTypeDiv .MuiInputBase-root.MuiOutlinedInput-root {
  width: 100%;
}

.SelectEventTypeDiv h1 {
  margin-bottom: 10px;
}

.UserdetailsEventsDiv h1 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
  margin-top: 20px;
}

.eventTitleInput {
  width: 100%;
  height: 48px;
  padding: 0 10px;
  background: #fff;
  border: 1px solid #ddd;
  /* margin-bottom: 10px; */
  border-radius: 8px;
  margin-top: 5px;
}

.SelectEventTypeDiv
  .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
  padding: 11px 14px;
}

.SelectEventTypeDiv .MuiOutlinedInput-notchedOutline {
  border-color: #ddd;
  border-radius: 8px;
}

.AgeEventsDiv h4 {
  margin-bottom: 4px;
}

.AgeEventsDiv
  .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary {
  width: 100%;
  margin-bottom: 19px;
}

.AgeEventsDiv .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input {
  padding: 12px 14px;
}

fieldset.MuiOutlinedInput-notchedOutline {
  border-color: #ddd;
  border-radius: 8px;
}

.CompLevelEventsDiv h4 {
  margin-bottom: 6px;
}

.CompLevelEventsDiv
  .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary {
  width: 100%;
  margin-bottom: 19px;
}

/* .SelectEventTypeDiv {
  margin: 0 !important;
} */

.countryEventsDiv h4 {
  margin-bottom: 6px;
}

.EventdetailsEventsDiv h1 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
  margin-top: 20px;
}

.EventAddAddressArea textarea.eventAddressArea {
  width: 100%;
  height: 200px !important;
  border: 1px solid #ddd;
  border-radius: 8px;
  /* margin-bottom: 19px; */
  margin-top: 6px;
  padding: 6px;
}

.descrclass,
input.eventZipCodeInput {
  width: 100%;
  height: 48px;
  padding: 0 10px;
  background: #fff;
  border: 1px solid #ddd;
  /* margin-bottom: 19px; */
  border-radius: 8px;
  /* margin-top: 8px; */
}

.SelectEventCountryDiv h1 {
  margin: 0 0 6px;
}

.countryEventsDiv
  .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary {
  width: 100%;
}

.SelectEventCountryDiv
  .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary {
  width: 100%;
  margin-bottom: 19px;
}

.MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input {
  padding: 12px 13px;
}

.taskDueDate .MuiInput-underline:before {
  border-bottom: none;
}

label.taskDueDate {
  border: 1px solid #ddd;
  height: 57px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  padding: 0 10px;
  margin: 6px 0 19px;
}

.SelectEventDateDiv .MuiInput-underline:hover:not(.Mui-disabled):before {
  border-bottom: none;
}

.SchooldetailsEventsDiv h1 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}

.OrganizerSocialEvent .css-14lo706 {
  display: none;
}

.OrganizerSocialEvent .css-14lo706 span {
  display: none;
}

.userform {
  max-width: 600px;
}

.SchoolEventTimeEvent legend {
  display: none;
}

.SchoolEventTimeEvent label {
  display: none;
}

/* .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input {
  font: inherit;
  letter-spacing: inherit;
  color: currentColor;
  padding: 4px 0 5px;
  border: 0;
  box-sizing: content-box;
  background: none;
  height: 31px !important;
  margin: 0;
  -webkit-tap-highlight-color: transparent;
  display: block;
  min-width: 0;
  width: 100%;
  -webkit-animation-name: mui-auto-fill-cancel;
  animation-name: mui-auto-fill-cancel;
  -webkit-animation-duration: 10ms;
  animation-duration: 10ms;
  padding: 11px 14px 12px;
  padding-right: 0;
} */

.SchoolEventTimeEvent .MuiInputAdornment-root.MuiInputAdornment-positionEnd {
  padding: 0;
}

/* .SchoolEventTimeEvent input {
  padding: 9px 11px 13px;
} */
.SchoolEventTimeEvent h1 {
  margin-bottom: 6px;
}

/* .SchoolEventTimeEvent .MuiFormControl-root.MuiTextField-root {
  margin-bottom: 20px;
} */
.taskDueDate .MuiFormControl-root.MuiTextField-root {
  margin-bottom: 0;
}

.OrganizerSocialEvent h1 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
  margin-top: 20px;
}

.EventAcceptForeignDiv {
  margin: 0 0 20px;
}

.EventAcceptForeignDiv h1 {
  margin: 0 0 8px;
}

.EventAcceptForeignDiv label {
  margin: 0 10px;
}

.EventDetailsEventDiv,
.SpecialInstEvent,
.DateSeminarEvent {
  margin: 0 0 0px;
}

.SubmitHandlerEventAdd button {
  background: #1e22aa;
  color: #fff;
  padding: 11px 43px;
  text-transform: uppercase;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.3px;
  /* margin: 15px 0 0; */
  border: none;
}

/* .SelectEventCountryDiv input {
   margin: 0 0 10px;
} */
.CostSeminarEvent,
.EventAddZipCodeArea h4 {
  margin-bottom: 6px;
}

.DateSeminarEvent h1 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}

.SpecialInstEvent h1 {
  margin-bottom: 8px;
}

.SpecialInstEvent textarea {
  height: 200px !important;
  /* margin-top: 9px; */
  padding: 10px;
}

.EventDetailsEventDiv textarea {
  height: 200px !important;
  margin-top: 9px;
  padding: 10px;
}

.CostSeminarEvent h1 {
  margin: 0 0 6px;
}

/* .Minimumdiv {
  display: flex;
  margin-top: 7px;
  width: 100%;
} */
/* .Minimum {
  width: 50%;
  margin-right: 10px;
} */
/* .Minimum1 {
  width: 50%;
} */
.Minimumdiv h4 {
  margin-bottom: 6px;
}

.SelectEventCountryDiv textarea {
  height: 200px !important;
  padding: 6px;
}

input:focus-visible {
  outline: none;
}

input:focus {
  border: 1px solid #0072ff;
}

.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-width: 1px !important;
}

textarea:focus-visible {
  outline: none;
}

.auth-logo-contnet {
  display: flex;
  justify-content: center;
  align-items: center;
}

img.auth-logo {
  width: 30% !important;
}

.auth-logo-contnet-register {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.App_import input#email {
  font-size: 14px;
  font-weight: 300;
}

.App_import input#password {
  font-size: 14px;
  font-weight: 300;
}

.login-form-fight {
  font-family: poppins !important;
}

h1.title-font-blogs {
  font-family: "Rajdhani", sans-serif;
  font-size: 22px;
  font-weight: 900;
  font-style: normal;
  line-height: 27px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #000;
}

.post_meta {
  margin-bottom: 15px;
}

span.post_meta_item.post_date {
  font-family: "Rajdhani", sans-serif;
  font-weight: 700;
}

p.leading-relaxed11 {
  color: #000000e0;
  font-size: 16px;
  line-height: 30px;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
}

.public-footer {
  float: left;
  width: 100%;
  box-shadow: 1px 1px 4px #a3a3a3;
}

/* body {
  font-family: "Rajdhani", sans-serif;
} */

p.blog-title11.sm\\:text-xl.md\\:text-2xl.lg\\:text-2xl.xl\\:text-2xl.font-bold.text-blue-800 {
  font-family: "Rajdhani", sans-serif;
}

ul.footer-list-item {
  font-family: poppins;
}

/* .achivements_button {
  background: #1e40af;
  color: #fff;
  padding: 8px 20px;
  font-weight: 500;
  text-transform: uppercase;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
} */

.achivements_button {
  background: #1e40af;
  color: #fff;
  padding: 4px 7px;
  font-weight: 500;
  text-transform: uppercase;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
}

h1.titelhome {
  text-align: center;
  padding-top: 50px;
  color: #1e40af;
  font-size: 38px;
  font-weight: bold;
}

h4.fontsize56 {
  text-align: center;
  /* padding: 50px 0; */
  color: #fff;
  /* font-size: 56px; */
  font-weight: bold;
}

h3.fontsize38 {
  padding: 4px 0 4px;
  color: #1e40af;
  font-weight: bold;
  font-family: "Rajdhani", sans-serif;
}

button.viewbtn {
  background: #1e40af;
  color: #fff;
  padding: 12px 26px;
  font-weight: 500;
  text-transform: uppercase;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
}

.Home-events-img11 {
  height: 370px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

h4.pagetitleall {
  text-align: center;
  padding: 0 0 4px;
  color: #fff;
  font-size: 23px;
  font-weight: bold;
}

.eventspage {
  padding: 90px 0 30px;
}

.eventsec {
  float: left;
  width: 100%;
  margin-bottom: 80px;
}

.Home-events-page {
  width: 33.33%;
}

.eventimg {
  height: 280px;
  overflow: hidden;
}

.eventimg img {
  object-fit: cover;
  height: 100%;
}

.Home-events-page {
  width: 32.33%;
  margin: 5px;
  box-shadow: 1px 1px 6px #ddd;
  padding: 28px;
  border-radius: 9px;
  float: left;
}

.fighter-name2 {
  padding: 20px 0 0;
}

span.eventdate {
  font-size: 18px;
  color: #000;
  margin-bottom: 7px !important;
  display: inline-block;
}

.fighter-name2 h2 {
  font-size: 24px !important;
  font-weight: 700;
  color: #1e40af;
}

.eventdetails {
  float: left;
  width: 100%;
  padding: 30px 0 60px;
}

h2.relatedtitle {
  text-align: center;
  padding: 40px 0 60px;
  color: #1e40af;
  font-size: 38px !important;
  font-weight: bold;
  font-family: "Rajdhani", sans-serif;
  float: left;
  width: 100%;
}

.blogpage1 {
  padding: 108px 0 39px;
}

.blogdetailepage {
  padding: 50px 0 30px;
}

.commontext {
  margin: -54px 0 20px;
}

.commontext span {
  background: #1e40af;
  color: #fff;
  padding: 10px 19px;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  font-family: "Poppins", sans-serif;
}

.datedetailssec {
  background: #1e40af;
  color: #fff;
  padding: 10px 19px;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  font-family: "Poppins", sans-serif;
}

h1.blogtitledetails {
  padding: 5px 0 14px;
  color: #1e40af;
  font-size: 38px;
  font-weight: bold;
  font-family: "Rajdhani", sans-serif;
}

.aboutpage {
  padding: 50px 0;
}

.bakground {
  background: #f7f7f7;
  width: 100%;
  float: left;
}

h2.titleourpage {
  text-align: center;
  padding: 50px 0 0;
  color: #1e40af;
  font-size: 38px !important;
  font-weight: bold;
}

/* .addevent {
  margin-top: 162px;
  margin-bottom: 40px;
} */
.Relatedevents {
  width: 100%;
  float: left;
}

.terms-cojnn p {
  font-size: 15px;
  line-height: 30px;
}

.eventimg-contnet {
  width: 100%;
  float: left;
}

.event-dataimg {
  float: left;
  width: 100%;
}

.related-blogs-contnet {
  float: left;
}

.eventsbak {
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0.8;
  padding: 24px 24px;
  margin: 0 0 -4px;
}

.fourth-contnet-font-fam {
  font-family: "Poppins";
}

/* scroll bar modify */

/* Hide scrollbar for Chrome, Safari and Opera */
/* body {
  overflow-y: scroll; 
}
body::-webkit-scrollbar {
    display: none;
} */

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 20px !important;
}

/* scroll bar modify */

.menuhome {
  position: relative;
}

.header-sidebar-coontnet {
  position: absolute;
  width: 100%;
}

.MuiAutocomplete-root.MuiAutocomplete-hasClearIcon.form-control.input-groups.font-normal.rounded-md.text-gray-700.bg-white.border.border-solid.border-gray-300.css-1qqsdnr-MuiAutocomplete-root {
  padding: 0;
  height: 40px;
  border: none !important;
}

.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-fullWidth.MuiInputBase-formControl.MuiInputBase-adornedEnd.MuiAutocomplete-inputRoot.css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root {
  padding: 2px;
  border-radius: 0 !important;
}

.MuiAutocomplete-root.form-control.input-groups.font-normal.rounded-md.text-gray-700.bg-white.border.border-solid.border-gray-300.css-1qqsdnr-MuiAutocomplete-root {
  padding: 0 !important;
  height: 40px !important;
  border: none !important;
  border-radius: 30px 0px 0px 30px !important;
  outline: none;
}

.searchsec
  .css-1qqsdnr-MuiAutocomplete-root
  .MuiOutlinedInput-root
  .MuiAutocomplete-input {
  padding: 11px 13px !important;
}

.css-1qqsdnr-MuiAutocomplete-root .MuiOutlinedInput-root {
  padding: 1px !important;
}

button#mui-p-80405-T-1 {
  font-family: "Rajdhani", sans-serif !important;
  font-weight: bold;
}

.css-nwrfgk-MuiButtonBase-root-MuiTab-root {
  color: black !important;
  font-weight: 500;
  font-size: 17px !important;
  line-height: 1.25;
  padding: 12px 16px;
  font-weight: bold !important;
  font-family: "Rajdhani", sans-serif !important;
}

.css-1aquho2-MuiTabs-indicator {
  background-color: #42c1f4 !important;
  font-family: "Rajdhani", sans-serif !important;
}

.org-div {
  float: left;
  width: 100%;
}

.searchsec fieldset.MuiOutlinedInput-notchedOutline {
  border-color: none !important;
  border-radius: 0;
}

.searchsec .search_bar button:hover {
  background: none !important;
}

.searchsec .MuiButtonBase-root.MuiIconButton-root.MuiIconButton-sizeMedium {
  background: none;
}

.search_bar input:focus {
  border: none;
}

.searchsec fieldset.MuiOutlinedInput-notchedOutline {
  border-radius: 50px 0 0 50px !important;
}

i.fa-solid.fa-arrow-right {
  padding: 0px 6px;
}

.lkjDVC {
  min-width: 322px;
  max-width: 600px !important;
  height: 48px;
  border: dashed 2px #0a6ae7;
  padding: 8px 16px 8px 8px;
  border-radius: 5px;
  cursor: pointer;
  flex-grow: 0;
}

.css-1qqsdnr-MuiAutocomplete-root
  .MuiAutocomplete-inputRoot
  .MuiAutocomplete-input {
  width: 0;
  min-width: 30px;
  height: 31px !important;
}

/* .MuiTabs-flexContainer.css-heg063-MuiTabs-flexContainer {
  margin-left: 25px;
} */
.searchsec .MuiOutlinedInput-root .MuiAutocomplete-input {
  padding: 7.5px 4px 7.5px 20px !important;
}

/* .we .css-13xfq8m-MuiTabPanel-root {
  padding-top: 29px !important;
} */

.about-us-content td {
  padding: 12px;
  font-size: 16px;
  font-weight: 500;
  line-height: 35px;
  font-family: "Poppins";
  width: 50% !important;
}

.about-us-content img {
  border-radius: 14px;
  width: 100% !important;
}

/* .about-us-content h2 {
  font-size: 21px !important;
  font-family: "Rajdhani", sans-serif;
  text-align: center;
  font-weight: bold;
} */

.about-us-content table {
  border-color: #f0f8ff00 !important;
}

.font-fam-contnet {
  font-family: "Rajdhani", sans-serif;
  font-size: 16px !important;
}

.popins-font-fam {
  font-family: poppins !important;
  font-size: 15px !important;
}

/* .inputCntnr.error {
  border: 2px solid #d10d0dbf;
  border-radius: 7px;
} */

textarea.eventTitleInput-desc {
  width: 100%;
  height: 200px !important;
  border: 1px solid #ddd;
  border-radius: 8px;
  /* margin-bottom: 19px; */
  margin-top: 6px;
  padding: 6px;
}

.css-1u3bzj6-MuiFormControl-root-MuiTextField-root {
  width: 100% !important;
  height: 50% !important;
}

.css-nxo287-MuiInputBase-input-MuiOutlinedInput-input {
  padding: 13px 14px !important;
}

label[data-shrink="false"]
  + .MuiInputBase-formControl
  .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input {
  padding: 10px 14px !important;
}

.blogs_forms11 {
  width: 80% !important;
}

.switch-box {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch-box input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider-toggle {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}

.slider-toggle:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
}

input:checked + .slider-toggle {
  background-color: #2164f3;
}

input:focus + .slider-toggle {
  box-shadow: 0 0 1px #42c1f4;
}

input:checked + .slider-toggle:before {
  transform: translateX(26px);
}

/* Rounded sliders */
.slider-toggle.round {
  border-radius: 34px;
}

.slider-toggle.round:before {
  border-radius: 50%;
}

.MuiBox-root.css-0 {
  padding-bottom: 12px !important;
}

.css-13xfq8m-MuiTabPanel-root {
  padding: 0 !important;
}

/* 9 march */

/* .feedbackAboutAreaMainD.events-search-feed {
  width: 80%;
} */

.css-vqmohf-MuiButtonBase-root-MuiRadio-root.Mui-checked {
  color: #193ad2 !important;
}

.react-slideshow-container .default-nav:first-of-type {
  margin-right: 0px !important;
  border-right: 14;
  border-top: 0;
  padding: 3px 10px 3px 7px !important;
  left: 20px !important;
}

.react-slideshow-container .default-nav:last-of-type {
  margin-left: 0px !important;
  right: 20px !important;

  padding: 3px 10px 3px 7px !important;
}

.react-slideshow-container .default-nav {
  height: 30px;
  background: rgb(255 255 255 / 30%);
  width: 30px;
  border: 0;
  text-align: center;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ReactCollapse--collapse {
  transition: height 500ms;
}

/* .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation24.MuiDialog-paper.MuiDialog-paperScrollPaper.MuiDialog-paperWidthSm.css-1t1j96h-MuiPaper-root-MuiDialog-paper {
  width: 100%;
  height: auto;
} */

.crop-contnet {
  height: 0 max-content;
  height: auto;
  height: 0;
  margin-left: -13px;
  margin-top: 11px;
}

textarea.event-desc-contnet {
  width: 100%;
  height: 200px !important;
  border: 1px solid #ddd;
  border-radius: 8px;
  /* margin-bottom: 19px; */
  margin-top: 6px;
  padding: 6px;
}

i.fa.fa-search.text-black.text-md {
  font-size: 17px;
  padding-left: 4px;
}

.aero-angle-dowun {
  transform: rotate(177deg);
  height: 22px;
}

i.fas.fa-angle-down {
  margin-left: 8px;
  font-size: 19px;
}

.slider-image-div {
  height: auto;
  padding: 0 25px;
}

.evetns-search-image img {
  height: 100%;
  width: 100%;
  overflow: hidden;
  object-fit: cover;
  object-position: top;
}

.evetns-search-image {
  height: 200px;
  overflow: hidden;
}

p.leading-relaxed11.file-search {
  font-size: 12px !important;
  line-height: 22px !important;
}

h1.title-font-blogs.events-search-title {
  font-size: 19px;
  /* margin-bottom: 2px !important; */
}

p.post_meta_item11.post_date {
  font-family: "Rajdhani", sans-serif;
  font-weight: 700;
}

i.fas.fa-solid.fa-calendar-days {
  font-size: 16px;
  margin-right: 8px;
}

i.fa-solid.fa-globe {
  margin-right: 8px;
}

.back-img-photo {
  background-image: url(https://images.unsplash.com/photo-1499336315816-097655dcfbda?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=crop&amp;w=2710&amp;q=80);
  background-size: cover;
  width: 100%;
  background-repeat: no-repeat;
}

section.back-image-logo12 {
  height: 100% !important;
}

main.profile-page-thoughts {
  margin-top: 33%;
}

main.profile-page-thought-de {
  margin-top: 27%;
  margin-bottom: 3%;
}

.bell-tottal-count {
  position: relative;
}

span.total-noti-count {
  position: absolute;
  top: -7px;
  left: 10px;
  background: #ee2d2df2;
  color: white;
  border-radius: 20px;
  height: 22px;
  padding: 0px 5px;
}

.close-btn-back-profile {
  float: right;
  margin-bottom: 16px;
}

.profilePic-admin-image {
  position: absolute;
  top: -68px !important;
  right: 13px;
}

label.upload-profileImg.absolute {
  right: 18px;
  bottom: 6px;
}

.notification-alert {
  position: absolute;
  width: 34%;
  padding: 0px;
  right: 0;
  top: 85px;
}

i.fas.fa-caret-up {
  font-size: 41px;
  position: absolute;
  bottom: -13px;
  left: 38%;
  color: #8080803d;
}

h1.see-all-noti-page {
  margin-top: 21px;
  border: 1px solid #8080804d;
  padding: 9px 9px;
  border-radius: 4px;
}

.fighting-imges-disussion {
  min-height: 100vh !important;
}

i.far.fa-comment-dots.text-black {
  font-size: 19px !important;
}

/* i.fa.fa-search {
  font-size: 17px;
} */

.travel-div {
  font-size: 36px;
  text-align: center;
  /* padding: 73px 0px; */
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-family: poppins !important;
}

.the-martial-nexus {
  text-align: center;
  margin-left: 17px;
  font-family: "Rajdhani", sans-serif;
}

.the-martial-nexus.uppercase h1 {
  line-height: 22px;
}

/* .text-div-nexus {
  width: 60%;
  padding-left: 12%;
} */

/* .search-bar-for-event {
  width: 40%;
} */

/* .typing-key-event {
  top: 24%;
} */

.text-div-nexus {
  /* width: 60%; */
  /* padding-left: 12%; */
  text-align: center;
}

.typing-key-event {
  top: 15% !important;
}

button.tags-button-events {
  background: #0743b1;
  color: white;
  font-weight: bold;
  margin: 0px 10px;
  width: 60px;
  padding: 5px;
  border-radius: 20px;
  margin-top: 8px;
}

.insta-user img {
  width: 6%;
  object-fit: cover;
}

.insta-user {
  width: 100%;
  display: flex;
  justify-content: center;
}

.border-replay-comment {
  border: 1px solid #80808070;
  border-right: 2px solid var(--newCommunityTheme-line);
  display: block;
  height: 100%;
  width: 50%;
}

.border-line-replay {
  position: absolute;
  height: calc(89% - 68%);

  margin-left: 12px;
}

.social-media-text {
  margin-left: 30px;
}

article.comment-article {
  margin-left: -44px;
}

.comment-text-pera {
  margin-left: 47px !important;
}

.comment-art-box {
  position: relative;
}

.border-replay-comment1 {
  border: 1px solid #80808070;
  border-right: 2px solid var(--newCommunityTheme-line);
  display: block;
  height: 100%;
  width: 100%;
}

.border-line-replay1 {
  position: absolute;
  height: calc(100% - 0%);
  margin-left: 12px;
  width: 0;
  top: 55px;
  left: -20px;
}

.border-line-replay2 {
  position: absolute;
  height: calc(90% - 0%);
  margin-left: 12px;
  width: 0;
  top: 55px;
  left: -20px;
}

.border-replay-comment2 {
  border: 1px solid #80808070;
  border-right: 2px solid var(--newCommunityTheme-line);
  display: block;
  height: 100%;
  width: 100%;
}

.deletion-dialog-delete
  .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation24 {
  max-width: 400px !important;
  width: 100%;
}

button.delte-btn-dialog {
  width: 100px;
  background: #f75151;
  color: white;
  font-weight: 400;
  padding: 5px 0px;
  border-radius: 5px;
}

button.cancel-btn-dialog {
  width: 100px;
  background: #3360f7;
  color: white;
  font-weight: 400;
  padding: 5px 0px;
  border-radius: 5px;
}

button.save_profilepic {
  width: 100px;
  background: #3360f7;
  color: white;
  font-weight: 400;
  padding: 7px 0px;
  border-radius: 5px;
}

button.save_profilepic-btn {
  width: 100px;
  color: #3360f7;
  font-weight: 400;
  padding: 5px 0px;
  border-radius: 5px;
  border: 2px solid #3360f7;
  margin-left: 12px;
  margin-right: 12px;
}

button.deletion-btn-open-popup {
  width: 120px;
  background: #f04040c4;
  color: white;
  font-weight: 400;
  padding: 7px 0px;
  border-radius: 5px;
}

.profile-submit-buttons {
  margin: 0px 26px;
}

.user-profile_discussion img {
  width: 150px !important;
  height: 150px !important;
  object-fit: cover !important;
}

.discussion-cards-home {
  width: 100% !important;
  height: 265px !important;
  min-height: 100% !important;
}

button.crop-contnet {
  right: -35px;
  top: -9px !important;
  color: #808080a6;
}

i.fa.fa-edit.text-lg.text-gray-800 {
  color: #808080cf;
}

.search-bar-usersearch {
  /* position: absolute !important;
  top: 12% !important; */
  width: 100% !important;
  left: 12%;
}

.search-userpopup {
  position: absolute;
  top: 26px;
  left: 35px;
}

.input-group-user-search.searchsec {
  width: 56%;
}

.search-bar-usersearch {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.searchsec1 .MuiAutocomplete-root.form-control.input-groups.font-normal {
  width: 400px;
}

button.my-post-section {
  background: #1e40afe3;
  margin: 6px 11px;
  padding: 6px 8px;
  width: 118px;
  border-radius: 6px;
  color: white;
}

.search-input-users {
  text-align: center;
}

input.newSearchActInputPp {
  width: 50% !important;
  border-radius: 5px;
  padding: 10px 9px;
  border: 1px solid #8080806b;
}

/* phone number flag css */

.react-tel-input .selected-flag .flag {
  position: absolute;
  top: 50% !important;
  margin-top: -12px !important;
}

.react-tel-input .form-control {
  font-size: 16px;
  background: #ffffff;
  border: 1px solid #cacaca8a;
  border-radius: 0px !important;
  width: 238px !important;
  outline: none;
  padding: 9px 50px !important;
  /* transition: box-shadow ease .25s,border-color ease .25s; */
  color: #495057;
}

.react-tel-input .form-control:focus {
  background-color: #fff;
  border-color: #1365bd !important;
  outline: none !important;
  box-shadow: none !important;
}

.react-tel-input .selected-flag:before {
  content: "";
  display: block;
  position: absolute;

  border-radius: 4px 2px 2px 4px;
  border: 1px solid transparent;
  transition: box-shadow ease 0.25s, border-color ease 0.25s;
  height: 0 !important;
}

/* phone number flag css */
.follower-total-count {
  cursor: pointer;
}

button.search-users-popup-btn {
  background: #1266e5db;
  color: white;
  width: 114px;
  padding: 5px 1px;
  font-weight: 300;
  font-family: poppins;
  border-radius: 4px;
}

.search-users-popup {
  float: right !important;
}

.common-tabs-posts {
  height: 100% !important;
}

.btn-box-delete-info {
  right: -42px !important;
  top: 31px !important;
}

.searchsec button:hover {
  background: #1e40af;
}

.no-posts-found {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 60px;
}

.terms-privacy-fight {
  font-family: poppins !important;
}

.common-text-font-fam {
  font-family: "Rajdhani", sans-serif;
}

.no-posts-found h1 {
  font-size: 27px;
  font-weight: 500;
}

/* canvas.mapboxgl-canvas {
  width: 1256px !important;
  height: 400px !important;
} */

.show-hide-password {
  position: absolute;
  bottom: 8px;
  right: 11px;
}

.filter-sort-by {
  /* width: 25%; */
  display: flex;
  justify-content: center;
  align-items: center;
}

.eventSearchbar
  fieldset.MuiOutlinedInput-notchedOutline.css-1d3z3hw-MuiOutlinedInput-notchedOutline {
  /* FONT-VARIANT: JIS04; */
  border-radius: 0 !important;
}

.eventSearchbar
  .css-1qqsdnr-MuiAutocomplete-root
  .MuiOutlinedInput-root
  .MuiAutocomplete-input {
  padding: 2.5px 1px 4.5px 7px;
}

button.search-enter-btn {
  padding: 13px !important;
  height: 40px !important;
}

.input-group.eventSearchbar {
  margin-top: 36px;
  margin-right: 12px;
}

.css-nwrfgk-MuiButtonBase-root-MuiTab-root.Mui-selected {
  background-color: rgb(36 101 199) !important;
  color: white !important;
  border-color: rgb(36 101 199);
  font-size: 17px;
  font-weight: bold;
  font-family: "Rajdhani", sans-serif !important;
}

button.all_jobs_poject_buttonnewdiv.active1 {
  /* background: rgb(36 101 199); */
  color: white;
  font-size: 15px;
  /* width: 101px; */
  padding: 8px 10px;
  font-weight: 500;
  font-family: "Poppins";
  /* margin-right: 12px; */
  border: 0px solid rgb(36 101 199);
}

button.all_jobs_poject_buttonnewdiv {
  color: rgb(30 64 175);
  font-size: 14px;
  padding: 8px 10px;
  font-weight: 700;
  font-family: "Poppins";
  /* margin-right: 12px; */
  border: 1px solid;
}

.aero-down-icon {
  margin-top: -13px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin-right: 15px; */
}

i.fas.fa-caret-down.aeroafflian {
  font-size: 32px;
  color: rgb(30 64 175);
}

.mactching-div {
  text-align: center;
  padding: 12px 12px;
  color: white;
  font-size: 17px;
  font-family: "Poppins";
  font-weight: 400;
  margin-bottom: 12px;
}

i.fa.fa-search.search-user-icon {
  position: absolute;
  top: -5px;
  right: 207px;
  color: #808080c2;
  z-index: 30;
}

.search-user-btn input {
  border: 1px solid gray;
  padding: 10px 31px;
  border-radius: 30px;
  position: absolute;
  right: 0px;
  top: -22px;
  width: 100%;
}

/* .user-search-div {
  position: absolute;
  width: 35%;
  right: 29%;
  top: 98px;
} */

.user-search-div {
  position: absolute;
  width: 30%;
  right: 35%;
  top: 95px;
}

i.fas.fa-sort-down {
  font-size: 20px;
  margin-left: 14px;
  height: 27px;
}

textarea.thougt-textarea {
  height: 200px !important;
}

p.poem-word {
  height: 166px !important;
}

.upcoming-evetns-near {
  display: flex;
  justify-content: center;
  align-items: center;
}

button.terms-privacy-fight:active {
  background: #1e40af !important;
}

.slider-image-div img {
  height: 620px;
  object-fit: cover;
  border-radius: 10px;
}

.transparent-image {
  position: absolute;
  bottom: 0;
  padding: 170px 0px;
  width: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
}

textarea.w-full.px-3.py-2.border.border-slate-400.placeholder-text-sm.rounded {
  height: 100px !important;
}

.search-bar-for-event {
  /* width: 40%; */
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px 357px;
}

.recent-searhces {
  display: flex;
  align-items: center;
  margin: 0px 3px;
  font-family: poppins !important;
}

.event-tabele-data {
  width: 100%;
  margin: 0 auto;
  padding: 0;
}

/* .event-tabele-data::-webkit-scrollbar {
  width: 1em;
}
 
.event-tabele-data::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
 
.event-tabele-data::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
} */

/* 21 March 2023 */

.css-1qqsdnr-MuiAutocomplete-root
  .MuiOutlinedInput-root
  .MuiAutocomplete-input {
  /* padding: 7.5px 4px 7.5px 6px; */
  border-radius: 64px 0px 0px 64px !important;
}

/* .dataTables_length.bs-select {
  margin: -17px !important;
} */

button.search-enter-btn:hover {
  background-color: #1e40af !important;
}

a.mapboxgl-ctrl-logo {
  display: none !important;
}

.mapboxgl-ctrl-attrib-inner {
  display: none !important;
}

button.mapboxgl-popup-close-button {
  padding: 2px 10px !important;
}

/* 21 March 2023 */

/* .eventSearchbar input#tags-outlined {
  height: 12px !important;
} */

.DAMSidebar li span {
  display: none;
  transition: 1s;
}

.DAMSidebar {
  width: 80px;
  transition: 1s;
}

.DAMSidebar .whitespace-nowrap {
  display: none;
  transition: 1s;
}

.sidebarmenu2 {
  transition: 0.5s;
}

.logo_sec {
  width: 35%;
}

.search-user-btn {
  width: 30%;
}

.userid12 {
  width: 35%;
  display: flex;
  justify-content: end;
}

.wordbreadkdiv {
  word-wrap: break-word !important;
}

.eidt-profile {
  position: absolute;
  right: 51px;
  top: -9px;
  color: #007eff;
  cursor: pointer;
}

.event-tags-div
  .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-fullWidth.MuiInputBase-formControl.MuiInputBase-adornedEnd.MuiAutocomplete-inputRoot.css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root {
  padding: 0 !important;
  margin: 0 !important;
  height: 53px;
}

img.fight-finder-ligo {
  width: 100%;
  max-width: 200px;
}

div#search-event-boxx {
  max-height: 400px;
  overflow-y: scroll;
}

i.fa.fa-ellipsis-v {
  cursor: pointer;
}

.scroll-top-btn {
  position: fixed;
  bottom: 80px;
  right: 20px;
  background: no-repeat !important;
  border: none;
  outline: none;
  cursor: pointer;
}

i.fas.fa-arrow-up.aero-scroll {
  font-size: 30px;
  background: white;
  padding: 5px 7px;
  border-radius: 24px;
  color: black;
}

.fighter-images-events1.neweventsadd {
  height: 280px !important;
  border-radius: 11px !important;
}

.eventsbak.bgblack-trasn {
  border-radius: 8px !important;
}

.flex.flex-col.p-6.mx-auto.max-w-lg.text-gray-900.bg-white.rounded-lg.border.border-gray-100.shadow.w-full.my-ideas {
  height: 280px !important;
  border-radius: 11px;
}

.text-div-nexus {
  margin-top: 25px !important;
}

.grid.grid-cols-2.gap-4.skillstag {
  align-items: center !important;
}

p.common-text-font-fam.text-black-800.font-medium.text-lg {
  font-size: 13px !important;
  color: #000000c2 !important;
  text-align: center !important;
}

button.scroll-top-btn {
  z-index: 999 !important;
}

.Home-events-img11.Publiceventde.resize-image {
  height: 200px !important;
}

i.fa.fa-home {
  font-size: 22px;
}

i.fa.fa-home.text-lg.mr-2.text-gray-600 {
  font-size: 18px !important;
}

h4.common-text-font-fam.text-white.sm\\:text-3xl.md\\:text-5xl.font-bold {
  font-size: 90px !important;
}

.w-full.p-3.mt-2.bg-white.rounded.shadow.flex.flex-shrink-0 {
  display: flex;
  align-items: center;
}

img.rounded-full.max-w-none.w-12.h-12.mr-4 {
  margin: 0px 0px !important;
}

.grid.grid-cols-1.gap-2.box-border.mx-4 {
  margin-bottom: 50px;
}

.eveantag1212 .MuiOutlinedInput-root .MuiAutocomplete-input {
  border-radius: 4px !important;
  margin-right: 4px;
}

.eveantag1212 .MuiOutlinedInput-root {
  height: 48px !important;
  width: 100% !important;
}

textarea.block.p-2\\.5.w-full.text-sm.text-gray-900.bg-gray-50.rounded-lg.border.border-gray-300.focus\\:ring-blue-500.focus\\:border-blue-500.bg-white.dark\\:border-gray-600.dark\\:placeholder-gray-400.dark\\:text-black.dark\\:focus\\:ring-blue-500.dark\\:focus\\:border-blue-500 {
  height: 150px !important;
}

button.affilian-post-btn {
  color: white;
  padding: 7px 37px;
  border-radius: 5px;
  width: 167px;
}

.mapboxgl-popup-content {
  position: relative;
  background: #fff;
  border-radius: 3px;
  box-shadow: 0 1px 2px rgb(0 0 0/10%);
  padding: 10px 10px 15px;
  pointer-events: auto;
  width: 100px !important;
  text-align: center !important;
  font-family: "Poppins";
}

.save_profilepic-btn.close-prfile11 {
  position: relative;
}

button.save_profilepic-btn.close-prfile {
  position: absolute;
  top: -38px;
  left: 133px;
}

.swal-modal.errorAlert {
  height: 230px;
}

.successLogout {
  width: 107px;
  border: none;
  background: #7867c1;
  color: #fff;
  padding: 10px 0;
  border-radius: 8px;
  margin: 13px;
  font-size: 16px;
  cursor: pointer;
  font-family: "poppins";
}

.successfullyButton {
  background: #1f92b5;
  font-weight: 300;
  font-family: "Poppins";
  display: inline-block;
  text-decoration: none;
}

img.logo-dashboard {
  width: 139px;
}

a.successfullyButton {
  padding: 10px;
  color: #1e22aa;
  text-transform: capitalize;

  display: inline-block;
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 8px;
  margin: 20px auto 0;

  color: white;
}

img.dashboardImg {
  width: 300px;
}

.dashboardDiv {
  display: flex;
  justify-content: center;
  margin: 20px;
}

.update {
  width: 13%;
}

.dash {
  margin: 10px;
}

.filesDiv {
  display: flex;
  justify-content: space-between;
  height: 34px;
}

button.del {
  height: 23px;
  margin: 14px;
  color: #42c1f4;
  border-radius: 13px;
  border: 0px;
}

#file-input-area {
  display: none;
}

.button {
  background-color: #007bff;
  border: none;
  color: white;
  padding: 10px 40px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
  border-radius: 10px;
  font-family: "poppins";
}

text.recharts-text.recharts-cartesian-axis-tick-value {
  font-size: 13px;
}

.chatmapdiv {
  padding: 20px 20px 10px 0px;
}

p.fileName {
  display: flex;
  justify-content: center;
  background: white;
  border-radius: 4px;
  padding: 6px;
}

#membershipHeading {
  padding: 10px 0;
  font-size: 20px;
  font-weight: 600;
  font-family: "poppins";
}
h3.price {
  padding-bottom: 13px;
  font-weight: 500;
  color: #7867c1;
  font-size: 18px;
}
p.errorMsg {
  margin: 0 !important;
  font-size: 13px;
  color: #e31e00;
  font-family: poppins;
}

.divGraph {
  background-color: white;
  border-radius: 10px;
}

.chartDiv {
  background: white;
  padding: 30px 32px 24px 0px;
  border-radius: 10px;
  position: relative;
}

button.del.btnSS {
  float: right;
  background: #42c1f4;
  color: white;
}

/* select.method-select {
  border: none;
  padding: 4px;
  margin: 11px;
  border-radius: 12px;
  color: #42c1f4;
  outline: none !important;
} */

p.count {
  color: #42c1f4;
  display: flex;
  align-items: center;
}

img.error-page {
  width: 60%;
  display: flex;
  justify-content: center;
  margin: auto;
  margin-top: 32px;
}

a.hover-primary.subs {
  margin-right: 10px;
}

p#notfound {
  font-size: 34px;
  font-family: "Poppins";
  text-align: center;
  margin-top: 115px;
}

select.custom-select.custom-select-sm.form-control.form-control-sm {
  width: 168px;
  margin-bottom: 22px !important;
}

.userlistdiv {
  width: 60%;
  margin: auto;
  background: white;
  padding: 26px;
  border-radius: 10px;
}

table.table.table-bordered.table-sm.table-striped.dataTable {
  margin: auto;
  width: 100%;
}

/* .thanktexthome.userlist {
  width: 60%;
  margin: auto;
} */

.thanktexthome.userlist {
  margin: auto;
  padding: 0px 130px;
}

/* ul.pagination {
  width: 60%;
  margin: auto;
  margin-top: 20px;
} */

li.page-item {
  display: inline-block;
  margin-left: 17px;
  cursor: pointer;
}

button.del.add {
  width: 30px;
}

rect.recharts-brush-slide {
  fill-opacity: 1;
}

.dataresult {
  display: flex;
}

.datashow {
  width: 30%;
  position: relative;
}

.result {
  width: 70%;
}

/* data result */
.dataresult {
  margin: 12px;
}

.datashow {
  width: 21%;
  background: white;
  padding: 35px;
  border-radius: 5px 0px 0px 5px;
  box-shadow: 2px 1px 11px 3px;
}
/* h2.dataheading {
  display: flex;
  justify-content: center;
  color: #16414a;
  font-size: 39px;
} */

h2.dataheading {
  display: flex;
  justify-content: center;
  color: gray;
  font-size: 40px;
  font-weight: 700;
}

button.btnchange {
  border: none;
  color: gray;
  font-size: 25px;
  font-weight: 400;
  font-family: "Poppins";
}

/* p.dataText {
  font-size: 13px;
  margin: 2px;
  color: #8d9191;
} */
p.dataText {
  font-size: 14px;
  margin: 2px;
  color: #8d9191;
  font-family: "Poppins";
}
.Data-plotting {
  display: flex;
  background: white;
  margin-left: 10px;
  padding: 12px;
  border-radius: 0px 5px 5px 0px;
  box-shadow: 2px 1px 11px 3px;
}
.graphplot {
  width: 90%;
}
.graphdetail {
  width: 31%;
  /* display: flex;
  justify-content: center;
  align-items: self-end; */
}
.graphdetail > div {
  height: 40px;
  padding-left: 13px;
  margin-top: 270px;
  display: flex;
  justify-content: center;
}
.confidenceContainer {
  display: flex;
}
.clustergraph {
  height: 380px;
}
.confidence {
  width: 50%;
  background: white;
  margin-left: 10px;
  margin-top: 10px;
  box-shadow: 2px 1px 11px 3px;
  height: 460px;
}
.clusterPlot {
  background: white;
  margin-top: 10px;
  margin-left: 10px;
  width: 50%;
  border-radius: 0px 5px 5px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 2px 1px 11px 3px;
}

h2.corelate {
  margin-bottom: 95px;
}
.addpagelink {
  position: absolute;
  bottom: 13px;
  left: 20px;
}
.addpagelink a {
  list-style: none;
  color: grey;
  text-decoration: none;
}
label.fileupload {
  border-radius: 5px;

  font-size: 14px;
  border: 1.2px solid #7867c1;
  padding: 1px 6px;
  color: white;
  background: #7867c1;
  margin: 2px;
}
.dropzone-content {
  display: flex;
  flex-direction: row;
}

.dataText {
  font-size: 12px;
  margin-left: 8px;
  color: gray;
}
select.method-select {
  border: 1px solid gray;
  padding: 0 13px;
  width: 150px;
  border-radius: 3px;
  color: gray;
  background: white;
  outline: none !important;
}
p.dataToggle {
  color: gray;
  font-size: 13px;
}
/* toggle button */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 22px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 17px;
  width: 17px;
  left: 4px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.clusterPlot {
  padding: 6px;
  /* padding-top: 20px; */
}
.toggledec {
  display: flex;
  align-items: center;
}
input.confiInput {
  width: 50px;
  padding: 5px;
  border: none;
  border-radius: 3px;
  text-align: center;
  margin: 0px;
  color: #42c1f4;
}
button.del {
  height: 23px;
  margin: 0px;
  color: white;
  border-radius: 5px;
  border: 1px solid gray;
  background: #7867c1;
}

button.submitbtn {
  background: #7867c1;
  border-radius: 5px;
  border: 2px solid #9788d8;
  color: white;
  padding: 5px 16px;
  font-size: 23px;
  font-family: "poppins";
}

.leftsideimport {
  display: flex;
}

.addfiledata {
  padding-left: 100px;
}

.headerstyle a {
  list-style: none;
  color: grey;
  text-decoration: none;
  font-size: 25px;
}
.headerstyle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 8px 17px -10px;
}
.containeraddfile {
  width: 82%;
  box-shadow: 0px 1px 11px 1px;
  margin: auto;
  /* padding: 0px; */
}

.leftsideimport {
  background: white;
}
.containeraddfile {
  background: white;
}

h2.dataheading {
  margin: 0px;
  /* margin-bottom: 30px; */
}

.dashboardpage {
  background: #42c1f440;
}

.homepage {
  background: #42c1f4;
  padding: 40px 0;
  height: 100vh;
}

.action-btnss {
  display: flex;
  align-items: center;
  justify-content: center;
}

i.fa.fa-solid.fa-check {
  color: #10c910;
  font-size: 22px;
}

i.fa.fa-solid.fa-times {
  color: red;
  font-size: 22px;
}

.dataTables_length.bs-select {
  width: 102px !important;
}

.setting-action-btn {
  display: flex;
  justify-content: center;
}
.table-responsive tr {
  padding: 10px 0 !important;
  width: 100%;
  font-family: poppins !important;
  height: 53px;
}
/* .setting-action-btn {
  height: 53px;
} */

i.fa.fa-gear {
  font-size: 21px;
  /* pointer-events: initial; */
  cursor: pointer;
}

ul.pagination {
  /* width: 60%; */
  margin: auto;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.active > .page-link,
.page-link.active {
  background-color: #948ed1;
  border-color: var(--bs-pagination-active-border-color);
  padding: 5px 18px;
  color: white;
  font-size: 18px;
  border-radius: 11px;
}

.main-upload-data {
  display: flex;
  gap: 13px;
  align-items: center;
  height: 100px;
}

h2.number-lenght.text-red-800 {
  background: #7867c1;
  /* width: 40px; */
  padding: 9px 22px;
  border-radius: 27px;
  color: white;
  font-family: "Poppins";
}

.oneinputtitle {
  margin-top: 39px;
}

.straoght-border {
  border: 3px solid;
  width: 59px;
  transform: (14deg 7deg);
  transform: rotate(90deg);
  margin-left: -4px;
  color: #7867c1b5;
}
.dropzone-part {
  padding-top: 16px;
  padding-bottom: 8;
}

select.method-select {
  border: 1px solid gray;
  margin-top: 12px;

  width: 100%;
  border-radius: 3px;
  color: gray;
  background: white;
  font-family: "Poppins";
  outline: none !important;
}

/**
 * The switch widget!
 * Usage:
 *   <input type="checkbox" switch[="type"] id="toggleSwitch" />
 *   <label for="toggleSwitch" data-on-label="On" data-off-label="Off"></label>
 */

/*
  * Copyright (c) 2013 Thibaut Courouble
  * http://www.cssflow.com
  *
  * Licensed under the MIT License:
  * https://www.opensource.org/licenses/mit-license.php
  */

.switch {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 56px;
  height: 20px;

  background-color: white;
  border-radius: 18px;
  box-shadow: inset 0 -1px white, inset 0 1px 1px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  background-image: linear-gradient(to bottom, #eeeeee, white 25px);
}

.switch-input {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}

.switch-label {
  position: relative;
  border: 2px solid gray;
  display: block;
  height: inherit;
  font-size: 10px;
  text-transform: uppercase;
  background: #808080e1;
  border-radius: inherit;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.12),
    inset 0 0 2px rgba(0, 0, 0, 0.15);
  transition: 0.15s ease-out;
  transition-property: opacity background;
}
.switch-label:before,
.switch-label:after {
  position: absolute;
  top: 50%;
  margin-top: -0.5em;
  line-height: 1;
  transition: inherit;
}
.switch-label:before {
  content: attr(data-off);
  right: 11px;
  color: #aaa;
  text-shadow: 0 1px rgba(255, 255, 255, 0.5);
}
.switch-label:after {
  content: attr(data-on);
  left: 11px;
  color: white;
  text-shadow: 0 1px rgba(0, 0, 0, 0.2);
  opacity: 0;
}
.switch-input:checked ~ .switch-label {
  background: #7867c1;
  /* box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15), inset 0 0 3px rgba(0, 0, 0, 0.2); */
}
.switch-input:checked ~ .switch-label:before {
  opacity: 0;
}
.switch-input:checked ~ .switch-label:after {
  opacity: 1;
}

.switch-handle {
  position: absolute;
  border: 2px solid gray;
  top: 4px;
  left: 6px;
  width: 0;
  height: 13px;
  background: white;
  border-radius: 10px;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);
  background-image: linear-gradient(to bottom, white 40%, #f0f0f0);
  transition: left 0.15s ease-out;
}
.switch-handle:before {
  border: 2px solid gray;
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -6px 0 0 -2px;

  width: 12px;
  height: 12px;
  background: #f9f9f9;
  border-radius: 6px;
  box-shadow: inset 0 1px rgba(0, 0, 0, 0.02);
  background-image: linear-gradient(to bottom, #eeeeee, white);
}
.switch-input:checked ~ .switch-handle {
  left: 40px;
  box-shadow: -1px 1px 5px rgba(0, 0, 0, 0.2);
}

.switch-green > .switch-input:checked ~ .switch-label {
  background: #4fb845;
}

label.select-toggle-btn {
  margin-right: 50px;
  color: gray;
  font-family: "Poppins";
}

.plus-minus-input {
  display: flex;
  /* align-items: center; */
}

span.count-persanttage {
  border-top: 1px solid gray;
  border-bottom: 1px solid gray;
  padding: 2px 14px;
  background: white;
}

button.decrement-button {
  color: white;
  font-size: 26px;
  border-radius: 3px;
  border: none;
  width: 30px;
  height: 30px;
  background: #7867c1;
  display: flex;
  align-items: center;
  justify-content: center;
}

button.increment-button {
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 26px;
  border-radius: 3px;
  border: none;
  width: 30px !important;
  height: 30px;
  background: #7867c1;
}

button.submitbtn {
  background: #7867c1;
  border-radius: 15px;
  border: 2px solid #aa9ede;
  color: white;
  padding: 5px 12px;
  font-size: 33px;
  font-family: "poppins";
  font-weight: 700;
  font-family: "Poppins";
}

.main-graph-image {
  background: white;
  height: 100vh;
}

.heading h1 {
  text-align: center;
  color: rgb(128 128 128 / 75%);
  font-family: "Poppins";
  margin-top: 0;
  font-size: 38px;
  font-weight: 500;
  padding: 24px 0 0;
  font-weight: bold;
}

.main-graph-image {
  height: 100vh !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  padding: 0px 66px;
}
button {
  border: none;
  color: gray;
  font-size: 16px;
}
/* button.btnchange {
  border: none;
  color: gray;
  font-size: 16px;
} */
p.dataTitle {
  color: #7867c1;
  font-size: 30px;
  margin: 10px 0px 10px 0px;
  font-family: "Poppins";
}
.layout-dashboard-main {
  background: white;
  height: 100vh;
}
.icondown {
  width: 31px;
  height: 31px;
  margin-left: 5px;
  cursor: "pointer";
  float: right;
  /* display: flex; */
  /* align-items: center; */
  /* justify-content: center; */
  /* text-align: center; */
  margin: 0 20px;
  position: relative;
  z-index: 999;
}
.clusterGraph {
  width: 100%;
}
.main_navbar_header {
  padding: 8px 28px;
  box-shadow: 0px -4px 11px 4px;
}
/* .loginsigin {
  position: absolute;
  width: 200px;
  background: #fff;
  padding: 10px;
  right: 0;
  top: 55px;
  border-top: 4px solid #FC2D60;
  z-index: 9999;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
} */

.loginsigin a {
  width: 100%;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #a0a0a0;
}
.loginsigin li {
  width: 100%;
  margin: 3px;
}
.loginsigin li:hover {
  width: 100%;
  background: unset;
  box-shadow: unset;
  margin: 0;
}
li.user-header-div.Activediv {
  list-style: none;
}

img.mr-2.profileIcons {
  margin-right: 6px;
}
img.mr-2.logout {
  margin-right: 8px;
}
li.user-header-div {
  list-style: none;
}
.profileIcons {
  width: 20px;
  margin-right: 5px;
}
img.logout {
  margin-right: 9px;
}
.loginsigin {
  position: absolute;
  width: 200px;
  background: #fff;
  padding: 13px;
  right: 28px;
  top: 46px;
  border-top: 4px solid #7867c1;
  z-index: 9999;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
  list-style: none;
  text-align: justify;
  padding-left: 20px;
}
a.hover-primary {
  color: #7867c1;
  font-size: 14px;
  text-decoration: none;
  font-weight: 600;
  /* margin-top: 7px; */
  display: inline-block;
  text-transform: capitalize;
  font-family: "Poppins";
}
img.imgPro {
  margin-top: 11px;
  width: 26px;
}
.main-geoThara-div {
  margin: 70px 0;
}
.elementor-widget-container {
  color: #4ac0ef;
  font-family: "Rubik", Sans-serif;
  font-size: 45px;
  font-weight: 600;
  line-height: 50px;
}
.changing-content {
  color: #7867c1;
  font-family: "Rubik", Sans-serif;
  font-size: 45px;
  font-weight: 600;
  line-height: 50px;
}
.test-1 {
  font-family: "Poppins", Sans-serif;
  font-size: 18px;
  font-weight: 400;
}
.slider-image-div img {
  width: 100%;
  /* height: auto; */
}
.trenddetection {
  display: flex;
  align-items: center;
  justify-content: center;
}
.react-slideshow-container .default-nav {
  background: none !important;
}
.react-slideshow-container svg {
  fill: #fff !important;
}
.topdiv {
  height: 520px;
  overflow: hidden;
  position: relative;
}

.newlogomenu {
  display: flex;
}
.newlogo {
  width: 150px;
}
.container {
  margin: 0 auto;
}
.logomenu {
  width: 100%;
  display: flex;
  padding: 0 40px;
  align-items: end;
  justify-content: center;
}
.newlogomenu {
  display: flex;
  max-width: 1130px;
  margin: 0 auto;
}
.logomenu li {
  list-style: none;
  padding: 0 18px;
}
.logonavbar {
  position: absolute;
  top: 0;
  width: 100%;
  padding: 20px 10px;
  z-index: 999;
  border-top: 1px solid #fff;
  margin-top: 44px;
}
.logomenu a {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #fff;
}
p.emailtext {
  /* position: absolute; */
  /* right: 0; */
  /* margin: 0 auto; */
  color: #fff;
  /* padding: 10px 0 30px; */
  /* display: inline-block; */
  /* width: 100%; */
}
.container-text {
  text-align: right;
  width: 90%;
  /* margin: 0 auto; */
  float: left;
  padding: 9px 0;
  position: absolute;
  z-index: 999;
}
.tobtext {
  position: absolute;
  top: 50%;
  width: 100%;
}
.tobtext h1 {
  color: #ffffff;
  font-family: "DM Sans", Sans-serif;
  font-size: 47px;
  font-weight: 700;
  line-height: 100px;
  padding: 0 66px;
}
.Services {
  object-fit: cover;
  background-repeat: no-repeat;
  padding: 50px 0 80px;
}
.allServices {
  display: flex;
}
.Services1 {
  width: 30.5%;
  background: #fff;
  text-align: center;
  padding: 80px 30px;
  border-radius: 15px;
}
.Services-icon {
  width: 4%;
  display: flex;
  align-items: center;
  justify-content: center;
}
img.Services-icon-img {
  width: 130px;
  margin: 0 auto;
  padding: 20px;
}
h2.nuber {
  color: #6ec1e4;
  font-size: 35px;
  font-weight: 700;
}
h3.datatext {
  font-family: "Rubik", Sans-serif;
  font-size: 25px;
  font-weight: 700;
  font-style: italic;
  letter-spacing: 0px;
  color: #7867c1;
  margin: 7px 0 10px;
}
p.Services-test {
  font-family: "Rubik", Sans-serif;
  font-size: 15px;
  font-weight: 700;
  font-style: italic;
  color: #7867c1;
}
h1.Servicestitle {
  color: #ffffff;
  font-family: "Rubik", Sans-serif;
  font-size: 45px;
  font-weight: 600;
  margin-bottom: 50px;
}
.Services-top {
  padding: 0 65px;
}
.result {
  width: 78%;
}
.datashow {
  width: 30%;
  position: relative;
  background: white;
  padding: 35px;
  border-radius: 5px 0px 0px 5px;
  box-shadow: 2px 1px 11px 3px;
}
.Contactsecdiv {
  display: flex;
  width: 100%;
  margin: 85px 0;
}
.Contactsecdiv-text {
  width: 50%;
  display: flex;
  align-items: center;
}
.Contactsecdiv-img {
  width: 50%;
}
.Contactsecdiv-img img {
  width: 100%;
}
h1.Contacttitle {
  color: #4ac0ef;
  font-family: "Rubik", Sans-serif;
  font-size: 45px;
  font-weight: 600;
  line-height: 50px;
}
h2.contactlink {
  font-size: 24px;
  color: #7867c1;
  margin: 6px 0 0;
}
.Contactsecdiv-img img {
  border-radius: 10px;
}
.bottomsec {
  background: #01102d;
  padding: 60px 0;
}
.footer-text {
  width: 33.33%;
}
.footer-logo {
  width: 33%;
  display: flex;
  align-items: center;
}
.footer {
  display: flex;
}
.footer-logo img {
  width: 220px;
}
.footer-text p {
  text-align: left;
  color: #ffffff;
  font-family: "Poppins", Sans-serif;
  font-size: 16px;
  font-weight: 500;
  padding-bottom: 20px;
}
.scrolled .logonavbar {
  position: fixed;
  background: #000;
  top: -50px;
}
h2.createplay-title {
  font-size: 26px;
  color: #7867c1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation24 {
  max-width: 350px !important;
  width: 100%;
  padding: 0px 10px;
}
button.MuiButtonBase-root.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.canceButtonnewPop.css-1e6y48t-MuiButtonBase-root-MuiButton-root {
  color: #42c1f4;
  padding-bottom: 8px;
  font-size: 16px;
}
.MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
  width: 73px;
  color: #7867c1;
  border: 1px solid #7867c1;
}
h2.add-title {
  color: #7867c1;
  font-size: 27px;
  display: flex;
  justify-content: center;
  padding-bottom: 27px;
}
.allpage {
  background: white;
  border-radius: 5px;
  padding: 15px;
}
.dataTables_length.bs-select {
  color: #7867c1;
}

i.fas.fa-2x.fa-sharp.fa-regular.fa-circle-down {
  color: #7867c1;
}

.clustergraph svg.recharts-surface {
  margin-top: 41px;
  height: 380px !important;
}

/* .clusterGraph.third svg.recharts-surface {
  margin-top: -78px !important;
} */

/* .graphplot.firstgraph {
  width: 300% !important;
} */

button.i-contnet-btn {
  background: #7867c1;
  color: white;
  padding: 1px 16px;
  border-radius: 12px;
}
.Data-plotting .graphplot {
  width: 300%;
}
.icondown11 {
  display: flex;
  height: 98%;
  align-items: end;
}
.icondown474 {
  margin: -5px 11px 0;
}
/* neww csss */

.select-steps-contnet {
  font-size: 29px;
  font-weight: 300;

  color: rgba(128, 128, 128, 0.86);
  font-family: "Poppins", sans-serif;
}

.border-steps {
  color: #9082cc;
  border: 3px solid;
}

.rounded-border-contnet {
  background: #7867c1 !important;
  width: 50px;
  height: 50px;
  border: 1px solid #7867c1;
  color: white;
  font-size: 22px;
  font-family: "Poppins";
}

.upload-data-inputdata {
  margin-top: 30px !important;
}

.spaceonright {
  display: flex;
  justify-content: center;
  align-items: end;
  position: absolute !important;
  left: 43%;
  top: 95%;
}
button.togglebtn {
  display: none;
}
.logo-m {
  display: none;
}
.mobl {
  display: none;
}

.foldermainDisplayDivsec {
  width: 100% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

a.Auth-button.back-btn {
  margin: 0 auto;
}

.show-hide-password {
  display: none !important;
}

.newgraph-div {
  display: flex;
  background: #80808036;
  padding: 44px 0px 0px 0px;
  box-shadow: 0px 3px 8px -3px;
}

button.all_graph_buttonnewdiv {
  width: 140px;
  background: #8080806b;
  color: black;
  font-family: poppins;
  font-size: 21px;
  text-align: center;
  padding: 5px 8px;
  border-radius: 10px 10px 0px 0px;
  font-weight: 400;
}

/* button.all_graph_buttonnewdiv {
  width: 140px;
  background: #80808094;
  color: black;
  font-family: poppins;
  font-size: 21px;
  text-align: center;
  padding: 5px 8px;
  border-radius: 10px 10px 0px 0px;
  font-weight: 400;
} */

.graph-newdesign11 {
  display: flex;
  margin-left: 30px;
}

@media (min-width: 320px) and (max-width: 420px) {
  .slider-image-div img {
    height: 400px !important;
    object-fit: cover !important;
    padding: 0px 10px;
  }
  .slider-image-div {
    height: auto;
    padding: 0 0px !important;
  }
}

@media (min-width: 320px) and (max-width: 767px) {
  p.dataTitle {
    font-size: 16px !important;
  }

  .form-outline.mb-2 {
    height: 80px !important;
  }

  p.Subscription {
    font-size: 18px !important;
  }

  .homepagepay {
    background: #42c1f4 !important;
    padding-bottom: 12px !important;
  }

  .auth-divide-section {
    display: block !important;
  }

  .Registerpage {
    margin: 0px 20px !important;
  }

  .forgotpage {
    margin: 0px 20px !important;
  }
  .spaceonright {
    left: 40% !important;
    top: 90% !important;
  }

  select.custom-select.custom-select-sm.form-control.form-control-sm {
    width: 80% !important;
  }

  .tobtext {
    top: 30% !important;
  }

  table {
    border-collapse: collapse !important;
    width: 100% !important;
  }
  .dataTable td {
    font-size: 11px !important;
  }

  /* .table-responsive {
  margin: 130px 0 0;
  font-family: "Figtree", sans-serif;
} */

  input.form-control.form-control-sm.ml-0.my-1 {
    max-width: auto !important;
    height: 45px !important;
    float: none !important;
  }

  .dataTable th {
    font-size: 12px !important;
    padding: 10px 10px !important;
  }

  .thanktexthome.userlist {
    padding: 0px 10px !important;
  }

  img.logo-dashboard {
    width: 110px !important;
  }

  .rounded-border-contnet {
    width: 40px !important;
    height: 40px !important;
  }

  img.imgPro {
    width: 16px !important;
  }

  p.count {
    font-size: 13px !important;
  }

  .heading h1 {
    font-size: 23px !important;
    margin-bottom: 12px !important;
  }

  .elementor-widget-container {
    font-size: 22px !important;
  }
  .spaceonright {
    margin-top: 90px !important;
    /* padding-bottom: 12px !important; */
    /* display: flex;
    align-items: center;
    justify-content: center !important;
    text-align: center; */
  }
  .logo-m img {
    max-width: 120px !important;
    margin: 0 auto !important;
  }
  .container-text {
    width: 100% !important;
  }
  .mobl {
    display: block !important;
  }
  .topdiv {
    overflow: unset !important;
  }
  .logo-m {
    display: block !important;
  }
  .togglediv {
    display: flex;
    padding: 0 20px;
  }

  .logo-m {
    width: 100%;
  }
  button.togglebtn {
    display: block !important;
  }
  .logomenu {
    width: 100% !important;
    display: block !important;
    padding: 0 !important;
  }
  .logomenu li {
    padding: 10px 0 !important;
    border-bottom: 1px solid #dddd !important;
  }
  .scrolled .logonavbar {
    position: absolute !important;
  }
  .newlogo {
    width: 150px;
    display: none;
  }
  .mobl .newlogomenu {
    position: absolute;
    background: #000;
    width: 230px;
    z-index: 9999;
    top: 30px;
    left: 20px;
    padding: 0 10px;
  }
  .logonavbar {
    width: 200px !important;
    padding: 20px 10px;
    z-index: 999;
    border-top: unset !important;
    margin-top: 34px !important;
    background: #000;
    display: none;
  }
  p.emailtext {
    display: none;
  }
  .oneinputtitle {
    margin-top: 0 !important;
  }

  .Data-plotting {
    display: block !important;
  }
  .Data-plotting .graphplot {
    width: 100% !important;
  }
  .graphdetail {
    width: 100% !important;
  }
  .graphdetail > div {
    margin-top: 0 !important;
    display: unset !important;
  }
  .icondown {
    margin-left: 5px !important;
    margin-top: 10px !important;
    float: unset !important;
    display: unset !important;
  }
  .select-steps-contnet {
    font-size: 16px !important;
  }
  .clusterPlot141 {
    display: block !important;
  }
  button.i-contnet-btn {
    border-radius: 100% !important;
    width: 30px !important;
    height: 30px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin-left: 5px !important;
  }

  .confidenceContainer {
    display: block !important;
    margin-left: -9px !important;
  }

  .confidence {
    width: 97% !important;
    margin-left: 0 auto !important;
  }

  .clusterPlot.clusterPlot141 {
    width: 97% !important;
    margin-left: 10px !important;
  }

  .clustergraph svg.recharts-surface {
    margin-top: 16px !important;
    height: auto !important;
  }

  .oneinputtitle.select-method {
    margin-top: 13px !important;
  }

  .dataresult {
    display: block !important;
    margin-bottom: 12px !important;
  }

  .datashow {
    width: 100% !important;
    margin-bottom: 18px !important;
  }

  .result {
    width: 100% !important;
  }

  .Data-plotting {
    margin-left: 0 !important;
  }

  /* .Data-plotting .graphplot {
  width: auto !important;
} */

  /* .recharts-wrapper {
    width: 270px !important;
  } */

  p.dataTitle.preprosesing-cont {
    margin-top: 40px !important;
  }

  p.dataTitle.confidence-cont {
    margin-top: 46px !important;
  }

  label.select-toggle-btn {
    font-size: 12px !important;
  }

  h2.number-lenght.text-red-800 {
    margin-bottom: 21px !important;
  }

  .straoght-border {

    margin-top: -11px !important;
    width: 65px !important;

    margin-left: -10px !important;
  }

  h2.number-lenght.text-red-800 {
    display: flex !important;
    justify-content: center !important;
    width: 40px !important;
  }
  .Services1 {
    width: 100% !important;
  }
  .allServices {
    display: block !important;
  }
  .Services {
    background-size: cover !important;
  }
  .Services-top .grid {
    display: unset !important;
  }
  .Services-top {
    padding: 0 30px !important;
  }

  .changing-content {
    font-size: 22px !important;

    line-height: inherit !important;
  }
  .test-1 {
    font-size: 13px !important;
  }
  h1.Servicestitle {
    font-size: 24px !important;
    text-align: center !important;
  }
  h1.Contacttitle {
    font-size: 24px !important;
    text-align: center !important;
  }
  .Contactsecdiv-text {
    width: 100% !important;
    display: unset !important;
  }
  h2.contactlink {
    font-size: 18px !important;

    margin: 0px 0 30px !important;
    text-align: center !important;
  }
  .Services-icon {
    margin: 5px auto 2px !important;
    transform: rotate(90deg) !important;
  }
  .footer {
    display: block !important;
  }
  .topdiv {
    height: auto !important;
  }
  .Contactsecdiv {
    display: block !important;
    margin: 30px 0 !important;
  }
  .Contactsecdiv-img {
    width: 100% !important;
  }
  .tobtext h1 {
    font-size: 18px !important;
    padding: 0 20px !important;
    text-align: center !important;
  }
}

@media (min-width: 767px) and (max-width: 1170px) {
}

.loginRight .loginsigin li {
  list-style: none;
}
.topdiv {
  height: auto !important;
}
/* .elementor-widget-container {

  font-size: 32px !important;
  
} */
/* .changing-content {
  font-size: 32px !important;
} */
.Services-top {
  padding: 0 15px !important;
}
.Services1 {
  padding: 10px 10px !important;
}
.tobtext h1 {
  font-size: 30px;
  padding: 0 20px !important;
}
.bgCo {
  background: #42c1f4 !important;
}

.loginRight {
  position: absolute;
  background: #fff;
  width: 150px;
  box-shadow: 0px 13px 18px #eee;
  padding: 20px;
  right: 0;
  top: 98px;
  border-top: 4px solid #1acb1a;
  border-radius: 4px 3px 0px 0px;
}

.drop_down_open {
  cursor: pointer;
}

.home_active .Header-main-div {
  position: absolute;
  top: 0;
  z-index: 9999;
  left: 0;
  right: 0;
  background: transparent !important;
}

.home_active {
  position: relative;
}

.active-header-info {
  border-bottom: 2.5px solid #1e40af;
  color: #000 !important;
  font-weight: 500;
  padding: 0px 0px 8px 0px;
}

img.HomeimgSize {
  width: 100%;
  max-width: 40px;
  padding: 6px 0px;
}

.active > .page-link,
.page-link.active {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: #0746a5;
  border-color: var(--bs-pagination-active-border-color);
}

.first-tab,
.second-tab,
.third-tab {
  padding: 3px 0px;
}

.blogs_forms {
  width: 100%;
  max-width: 600px;
}

/* css dec 14  */

.toggle-data-main {
  display: none;
}

.contactuspage {
  margin: 0 0 10px;
}

.menu-icon,
.cross-icon {
  color: white;
}

/* SWAL  */

.errorAlert .swal-text,
.errorAlert-login .swal-text {
  color: #d14f4f;
}

.successAlert .swal-text,
.successAlert-login .swal-text {
  color: #59cf65;
}

.swal-button--danger {
  background-color: #e64942 !important;
  width: 86px !important;
}

.swal-button--cancel {
  color: #555;
  background-color: #efefef;
  width: 86px !important;
  border: none;
  outline: none;
}

.swal-text {
  text-align: center;
  font-family: "Figtree", sans-serif;
}

/* .swal-icon:first-child {
  margin-top: 55px;
} */
.swal-icon:first-child {
  margin-top: 27px;
}

/* .swal-icon:first-child {
  margin-top: 45px;
} */

.swal-icon {
  margin: 10px auto;
}

.errorAlert .swal-title,
.errorAlert-login .swal-title {
  color: #d14f4f;
  font-family: "Figtree", sans-serif;
  letter-spacing: 0.5px;
}

.warningAlert .swal-title,
.warningAlert-login .swal-title {
  color: #d99836;
  font-family: "Figtree", sans-serif;
  letter-spacing: 0.5px;
}

.successAl1ert .swal-title,
.successAlert-login .swal-title {
  color: #59cf65;
  font-family: "Figtree", sans-serif;
  letter-spacing: 0.5px;
}

.swal-modal .swal-text {
  color: #49454f;
  font-family: "Figtree", sans-serif;
  letter-spacing: 0.25px;
  margin-top: 0px;
}

.swal-title {
  padding: 0px 16px !important;
  font-size: 16px !important;
}

.swal-footer {
  text-align: center !important;
}

.css-1qqsdnr-MuiAutocomplete-root
  .MuiAutocomplete-inputRoot
  .MuiAutocomplete-input {
  width: 0;
  min-width: 30px;
  max-height: 12px !important;
}

.css-1qqsdnr-MuiAutocomplete-root .MuiOutlinedInput-root {
  height: 40px !important;
}

.eventSearchbar
  .css-1qqsdnr-MuiAutocomplete-root
  .MuiOutlinedInput-root
  .MuiAutocomplete-input {
  padding: 12px 15px !important;
  outline: none !important;
  border-radius: 0 !important;
}

svg.MuiSvgIcon-root.MuiSvgIcon-fontSizeSmall.css-ptiqhd-MuiSvgIcon-root {
  background: #1e40af;
  color: white !important;
  font-weight: bolder !important;
  border-radius: 33px !important;
  width: 25px !important;
  height: 25px !important;
  margin: -3px -5px !important;
}

/* .swal-icon img {
  max-width: 100%;
  max-height: 100%;
  display: unset;
} */

.swal-icon img {
  max-width: 100%;
  max-width: 60px !important;
  max-height: 100%;
  display: unset;
}

.swal-footer {
  text-align: right;
  padding-top: 13px;
  margin-top: 0 !important;
  padding: 13px 16px;
  border-radius: inherit;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.table-responsive {
  margin: 40px 0 0;
  font-family: "Figtree", sans-serif;
}

.table > :not(:first-child) {
  border-top: 0 !important;
}

.dataTable td {
  font-size: 16px;
  font-weight: 500;
}

.dataTable tr td:nth-child(2) {
  align-items: center;
  /* padding-top: 12px; */
  padding-left: 10px;
  /* padding-bottom: 10px; */
  text-align: center;
  height: 44px;
}

.dataTable tr td:nth-child(1) {
  align-items: center;
  /* padding-top: 12px; */
  padding-left: 11px;
  /* padding-bottom: 10px; */
  text-align: center;
  height: 44px;
}

/* .dataTable tr:nth-child(2n + 2) {
  background: rgba(36, 114, 252, 0.08);
  font-family: poppins !important;
} */

.dataTable tr:nth-child(2n + 2) {
  background: rgb(148 142 209 / 37%);
  font-family: poppins !important;
}

.dataTable
  button.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.MuiButtonBase-root.deletebutt.css-1e6y48t-MuiButtonBase-root-MuiButton-root {
  margin: 0 !important;
  min-width: auto !important;
}

.dataTable a:hover {
  background: none;
}

.table > thead {
  vertical-align: bottom;
  background: rgb(136 121 201 / 82%);
}

.col-sm-12.col-md-6 {
  display: unset !important;
  font-family: poppins !important;
}

.col-md-6 {
  flex: 0 0 auto;
  width: 50%;
}

.savebtn {
  width: 160px !important;
  height: 47px;
  grid-gap: 10px;
  gap: 10px;
  background: #2472fc00 !important;
  font-size: 16px !important;
  font-family: "Figtree", sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px !important;
  border: 1px solid #084ec5;
  font-family: poppins !important;
  float: right;
}

.dataTable th {
  font-size: 16px;
  padding: 8px 25px;
  font-weight: 700;
  color: #000;
  font-family: "poppins", sans-serif !important;
}

.table-bordered > :not(caption) > * > * {
  border-width: 0 !important;
}

.table-bordered > :not(caption) > * {
  border-width: 0px 0;
}

.homepagepay.usr {
  background: #42c1f4;
  padding-bottom: 35px;
}
.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-accent-bg: rgb(255 255 255);
  color: var(--bs-table-striped-color);
  font-family: poppins !important;
}

.css-1d3z3hw-MuiOutlinedInput-notchedOutline {
  text-align: left;
  position: absolute;
  bottom: 0;
  right: 0;
  top: -5px;
  left: 0;
  margin: 0;
  padding: 0 8px;
  pointer-events: none;
  border-radius: inherit;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  min-width: 0%;
}

thead[data-test="table-foot"] {
  display: none;
}

select.custom-select.custom-select-sm.form-control.form-control-sm {
  height: 44px;
  border-radius: 8px;
  text-align: center;
}

.bs-select select {
  display: inline-block !important;
  float: left;
  width: 100%;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: 0.25rem;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  appearance: none;
  border-radius: 0.375rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.custom-select-sm {
  margin: 0 !important;
  height: 50px;
  width: 150px;
  border-radius: 8px;
}

/* input.form-control.form-control-sm.ml-0.my-1 {
  height: 47px;
  margin: 0 11px;
  max-width: 335px;
  border-radius: 8px;
  display: flex;
  align-items: flex-end !important;
  justify-content: flex-end !important;
  float: right;
} */

input.form-control.form-control-sm.ml-0.my-1 {
  height: 34px;
  /* margin: 0 11px; */
  max-width: 335px;
  /* border-radius: 8px; */
  display: flex;
  align-items: flex-end !important;
  justify-content: flex-end !important;
  float: right;
}

button.MuiButtonBase-root.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.close_btn.css-1e6y48t-MuiButtonBase-root-MuiButton-root {
  background: #2472fc !important;
  color: #fff !important;
  font-family: "Figtree", sans-serif !important;
  font-size: 16px !important;
  border-radius: 4px !important;
  margin-right: 16px !important;
  padding: 6px 25px !important;
  margin: 0px 16px 0 0 !important;
  text-transform: capitalize !important;
  width: 107px;
}

button.MuiButtonBase-root.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.submit_block.css-1e6y48t-MuiButtonBase-root-MuiButton-root {
  border: 2px solid #2472fc;
  border-radius: 4px;
  padding: 4px 25px;
  color: #2472fc;
  font-family: "Figtree", sans-serif !important;
  text-transform: none;
  font-weight: 600 !important;
  font-size: 16px !important;
  width: 107px;
  background: none;
}

/* h2#\\:r1\\: {
  border-bottom: 1px solid rgb(204, 194, 194);
  padding: 10px 30px;
} */

select.active_blockinput {
  width: 100%;
  border: 1px solid;
  padding: 7px 13px;
  font-size: 19px;
  font-weight: 62%;
  height: 50px;
  border-radius: 4px;
}

/* DEC 15  */

/* .toggle-data-main {
  position: absolute;
  top: 23px;
} */

.logout-section {
  position: fixed;
  top: 50%;
  right: 0;
  background: #3bd56a;
  padding: 14px;
  border-radius: 50%;
  z-index: 11111;
}

.swal-modal {
  max-width: 348px;
  background-color: #fff;
  min-width: 340px;
  border-radius: 8px;
  box-shadow: 3px 4px 5px 1px #00000080;
  height: auto;
}

/* Dec 16  */
.contact-email-logo {
  background: #3730a3;
  font-size: 15px;
  color: #fff;
  border-radius: 50px;
  padding: 15px;
}

.log-out-icon {
  color: #fff;
  padding: 5px 7px 0 0;
}

.profile_dialog-box
  .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation24.MuiDialog-paper {
  width: 100%;
  min-width: 950px;
  height: 100%;
  min-height: 600px;
}

i.fa-solid.fa-xmark {
  float: right;
}

button.add-event-btn {
  color: blue;
  border: 1px solid blue;
  border-radius: 4px;
  font-size: 13px;
  padding: 6px;
}

button.remove-event-btn {
  color: red;
  border: 1px solid red;
  border-radius: 4px;
  font-size: 13px;
  padding: 6px;
}

/* side bar icon css0 */
img.iconimage-path {
  max-width: 30px;
}

span.ml-3.flex-1.whitespace-nowrap {
  /* font-size: 18px; */
  font-weight: 400;
}

/* 20 Dec 2022 */
.Topdiv {
  background: rgba(36, 114, 252, 0.06);
  width: 100%;
  float: left;
  position: relative;
}

.verifydiv {
  background: rgba(36, 114, 252, 0.06);
}

.verifyemail {
  max-width: 600px;
}

.login-content {
  max-width: 380px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 90%;
}

.verifylogo {
  text-align: center;
}

img.login-logo {
  max-width: 200px;
  display: unset;
}

.verifyemailtext {
  text-align: center;
}

.verifyemailtext h1 {
  padding: 17px 0 12px;
}

a.successfullyButton {
  padding: 10px;
  color: #1e22aa;
  text-transform: capitalize;
  font-size: 16px;
  width: 160px;
  display: inline-block;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 47px;
  border-radius: 8px;
  margin: 31px auto 0;
  border: 1px solid #1e22aa;
}

.thankyoupage {
  background: rgba(36, 114, 252, 0.06);
}

.login-content-registering {
  max-width: 500px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 90%;
}

.thanktext {
  padding: 25px;
  width: 100%;
  border: 1px solid #0d6efd00;
  border-radius: 8px;
  box-shadow: 0px 1px 5px #0d6efd45;
  background: #fff;
}

.logo-content {
  text-align: center;
  margin: 10px 0 20px;
}

.thanktext p {
  line-height: 28px;
  text-align: center;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

/* 20 Dec 2022 */

/* 21 Dec 2022 */
.login-links a {
  color: #4338ca;
}

.login-links.last-link a {
  color: #c74646;
  margin-top: 20px;
}

ul.navbar-link-items {
  display: flex;
  justify-content: center;
  align-items: baseline;
}

.blog-item.first {
  border-top: 0px solid;
  padding-top: 0;
}

.blog-item {
  border-top: 2px solid #ddd;
  padding-top: 15px;
}

/* .container.fighting-imges {
  max-width: 1180px;
} */

@media (min-width: 1550px) and (max-width: 1900px) {
  img.fight-finder-ligo {
    width: 80% !important;
  }

  /* .box-div {
    padding: 119px;
  } */
  .container.absolute.top-50.text-center {
    left: 12rem;
  }
}

.grop-box-content.relative.flex.flex-col.items-start.px-6.bg-white.border.border-t-0.border-gray-200.py-7.rounded-b-2xl {
  min-height: 70%;
}

h1.empty-data {
  font-size: 24px;
  text-align: center;
  color: black;
  padding: 54px 10px;
  text-transform: uppercase;
}

.event-dataimg img {
  float: left;
  margin-right: 15px;
  margin-bottom: 2px;
}

.eventimg-contnet img {
  height: 100%;
}

.eventimg-contnet {
  height: 240px;
  overflow: hidden;
}

.heading-contnet-fight {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 11%;
  top: 0 !important;
  width: 100%;
}

.focus\\:ring-4:focus {
  box-shadow: unset;
}

iframe.map_image {
  height: 400px;
}

/* .related-blogs-contnet {
  float: left;
} */
.fontsize20 {
  font-size: 24px;
  font-weight: bold;
}

input.form-control.input-groups {
  border-radius: 50px 0px 0px 50px;
}

.search_bar .form-control:focus {
  box-shadow: unset;
}

.search_bar button:hover {
  background: #060692;
}

/* 
.Home-events-img {
  height: 410px;
}
.Home-events-img.relative img {
  height: 100%;
} */

/* .Home-events-actives {
  height: 440px !important;
} */

/* .Home-events-actives img {
  height: 100%;
  width: 100%;
} */
.fighter-images-events1 {
  height: 400px;
  overflow: hidden;
}

.fighter-images-events1 img {
  width: 100%;
  height: 400px;
  object-fit: cover;
}

.Home-events-img-contnet {
  height: 410px;
  width: 100%;
}

.Home-events-img-contnet img {
  height: 100%;
  width: 100%;
}

.eventimg-contnet img {
  width: 100%;
}

.dataTable tr td:nth-child(3) {
  align-items: center;
  /* padding-top: 12px; */
  padding-left: 10px;
  /* padding-bottom: 10px; */
  text-align: center;
  height: 44px;
}

.dataTable tr td:nth-child(4) {
  align-items: center;
  /* padding-top: 12px; */
  padding-left: 10px;
  /* padding-bottom: 10px; */
  text-align: center;
  height: 44px;
}

.dataTable tr td:nth-child(5) {
  align-items: center;
  /* padding-top: 12px; */
  padding-left: 10px;
  /* padding-bottom: 10px; */
  height: 44px;
}

.dataTable tr td:nth-child(7) {
  align-items: center;
  /* padding-top: 12px; */
  padding-left: 10px;
  /* padding-bottom: 10px; */
  height: 44px;
}

.box-div.bg-blue-800.py-8.pb-5.px-3.my-4.transition.ease-in-out.delay-150.hover\\:-translate-y-1.hover\\:scale-70.hover\\:bg-blue-500.duration-300.hover\\:text-white.w3-animate-zoom.ease-in {
  height: 193px;
}

.welcome-event-home {
  top: 30% !important;
  font-family: "Rajdhani", sans-serif;
  left: 30px;
}

.welcome-event-home11 {
  top: 25% !important;
  font-family: "Rajdhani", sans-serif;
  left: 30px;
}

button.blog-btn.bg-blue-800.hover\\:bg-blue-700.text-white.uppercase {
  font-size: 12px;
  width: 60px;
  padding: 3px;
  border-radius: 3px;
  margin-right: 17px;
  letter-spacing: 2px;
  font-weight: 500;
  font-family: "Rajdhani";
}

.not-fount-data {
  font-size: 27px;
  color: black;
  text-align: center !important;
  width: 100%;
}

.not-fount-data_content {
  text-align: center;
  font-size: 25px;
  color: black;
}

.fight-finder-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  transition: all 0.3s ease-out 0s;
  padding: 24px;
  background-color: white;
  font-family: poppins !important;
}

/* 9-01-2023 */
.userpage {
  background: #fff;
  width: 97%;
  margin: 0px auto;
  padding: 40px;
  border-radius: 8px;
}

.SelectEventTypeDiv .MuiInputBase-root.MuiOutlinedInput-root {
  width: 100%;
}

.SelectEventTypeDiv h1 {
  margin-bottom: 10px;
}

.UserdetailsEventsDiv h1 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
  margin-top: 20px;
}

.eventTitleInput {
  width: 100%;
  height: 48px;
  padding: 0 10px;
  background: #fff;
  border: 1px solid #ddd;
  /* margin-bottom: 10px; */
  border-radius: 8px;
  margin-top: 5px;
}

.SelectEventTypeDiv
  .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
  padding: 11px 14px;
}

.SelectEventTypeDiv .MuiOutlinedInput-notchedOutline {
  border-color: #ddd;
  border-radius: 8px;
}

.AgeEventsDiv h4 {
  margin-bottom: 4px;
}

.AgeEventsDiv
  .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary {
  width: 100%;
  margin-bottom: 19px;
}

.AgeEventsDiv .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input {
  padding: 12px 14px;
}

fieldset.MuiOutlinedInput-notchedOutline {
  border-color: #ddd;
  border-radius: 8px;
}

.CompLevelEventsDiv h4 {
  margin-bottom: 6px;
}

.CompLevelEventsDiv
  .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary {
  width: 100%;
  margin-bottom: 19px;
}

/* .SelectEventTypeDiv {
  margin: 0 !important;
} */

.countryEventsDiv h4 {
  margin-bottom: 6px;
}

.EventdetailsEventsDiv h1 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
  margin-top: 20px;
}

.EventAddAddressArea textarea.eventAddressArea {
  width: 100%;
  height: 200px !important;
  border: 1px solid #ddd;
  border-radius: 8px;
  /* margin-bottom: 19px; */
  margin-top: 6px;
  padding: 6px;
}

.descrclass,
input.eventZipCodeInput {
  width: 100%;
  height: 48px;
  padding: 0 10px;
  background: #fff;
  border: 1px solid #ddd;
  /* margin-bottom: 19px; */
  border-radius: 8px;
  /* margin-top: 8px; */
}

.SelectEventCountryDiv h1 {
  margin: 0 0 6px;
}

.countryEventsDiv
  .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary {
  width: 100%;
}

.SelectEventCountryDiv
  .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary {
  width: 100%;
  margin-bottom: 19px;
}

.MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input {
  padding: 12px 13px;
}

.taskDueDate .MuiInput-underline:before {
  border-bottom: none;
}

label.taskDueDate {
  border: 1px solid #ddd;
  height: 57px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  padding: 0 10px;
  margin: 6px 0 19px;
}

.SelectEventDateDiv .MuiInput-underline:hover:not(.Mui-disabled):before {
  border-bottom: none;
}

.SchooldetailsEventsDiv h1 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}

.OrganizerSocialEvent .css-14lo706 {
  display: none;
}

.OrganizerSocialEvent .css-14lo706 span {
  display: none;
}

.userform {
  max-width: 600px;
}

.SchoolEventTimeEvent legend {
  display: none;
}

.SchoolEventTimeEvent label {
  display: none;
}

/* .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input {
  font: inherit;
  letter-spacing: inherit;
  color: currentColor;
  padding: 4px 0 5px;
  border: 0;
  box-sizing: content-box;
  background: none;
  height: 31px !important;
  margin: 0;
  -webkit-tap-highlight-color: transparent;
  display: block;
  min-width: 0;
  width: 100%;
  -webkit-animation-name: mui-auto-fill-cancel;
  animation-name: mui-auto-fill-cancel;
  -webkit-animation-duration: 10ms;
  animation-duration: 10ms;
  padding: 11px 14px 12px;
  padding-right: 0;
} */

.SchoolEventTimeEvent .MuiInputAdornment-root.MuiInputAdornment-positionEnd {
  padding: 0;
}

/* .SchoolEventTimeEvent input {
  padding: 9px 11px 13px;
} */
.SchoolEventTimeEvent h1 {
  margin-bottom: 6px;
}

/* .SchoolEventTimeEvent .MuiFormControl-root.MuiTextField-root {
  margin-bottom: 20px;
} */
.taskDueDate .MuiFormControl-root.MuiTextField-root {
  margin-bottom: 0;
}

.OrganizerSocialEvent h1 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
  margin-top: 20px;
}

.EventAcceptForeignDiv {
  margin: 0 0 20px;
}

.EventAcceptForeignDiv h1 {
  margin: 0 0 8px;
}

.EventAcceptForeignDiv label {
  margin: 0 10px;
}

.EventDetailsEventDiv,
.SpecialInstEvent,
.DateSeminarEvent {
  margin: 0 0 0px;
}

.SubmitHandlerEventAdd button {
  background: #1e22aa;
  color: #fff;
  padding: 11px 43px;
  text-transform: uppercase;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.3px;
  /* margin: 15px 0 0; */
  border: none;
}

/* .SelectEventCountryDiv input {
   margin: 0 0 10px;
} */
.CostSeminarEvent,
.EventAddZipCodeArea h4 {
  margin-bottom: 6px;
}

.DateSeminarEvent h1 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}

.SpecialInstEvent h1 {
  margin-bottom: 8px;
}

.SpecialInstEvent textarea {
  height: 200px !important;
  /* margin-top: 9px; */
  padding: 10px;
}

.EventDetailsEventDiv textarea {
  height: 200px !important;
  margin-top: 9px;
  padding: 10px;
}

.CostSeminarEvent h1 {
  margin: 0 0 6px;
}

/* .Minimumdiv {
  display: flex;
  margin-top: 7px;
  width: 100%;
} */
/* .Minimum {
  width: 50%;
  margin-right: 10px;
} */
/* .Minimum1 {
  width: 50%;
} */
.Minimumdiv h4 {
  margin-bottom: 6px;
}

.SelectEventCountryDiv textarea {
  height: 200px !important;
  padding: 6px;
}

input:focus-visible {
  outline: none;
}

input:focus {
  border: 1px solid #0072ff;
}

.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-width: 1px !important;
}

textarea:focus-visible {
  outline: none;
}

.auth-logo-contnet {
  display: flex;
  justify-content: center;
  align-items: center;
}

img.auth-logo {
  width: 30% !important;
}

.auth-logo-contnet-register {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.App_import input#email {
  font-size: 14px;
  font-weight: 300;
}

.App_import input#password {
  font-size: 14px;
  font-weight: 300;
}

.login-form-fight {
  font-family: poppins !important;
}

h1.title-font-blogs {
  font-family: "Rajdhani", sans-serif;
  font-size: 22px;
  font-weight: 900;
  font-style: normal;
  line-height: 27px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #000;
}

.post_meta {
  margin-bottom: 15px;
}

span.post_meta_item.post_date {
  font-family: "Rajdhani", sans-serif;
  font-weight: 700;
}

p.leading-relaxed11 {
  color: #000000e0;
  font-size: 16px;
  line-height: 30px;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
}

.public-footer {
  float: left;
  width: 100%;
  box-shadow: 1px 1px 4px #a3a3a3;
}

/* body {
  font-family: "Rajdhani", sans-serif;
} */

p.blog-title11.sm\\:text-xl.md\\:text-2xl.lg\\:text-2xl.xl\\:text-2xl.font-bold.text-blue-800 {
  font-family: "Rajdhani", sans-serif;
}

ul.footer-list-item {
  font-family: poppins;
}

/* .achivements_button {
  background: #1e40af;
  color: #fff;
  padding: 8px 20px;
  font-weight: 500;
  text-transform: uppercase;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
} */

.achivements_button {
  background: #1e40af;
  color: #fff;
  padding: 4px 7px;
  font-weight: 500;
  text-transform: uppercase;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
}

h1.titelhome {
  text-align: center;
  padding-top: 50px;
  color: #1e40af;
  font-size: 38px;
  font-weight: bold;
}

h4.fontsize56 {
  text-align: center;
  /* padding: 50px 0; */
  color: #fff;
  /* font-size: 56px; */
  font-weight: bold;
}

h3.fontsize38 {
  padding: 4px 0 4px;
  color: #1e40af;
  font-weight: bold;
  font-family: "Rajdhani", sans-serif;
}

button.viewbtn {
  background: #1e40af;
  color: #fff;
  padding: 12px 26px;
  font-weight: 500;
  text-transform: uppercase;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
}

.Home-events-img11 {
  height: 370px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

h4.pagetitleall {
  text-align: center;
  padding: 0 0 4px;
  color: #fff;
  font-size: 23px;
  font-weight: bold;
}

.eventspage {
  padding: 90px 0 30px;
}

.eventsec {
  float: left;
  width: 100%;
  margin-bottom: 80px;
}

.Home-events-page {
  width: 33.33%;
}

.eventimg {
  height: 280px;
  overflow: hidden;
}

.eventimg img {
  object-fit: cover;
  height: 100%;
}

.Home-events-page {
  width: 32.33%;
  margin: 5px;
  box-shadow: 1px 1px 6px #ddd;
  padding: 28px;
  border-radius: 9px;
  float: left;
}

.fighter-name2 {
  padding: 20px 0 0;
}

span.eventdate {
  font-size: 18px;
  color: #000;
  margin-bottom: 7px !important;
  display: inline-block;
}

.fighter-name2 h2 {
  font-size: 24px !important;
  font-weight: 700;
  color: #1e40af;
}

.eventdetails {
  float: left;
  width: 100%;
  padding: 30px 0 60px;
}

h2.relatedtitle {
  text-align: center;
  padding: 40px 0 60px;
  color: #1e40af;
  font-size: 38px !important;
  font-weight: bold;
  font-family: "Rajdhani", sans-serif;
  float: left;
  width: 100%;
}

.blogpage1 {
  padding: 108px 0 39px;
}

.blogdetailepage {
  padding: 50px 0 30px;
}

.commontext {
  margin: -54px 0 20px;
}

.commontext span {
  background: #1e40af;
  color: #fff;
  padding: 10px 19px;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  font-family: "Poppins", sans-serif;
}

.datedetailssec {
  background: #1e40af;
  color: #fff;
  padding: 10px 19px;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  font-family: "Poppins", sans-serif;
}

h1.blogtitledetails {
  padding: 5px 0 14px;
  color: #1e40af;
  font-size: 38px;
  font-weight: bold;
  font-family: "Rajdhani", sans-serif;
}

.aboutpage {
  padding: 50px 0;
}

.bakground {
  background: #f7f7f7;
  width: 100%;
  float: left;
}

h2.titleourpage {
  text-align: center;
  padding: 50px 0 0;
  color: #1e40af;
  font-size: 38px !important;
  font-weight: bold;
}

/* .addevent {
  margin-top: 162px;
  margin-bottom: 40px;
} */
.Relatedevents {
  width: 100%;
  float: left;
}

.terms-cojnn p {
  font-size: 15px;
  line-height: 30px;
}

.eventimg-contnet {
  width: 100%;
  float: left;
}

.event-dataimg {
  float: left;
  width: 100%;
}

.related-blogs-contnet {
  float: left;
}

.eventsbak {
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0.8;
  padding: 24px 24px;
  margin: 0 0 -4px;
}

.fourth-contnet-font-fam {
  font-family: "Poppins";
}

/* scroll bar modify */

/* Hide scrollbar for Chrome, Safari and Opera */
/* body {
  overflow-y: scroll; 
}
body::-webkit-scrollbar {
    display: none;
} */

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 20px !important;
}

/* scroll bar modify */

.menuhome {
  position: relative;
}

.header-sidebar-coontnet {
  position: absolute;
  width: 100%;
}

.MuiAutocomplete-root.MuiAutocomplete-hasClearIcon.form-control.input-groups.font-normal.rounded-md.text-gray-700.bg-white.border.border-solid.border-gray-300.css-1qqsdnr-MuiAutocomplete-root {
  padding: 0;
  height: 40px;
  border: none !important;
}

.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-fullWidth.MuiInputBase-formControl.MuiInputBase-adornedEnd.MuiAutocomplete-inputRoot.css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root {
  padding: 2px;
  border-radius: 0 !important;
}

.MuiAutocomplete-root.form-control.input-groups.font-normal.rounded-md.text-gray-700.bg-white.border.border-solid.border-gray-300.css-1qqsdnr-MuiAutocomplete-root {
  padding: 0 !important;
  height: 40px !important;
  border: none !important;
  border-radius: 30px 0px 0px 30px !important;
  outline: none;
}

.searchsec
  .css-1qqsdnr-MuiAutocomplete-root
  .MuiOutlinedInput-root
  .MuiAutocomplete-input {
  padding: 11px 13px !important;
}

.css-1qqsdnr-MuiAutocomplete-root .MuiOutlinedInput-root {
  padding: 1px !important;
}

button#mui-p-80405-T-1 {
  font-family: "Rajdhani", sans-serif !important;
  font-weight: bold;
}

.css-nwrfgk-MuiButtonBase-root-MuiTab-root {
  color: black !important;
  font-weight: 500;
  font-size: 17px !important;
  line-height: 1.25;
  padding: 12px 16px;
  font-weight: bold !important;
  font-family: "Rajdhani", sans-serif !important;
}

.css-1aquho2-MuiTabs-indicator {
  background-color: #42c1f4 !important;
  font-family: "Rajdhani", sans-serif !important;
}

.org-div {
  float: left;
  width: 100%;
}

.searchsec fieldset.MuiOutlinedInput-notchedOutline {
  border-color: none !important;
  border-radius: 0;
}

.searchsec .search_bar button:hover {
  background: none !important;
}

.searchsec .MuiButtonBase-root.MuiIconButton-root.MuiIconButton-sizeMedium {
  background: none;
}

.search_bar input:focus {
  border: none;
}

.searchsec fieldset.MuiOutlinedInput-notchedOutline {
  border-radius: 50px 0 0 50px !important;
}

i.fa-solid.fa-arrow-right {
  padding: 0px 6px;
}

.lkjDVC {
  min-width: 322px;
  max-width: 600px !important;
  height: 48px;
  border: dashed 2px #0a6ae7;
  padding: 8px 16px 8px 8px;
  border-radius: 5px;
  cursor: pointer;
  flex-grow: 0;
}

.css-1qqsdnr-MuiAutocomplete-root
  .MuiAutocomplete-inputRoot
  .MuiAutocomplete-input {
  width: 0;
  min-width: 30px;
  height: 31px !important;
}

/* .MuiTabs-flexContainer.css-heg063-MuiTabs-flexContainer {
  margin-left: 25px;
} */
.searchsec .MuiOutlinedInput-root .MuiAutocomplete-input {
  padding: 7.5px 4px 7.5px 20px !important;
}

/* .we .css-13xfq8m-MuiTabPanel-root {
  padding-top: 29px !important;
} */

.about-us-content td {
  padding: 12px;
  font-size: 16px;
  font-weight: 500;
  line-height: 35px;
  font-family: "Poppins";
  width: 50% !important;
}

.about-us-content img {
  border-radius: 14px;
  width: 100% !important;
}

/* .about-us-content h2 {
  font-size: 21px !important;
  font-family: "Rajdhani", sans-serif;
  text-align: center;
  font-weight: bold;
} */

.about-us-content table {
  border-color: #f0f8ff00 !important;
}

.font-fam-contnet {
  font-family: "Rajdhani", sans-serif;
  font-size: 16px !important;
}

.popins-font-fam {
  font-family: poppins !important;
  font-size: 15px !important;
}

/* .inputCntnr.error {
  border: 2px solid #d10d0dbf;
  border-radius: 7px;
} */

textarea.eventTitleInput-desc {
  width: 100%;
  height: 200px !important;
  border: 1px solid #ddd;
  border-radius: 8px;
  /* margin-bottom: 19px; */
  margin-top: 6px;
  padding: 6px;
}

.css-1u3bzj6-MuiFormControl-root-MuiTextField-root {
  width: 100% !important;
  height: 50% !important;
}

.css-nxo287-MuiInputBase-input-MuiOutlinedInput-input {
  padding: 13px 14px !important;
}

label[data-shrink="false"]
  + .MuiInputBase-formControl
  .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input {
  padding: 10px 14px !important;
}

.blogs_forms11 {
  width: 80% !important;
}

.switch-box {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch-box input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider-toggle {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}

.slider-toggle:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
}

input:checked + .slider-toggle {
  background-color: #2164f3;
}

input:focus + .slider-toggle {
  box-shadow: 0 0 1px #42c1f4;
}

input:checked + .slider-toggle:before {
  transform: translateX(26px);
}

/* Rounded sliders */
.slider-toggle.round {
  border-radius: 34px;
}

.slider-toggle.round:before {
  border-radius: 50%;
}

.MuiBox-root.css-0 {
  padding-bottom: 12px !important;
}

.css-13xfq8m-MuiTabPanel-root {
  padding: 0 !important;
}

/* 9 march */

/* .feedbackAboutAreaMainD.events-search-feed {
  width: 80%;
} */

.css-vqmohf-MuiButtonBase-root-MuiRadio-root.Mui-checked {
  color: #193ad2 !important;
}

.react-slideshow-container .default-nav:first-of-type {
  margin-right: 0px !important;
  border-right: 14;
  border-top: 0;
  padding: 3px 10px 3px 7px !important;
  left: 20px !important;
}

.react-slideshow-container .default-nav:last-of-type {
  margin-left: 0px !important;
  right: 20px !important;

  padding: 3px 10px 3px 7px !important;
}

.react-slideshow-container .default-nav {
  height: 30px;
  background: rgb(255 255 255 / 30%);
  width: 30px;
  border: 0;
  text-align: center;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ReactCollapse--collapse {
  transition: height 500ms;
}

/* .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation24.MuiDialog-paper.MuiDialog-paperScrollPaper.MuiDialog-paperWidthSm.css-1t1j96h-MuiPaper-root-MuiDialog-paper {
  width: 100%;
  height: auto;
} */

.crop-contnet {
  height: 0 max-content;
  height: auto;
  height: 0;
  margin-left: -13px;
  margin-top: 11px;
}

textarea.event-desc-contnet {
  width: 100%;
  height: 200px !important;
  border: 1px solid #ddd;
  border-radius: 8px;
  /* margin-bottom: 19px; */
  margin-top: 6px;
  padding: 6px;
}

i.fa.fa-search.text-black.text-md {
  font-size: 17px;
  padding-left: 4px;
}

.aero-angle-dowun {
  transform: rotate(177deg);
  height: 22px;
}

i.fas.fa-angle-down {
  margin-left: 8px;
  font-size: 19px;
}

.slider-image-div {
  height: auto;
  padding: 0 25px;
}

.evetns-search-image img {
  height: 100%;
  width: 100%;
  overflow: hidden;
  object-fit: cover;
  object-position: top;
}

.evetns-search-image {
  height: 200px;
  overflow: hidden;
}

p.leading-relaxed11.file-search {
  font-size: 12px !important;
  line-height: 22px !important;
}

h1.title-font-blogs.events-search-title {
  font-size: 19px;
  /* margin-bottom: 2px !important; */
}

p.post_meta_item11.post_date {
  font-family: "Rajdhani", sans-serif;
  font-weight: 700;
}

i.fas.fa-solid.fa-calendar-days {
  font-size: 16px;
  margin-right: 8px;
}

i.fa-solid.fa-globe {
  margin-right: 8px;
}

.back-img-photo {
  background-image: url(https://images.unsplash.com/photo-1499336315816-097655dcfbda?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=crop&amp;w=2710&amp;q=80);
  background-size: cover;
  width: 100%;
  background-repeat: no-repeat;
}

section.back-image-logo12 {
  height: 100% !important;
}

main.profile-page-thoughts {
  margin-top: 33%;
}

main.profile-page-thought-de {
  margin-top: 27%;
  margin-bottom: 3%;
}

.bell-tottal-count {
  position: relative;
}

span.total-noti-count {
  position: absolute;
  top: -7px;
  left: 10px;
  background: #ee2d2df2;
  color: white;
  border-radius: 20px;
  height: 22px;
  padding: 0px 5px;
}

.close-btn-back-profile {
  float: right;
  margin-bottom: 16px;
}

.profilePic-admin-image {
  position: absolute;
  top: -68px !important;
  right: 13px;
}

label.upload-profileImg.absolute {
  right: 18px;
  bottom: 6px;
}

.notification-alert {
  position: absolute;
  width: 34%;
  padding: 0px;
  right: 0;
  top: 85px;
}

i.fas.fa-caret-up {
  font-size: 41px;
  position: absolute;
  bottom: -13px;
  left: 38%;
  color: #8080803d;
}

h1.see-all-noti-page {
  margin-top: 21px;
  border: 1px solid #8080804d;
  padding: 9px 9px;
  border-radius: 4px;
}

.fighting-imges-disussion {
  min-height: 100vh !important;
}

i.far.fa-comment-dots.text-black {
  font-size: 19px !important;
}

/* i.fa.fa-search {
  font-size: 17px;
} */

.travel-div {
  font-size: 36px;
  text-align: center;
  /* padding: 73px 0px; */
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-family: poppins !important;
}

.the-martial-nexus {
  text-align: center;
  margin-left: 17px;
  font-family: "Rajdhani", sans-serif;
}

.the-martial-nexus.uppercase h1 {
  line-height: 22px;
}

/* .text-div-nexus {
  width: 60%;
  padding-left: 12%;
} */

/* .search-bar-for-event {
  width: 40%;
} */

/* .typing-key-event {
  top: 24%;
} */

.text-div-nexus {
  /* width: 60%; */
  /* padding-left: 12%; */
  text-align: center;
}

.typing-key-event {
  top: 15% !important;
}

button.tags-button-events {
  background: #0743b1;
  color: white;
  font-weight: bold;
  margin: 0px 10px;
  width: 60px;
  padding: 5px;
  border-radius: 20px;
  margin-top: 8px;
}

.insta-user img {
  width: 6%;
  object-fit: cover;
}

.insta-user {
  width: 100%;
  display: flex;
  justify-content: center;
}

.border-replay-comment {
  border: 1px solid #80808070;
  border-right: 2px solid var(--newCommunityTheme-line);
  display: block;
  height: 100%;
  width: 50%;
}

.border-line-replay {
  position: absolute;
  height: calc(89% - 68%);

  margin-left: 12px;
}

.social-media-text {
  margin-left: 30px;
}

article.comment-article {
  margin-left: -44px;
}

.comment-text-pera {
  margin-left: 47px !important;
}

.comment-art-box {
  position: relative;
}

.border-replay-comment1 {
  border: 1px solid #80808070;
  border-right: 2px solid var(--newCommunityTheme-line);
  display: block;
  height: 100%;
  width: 100%;
}

.border-line-replay1 {
  position: absolute;
  height: calc(100% - 0%);
  margin-left: 12px;
  width: 0;
  top: 55px;
  left: -20px;
}

.border-line-replay2 {
  position: absolute;
  height: calc(90% - 0%);
  margin-left: 12px;
  width: 0;
  top: 55px;
  left: -20px;
}

.border-replay-comment2 {
  border: 1px solid #80808070;
  border-right: 2px solid var(--newCommunityTheme-line);
  display: block;
  height: 100%;
  width: 100%;
}

.deletion-dialog-delete
  .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation24 {
  max-width: 400px !important;
  width: 100%;
}

button.delte-btn-dialog {
  width: 100px;
  background: #f75151;
  color: white;
  font-weight: 400;
  padding: 5px 0px;
  border-radius: 5px;
}

button.cancel-btn-dialog {
  width: 100px;
  background: #3360f7;
  color: white;
  font-weight: 400;
  padding: 5px 0px;
  border-radius: 5px;
}

button.save_profilepic {
  width: 100px;
  background: #3360f7;
  color: white;
  font-weight: 400;
  padding: 7px 0px;
  border-radius: 5px;
}

button.save_profilepic-btn {
  width: 100px;
  color: #3360f7;
  font-weight: 400;
  padding: 5px 0px;
  border-radius: 5px;
  border: 2px solid #3360f7;
  margin-left: 12px;
  margin-right: 12px;
}

button.deletion-btn-open-popup {
  width: 120px;
  background: #f04040c4;
  color: white;
  font-weight: 400;
  padding: 7px 0px;
  border-radius: 5px;
}

.profile-submit-buttons {
  margin: 0px 26px;
}

.user-profile_discussion img {
  width: 150px !important;
  height: 150px !important;
  object-fit: cover !important;
}

.discussion-cards-home {
  width: 100% !important;
  height: 265px !important;
  min-height: 100% !important;
}

button.crop-contnet {
  right: -35px;
  top: -9px !important;
  color: #808080a6;
}

i.fa.fa-edit.text-lg.text-gray-800 {
  color: #808080cf;
}

.search-bar-usersearch {
  /* position: absolute !important;
  top: 12% !important; */
  width: 100% !important;
  left: 12%;
}

.search-userpopup {
  position: absolute;
  top: 26px;
  left: 35px;
}

.input-group-user-search.searchsec {
  width: 56%;
}

.search-bar-usersearch {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.searchsec1 .MuiAutocomplete-root.form-control.input-groups.font-normal {
  width: 400px;
}

button.my-post-section {
  background: #1e40afe3;
  margin: 6px 11px;
  padding: 6px 8px;
  width: 118px;
  border-radius: 6px;
  color: white;
}

.search-input-users {
  text-align: center;
}

input.newSearchActInputPp {
  width: 50% !important;
  border-radius: 5px;
  padding: 10px 9px;
  border: 1px solid #8080806b;
}

/* phone number flag css */

.react-tel-input .selected-flag .flag {
  position: absolute;
  top: 50% !important;
  margin-top: -12px !important;
}

.react-tel-input .form-control {
  font-size: 16px;
  background: #ffffff;
  border: 1px solid #cacaca8a;
  border-radius: 0px !important;
  width: 238px !important;
  outline: none;
  padding: 9px 50px !important;
  /* transition: box-shadow ease .25s,border-color ease .25s; */
  color: #495057;
}

.react-tel-input .form-control:focus {
  background-color: #fff;
  border-color: #1365bd !important;
  outline: none !important;
  box-shadow: none !important;
}

.react-tel-input .selected-flag:before {
  content: "";
  display: block;
  position: absolute;

  border-radius: 4px 2px 2px 4px;
  border: 1px solid transparent;
  transition: box-shadow ease 0.25s, border-color ease 0.25s;
  height: 0 !important;
}

/* phone number flag css */
.follower-total-count {
  cursor: pointer;
}

button.search-users-popup-btn {
  background: #1266e5db;
  color: white;
  width: 114px;
  padding: 5px 1px;
  font-weight: 300;
  font-family: poppins;
  border-radius: 4px;
}

.search-users-popup {
  float: right !important;
}

.common-tabs-posts {
  height: 100% !important;
}

.btn-box-delete-info {
  right: -42px !important;
  top: 31px !important;
}

.searchsec button:hover {
  background: #1e40af;
}

.no-posts-found {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 60px;
}

.terms-privacy-fight {
  font-family: poppins !important;
}

.common-text-font-fam {
  font-family: "Rajdhani", sans-serif;
}

.no-posts-found h1 {
  font-size: 27px;
  font-weight: 500;
}

/* canvas.mapboxgl-canvas {
  width: 1256px !important;
  height: 400px !important;
} */

.show-hide-password {
  position: absolute;
  bottom: 8px;
  right: 11px;
}

input.mapboxgl-ctrl-geocoder--input {
  padding-left: 30px !important;
}

.filter-sort-by {
  /* width: 25%; */
  display: flex;
  justify-content: center;
  align-items: center;
}

.eventSearchbar
  fieldset.MuiOutlinedInput-notchedOutline.css-1d3z3hw-MuiOutlinedInput-notchedOutline {
  /* FONT-VARIANT: JIS04; */
  border-radius: 0 !important;
}

.eventSearchbar
  .css-1qqsdnr-MuiAutocomplete-root
  .MuiOutlinedInput-root
  .MuiAutocomplete-input {
  padding: 2.5px 1px 4.5px 7px;
}

button.search-enter-btn {
  padding: 13px !important;
  height: 40px !important;
}

.input-group.eventSearchbar {
  margin-top: 36px;
  margin-right: 12px;
}

.css-nwrfgk-MuiButtonBase-root-MuiTab-root.Mui-selected {
  background-color: rgb(36 101 199) !important;
  color: white !important;
  border-color: rgb(36 101 199);
  font-size: 17px;
  font-weight: bold;
  font-family: "Rajdhani", sans-serif !important;
}

button.all_jobs_poject_buttonnewdiv.active1 {
  /* background: rgb(36 101 199); */
  color: white;
  font-size: 15px;
  /* width: 101px; */
  padding: 8px 10px;
  font-weight: 500;
  font-family: "Poppins";
  /* margin-right: 12px; */
  border: 0px solid rgb(36 101 199);
}

button.all_jobs_poject_buttonnewdiv {
  color: rgb(30 64 175);
  font-size: 14px;
  padding: 8px 10px;
  font-weight: 700;
  font-family: "Poppins";
  /* margin-right: 12px; */
  border: 1px solid;
}

.aero-down-icon {
  margin-top: -13px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin-right: 15px; */
}

i.fas.fa-caret-down.aeroafflian {
  font-size: 32px;
  color: rgb(30 64 175);
}

.mactching-div {
  text-align: center;
  padding: 12px 12px;
  color: white;
  font-size: 17px;
  font-family: "Poppins";
  font-weight: 400;
  margin-bottom: 12px;
}

i.fa.fa-search.search-user-icon {
  position: absolute;
  top: -5px;
  right: 207px;
  color: #808080c2;
  z-index: 30;
}

.search-user-btn input {
  border: 1px solid gray;
  padding: 10px 31px;
  border-radius: 30px;
  position: absolute;
  right: 0px;
  top: -22px;
  width: 100%;
}

/* .user-search-div {
  position: absolute;
  width: 35%;
  right: 29%;
  top: 98px;
} */

.user-search-div {
  position: absolute;
  width: 30%;
  right: 35%;
  top: 95px;
}

i.fas.fa-sort-down {
  font-size: 20px;
  margin-left: 14px;
  height: 27px;
}

textarea.thougt-textarea {
  height: 200px !important;
}

p.poem-word {
  height: 166px !important;
}

.upcoming-evetns-near {
  display: flex;
  justify-content: center;
  align-items: center;
}

button.terms-privacy-fight:active {
  background: #1e40af !important;
}

.slider-image-div img {
  height: 620px;
  object-fit: cover;
  border-radius: 10px;
}

.transparent-image {
  position: absolute;
  bottom: 0;
  padding: 170px 0px;
  width: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
}

textarea.w-full.px-3.py-2.border.border-slate-400.placeholder-text-sm.rounded {
  height: 100px !important;
}

.search-bar-for-event {
  /* width: 40%; */
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px 357px;
}

.recent-searhces {
  display: flex;
  align-items: center;
  margin: 0px 3px;
  font-family: poppins !important;
}

.event-tabele-data {
  width: 100%;
  margin: 0 auto;
  padding: 0;
}

/* .event-tabele-data::-webkit-scrollbar {
  width: 1em;
}
 
.event-tabele-data::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
 
.event-tabele-data::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
} */

/* 21 March 2023 */

.css-1qqsdnr-MuiAutocomplete-root
  .MuiOutlinedInput-root
  .MuiAutocomplete-input {
  /* padding: 7.5px 4px 7.5px 6px; */
  border-radius: 64px 0px 0px 64px !important;
}

/* .dataTables_length.bs-select {
  margin: -17px !important;
} */

button.search-enter-btn:hover {
  background-color: #1e40af !important;
}

a.mapboxgl-ctrl-logo {
  display: none !important;
}

.mapboxgl-ctrl-attrib-inner {
  display: none !important;
}

button.mapboxgl-popup-close-button {
  padding: 2px 10px !important;
}

/* 21 March 2023 */

/* .eventSearchbar input#tags-outlined {
  height: 12px !important;
} */

.DAMSidebar li span {
  display: none;
  transition: 1s;
}

.DAMSidebar {
  width: 80px;
  transition: 1s;
}

.DAMSidebar .whitespace-nowrap {
  display: none;
  transition: 1s;
}

.sidebarmenu2 {
  transition: 0.5s;
}

.logo_sec {
  width: 35%;
}

.search-user-btn {
  width: 30%;
}

.userid12 {
  width: 35%;
  display: flex;
  justify-content: end;
}

.wordbreadkdiv {
  word-wrap: break-word !important;
}

.eidt-profile {
  position: absolute;
  right: 51px;
  top: -9px;
  color: #007eff;
  cursor: pointer;
}

.event-tags-div
  .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-fullWidth.MuiInputBase-formControl.MuiInputBase-adornedEnd.MuiAutocomplete-inputRoot.css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root {
  padding: 0 !important;
  margin: 0 !important;
  height: 53px;
}

img.fight-finder-ligo {
  width: 100%;
  max-width: 200px;
}

div#search-event-boxx {
  max-height: 400px;
  overflow-y: scroll;
}

i.fa.fa-ellipsis-v {
  cursor: pointer;
}

.scroll-top-btn {
  position: fixed;
  bottom: 80px;
  right: 20px;
  background: no-repeat !important;
  border: none;
  outline: none;
  cursor: pointer;
}

i.fas.fa-arrow-up.aero-scroll {
  font-size: 30px;
  background: white;
  padding: 5px 7px;
  border-radius: 24px;
  color: black;
}

.fighter-images-events1.neweventsadd {
  height: 280px !important;
  border-radius: 11px !important;
}

.eventsbak.bgblack-trasn {
  border-radius: 8px !important;
}

.flex.flex-col.p-6.mx-auto.max-w-lg.text-gray-900.bg-white.rounded-lg.border.border-gray-100.shadow.w-full.my-ideas {
  height: 280px !important;
  border-radius: 11px;
}

.text-div-nexus {
  margin-top: 25px !important;
}

.grid.grid-cols-2.gap-4.skillstag {
  align-items: center !important;
}

p.common-text-font-fam.text-black-800.font-medium.text-lg {
  font-size: 13px !important;
  color: #000000c2 !important;
  text-align: center !important;
}

button.scroll-top-btn {
  z-index: 999 !important;
}

.Home-events-img11.Publiceventde.resize-image {
  height: 200px !important;
}

i.fa.fa-home {
  font-size: 22px;
}

i.fa.fa-home.text-lg.mr-2.text-gray-600 {
  font-size: 18px !important;
}

h4.common-text-font-fam.text-white.sm\\:text-3xl.md\\:text-5xl.font-bold {
  font-size: 90px !important;
}

.w-full.p-3.mt-2.bg-white.rounded.shadow.flex.flex-shrink-0 {
  display: flex;
  align-items: center;
}

img.rounded-full.max-w-none.w-12.h-12.mr-4 {
  margin: 0px 0px !important;
}

.grid.grid-cols-1.gap-2.box-border.mx-4 {
  margin-bottom: 50px;
}

.eveantag1212 .MuiOutlinedInput-root .MuiAutocomplete-input {
  border-radius: 4px !important;
  margin-right: 4px;
}

.eveantag1212 .MuiOutlinedInput-root {
  height: 48px !important;
  width: 100% !important;
}

textarea.block.p-2\\.5.w-full.text-sm.text-gray-900.bg-gray-50.rounded-lg.border.border-gray-300.focus\\:ring-blue-500.focus\\:border-blue-500.bg-white.dark\\:border-gray-600.dark\\:placeholder-gray-400.dark\\:text-black.dark\\:focus\\:ring-blue-500.dark\\:focus\\:border-blue-500 {
  height: 150px !important;
}

button.affilian-post-btn {
  color: white;
  padding: 7px 37px;
  border-radius: 5px;
  width: 167px;
}

.mapboxgl-popup-content {
  position: relative;
  background: #fff;
  border-radius: 3px;
  box-shadow: 0 1px 2px rgb(0 0 0/10%);
  padding: 10px 10px 15px;
  pointer-events: auto;
  width: 100px !important;
  text-align: center !important;
  font-family: "Poppins";
}

.save_profilepic-btn.close-prfile11 {
  position: relative;
}

button.save_profilepic-btn.close-prfile {
  position: absolute;
  top: -38px;
  left: 133px;
}

.swal-modal.errorAlert {
  height: 230px;
}

.successLogout {
  width: 107px;
  border: none;
  background: #7867c1;
  color: #fff;
  padding: 10px 0;
  border-radius: 8px;
  margin: 13px;
  font-size: 16px;
  cursor: pointer;
  font-family: "poppins";
}

.successfullyButton {
  background: #1f92b5;
  font-weight: 300;
  font-family: "Poppins";
  display: inline-block;
  text-decoration: none;
}

img.logo-dashboard {
  width: 139px;
}

a.successfullyButton {
  padding: 10px;
  color: #1e22aa;
  text-transform: capitalize;

  display: inline-block;
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 8px;
  margin: 20px auto 0;

  color: white;
}

img.dashboardImg {
  width: 300px;
}

.dashboardDiv {
  display: flex;
  justify-content: center;
  margin: 20px;
}

.update {
  width: 13%;
}

.dash {
  margin: 10px;
}

.filesDiv {
  display: flex;
  justify-content: space-between;
  height: 34px;
}

button.del {
  height: 23px;
  margin: 14px;
  color: #42c1f4;
  border-radius: 13px;
  border: 0px;
}

#file-input-area {
  display: none;
}

.button {
  background-color: #007bff;
  border: none;
  color: white;
  padding: 10px 40px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
  border-radius: 10px;
  font-family: "poppins";
}

text.recharts-text.recharts-cartesian-axis-tick-value {
  font-size: 13px;
}

.chatmapdiv {
  padding: 20px 20px 10px 0px;
}

p.fileName {
  display: flex;
  justify-content: center;
  background: white;
  border-radius: 4px;
  padding: 6px;
}

#membershipHeading {
  padding: 10px 0;
  font-size: 20px;
  font-weight: 600;
  font-family: "poppins";
}
h3.price {
  padding-bottom: 13px;
  font-weight: 500;
  color: #7867c1;
  font-size: 18px;
}
p.errorMsg {
  margin: 0 !important;
  font-size: 13px;
  color: #e31e00;
  font-family: poppins;
}

.divGraph {
  background-color: white;
  border-radius: 10px;
}

.chartDiv {
  background: white;
  padding: 30px 32px 24px 0px;
  border-radius: 10px;
  position: relative;
}

button.del.btnSS {
  float: right;
  background: #42c1f4;
  color: white;
}

/* select.method-select {
  border: none;
  padding: 4px;
  margin: 11px;
  border-radius: 12px;
  color: #42c1f4;
  outline: none !important;
} */

p.count {
  color: #42c1f4;
  display: flex;
  align-items: center;
}

img.error-page {
  width: 60%;
  display: flex;
  justify-content: center;
  margin: auto;
  margin-top: 32px;
}

a.hover-primary.subs {
  margin-right: 10px;
}

p#notfound {
  font-size: 34px;
  font-family: "Poppins";
  text-align: center;
  margin-top: 115px;
}

select.custom-select.custom-select-sm.form-control.form-control-sm {
  width: 168px;
  margin-bottom: 22px !important;
}

.userlistdiv {
  width: 60%;
  margin: auto;
  background: white;
  padding: 26px;
  border-radius: 10px;
}

table.table.table-bordered.table-sm.table-striped.dataTable {
  margin: auto;
  width: 100%;
}

/* .thanktexthome.userlist {
  width: 60%;
  margin: auto;
} */

.thanktexthome.userlist {
  margin: auto;
  padding: 0px 130px;
}

/* ul.pagination {
  width: 60%;
  margin: auto;
  margin-top: 20px;
} */

li.page-item {
  display: inline-block;
  margin-left: 17px;
  cursor: pointer;
}

button.del.add {
  width: 30px;
}

rect.recharts-brush-slide {
  fill-opacity: 1;
}

.dataresult {
  display: flex;
}

.datashow {
  width: 30%;
  position: relative;
}

.result {
  width: 70%;
}

/* data result */
.dataresult {
  margin: 12px;
}

.datashow {
  width: 21%;
  background: white;
  padding: 35px;
  border-radius: 5px 0px 0px 5px;
  box-shadow: 2px 1px 11px 3px;
}
/* h2.dataheading {
  display: flex;
  justify-content: center;
  color: #16414a;
  font-size: 39px;
} */

h2.dataheading {
  display: flex;
  justify-content: center;
  color: gray;
  font-size: 40px;
  font-weight: 700;
}

button.btnchange {
  border: none;
  color: gray;
  font-size: 25px;
  font-weight: 400;
  font-family: "Poppins";
}

/* p.dataText {
  font-size: 13px;
  margin: 2px;
  color: #8d9191;
} */
p.dataText {
  font-size: 14px;
  margin: 2px;
  color: #8d9191;
  font-family: "Poppins";
}
.Data-plotting {
  display: flex;
  background: white;
  margin-left: 10px;
  padding: 12px;
  border-radius: 0px 5px 5px 0px;
  box-shadow: 2px 1px 11px 3px;
}
.graphplot {
  width: 90%;
}
.graphdetail {
  width: 31%;
  /* display: flex;
  justify-content: center;
  align-items: self-end; */
}
.graphdetail > div {
  height: 40px;
  padding-left: 13px;
  margin-top: 270px;
  display: flex;
  justify-content: center;
}
.confidenceContainer {
  display: flex;
}
.clustergraph {
  height: 380px;
}
.confidence {
  width: 50%;
  background: white;
  margin-left: 10px;
  margin-top: 10px;
  box-shadow: 2px 1px 11px 3px;
  height: 460px;
}
.clusterPlot {
  background: white;
  margin-top: 10px;
  margin-left: 10px;
  width: 50%;
  border-radius: 0px 5px 5px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 2px 1px 11px 3px;
}

h2.corelate {
  margin-bottom: 95px;
}
.addpagelink {
  position: absolute;
  bottom: 13px;
  left: 20px;
}
.addpagelink a {
  list-style: none;
  color: grey;
  text-decoration: none;
}
label.fileupload {
  border-radius: 5px;

  font-size: 14px;
  border: 1.2px solid #7e6dc9;
  padding: 1px 6px;
  color: white;
  background: #7867c1;
  margin: 2px;
}
.dropzone-content {
  display: flex;
  flex-direction: row;
}

.dataText {
  font-size: 12px;
  margin-left: 8px;
  color: gray;
}
select.method-select {
  border: 1px solid gray;
  padding: 0 13px;
  width: 150px;
  border-radius: 3px;
  color: gray;
  background: white;
  outline: none !important;
}
p.dataToggle {
  color: gray;
  font-size: 13px;
}
/* toggle button */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 22px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 17px;
  width: 17px;
  left: 4px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.clusterPlot {
  padding: 6px;
  /* padding-top: 20px; */
}
.toggledec {
  display: flex;
  align-items: center;
}
input.confiInput {
  width: 50px;
  padding: 5px;
  border: none;
  border-radius: 3px;
  text-align: center;
  margin: 0px;
  color: #42c1f4;
}
button.del {
  height: 23px;
  margin: 0px;
  color: white;
  border-radius: 5px;
  border: 1px solid gray;
  background: #7867c1;
}

button.submitbtn {
  background: #7867c1;
  border-radius: 5px;
  border: 2px solid #9788d8;
  color: white;
  padding: 5px 16px;
  font-size: 23px;
  font-family: "poppins";
}

.leftsideimport {
  display: flex;
}

.addfiledata {
  padding-left: 100px;
}

.headerstyle a {
  list-style: none;
  color: grey;
  text-decoration: none;
  font-size: 25px;
}
.headerstyle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 8px 17px -10px;
}
.containeraddfile {
  width: 82%;
  box-shadow: 0px 1px 11px 1px;
  margin: auto;
  /* padding: 0px; */
}

.leftsideimport {
  background: white;
}
.containeraddfile {
  background: white;
}

h2.dataheading {
  margin: 0px;
  /* margin-bottom: 30px; */
}

.dashboardpage {
  background: #42c1f440;
}

.homepage {
  background: #42c1f4;
  padding: 40px 0;
  height: 100vh;
}

.action-btnss {
  display: flex;
  align-items: center;
  justify-content: center;
}

i.fa.fa-solid.fa-check {
  color: #10c910;
  font-size: 22px;
}

i.fa.fa-solid.fa-times {
  color: red;
  font-size: 22px;
}

.dataTables_length.bs-select {
  width: 102px !important;
}

.setting-action-btn {
  display: flex;
  justify-content: center;
}
.table-responsive tr {
  padding: 10px 0 !important;
  width: 100%;
  font-family: poppins !important;
  height: 53px;
}
/* .setting-action-btn {
  height: 53px;
} */

i.fa.fa-gear {
  font-size: 21px;
  /* pointer-events: initial; */
  cursor: pointer;
}

ul.pagination {
  /* width: 60%; */
  margin: auto;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.active > .page-link,
.page-link.active {
  background-color: #948ed1;
  border-color: var(--bs-pagination-active-border-color);
  padding: 5px 18px;
  color: white;
  font-size: 18px;
  border-radius: 11px;
}

.main-upload-data {
  display: flex;
  gap: 13px;
  align-items: center;
  height: 100px;
}

h2.number-lenght.text-red-800 {
  background: #7867c1;
  /* width: 40px; */
  padding: 9px 22px;
  border-radius: 27px;
  color: white;
  font-family: "Poppins";
}

.oneinputtitle {
  margin-top: 39px;
}

.straoght-border {
  border: 3px solid;
  width: 59px;
  transform: (14deg 7deg);
  transform: rotate(90deg);
  margin-left: -4px;
  color: #7867c1b5;
}
.dropzone-part {
  padding-top: 16px;
  padding-bottom: 8;
}

select.method-select {
  border: 1px solid gray;
  margin-top: 12px;

  width: 100%;
  border-radius: 3px;
  color: gray;
  background: white;
  font-family: "Poppins";
  outline: none !important;
}

/**
 * The switch widget!
 * Usage:
 *   <input type="checkbox" switch[="type"] id="toggleSwitch" />
 *   <label for="toggleSwitch" data-on-label="On" data-off-label="Off"></label>
 */

/*
  * Copyright (c) 2013 Thibaut Courouble
  * http://www.cssflow.com
  *
  * Licensed under the MIT License:
  * https://www.opensource.org/licenses/mit-license.php
  */

.switch {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 56px;
  height: 20px;

  background-color: white;
  border-radius: 18px;
  box-shadow: inset 0 -1px white, inset 0 1px 1px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  background-image: linear-gradient(to bottom, #eeeeee, white 25px);
}

.switch-input {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}

.switch-label {
  position: relative;
  border: 2px solid gray;
  display: block;
  height: inherit;
  font-size: 10px;
  text-transform: uppercase;
  background: #808080e1;
  border-radius: inherit;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.12),
    inset 0 0 2px rgba(0, 0, 0, 0.15);
  transition: 0.15s ease-out;
  transition-property: opacity background;
}
.switch-label:before,
.switch-label:after {
  position: absolute;
  top: 50%;
  margin-top: -0.5em;
  line-height: 1;
  transition: inherit;
}
.switch-label:before {
  content: attr(data-off);
  right: 11px;
  color: #aaa;
  text-shadow: 0 1px rgba(255, 255, 255, 0.5);
}
.switch-label:after {
  content: attr(data-on);
  left: 11px;
  color: white;
  text-shadow: 0 1px rgba(0, 0, 0, 0.2);
  opacity: 0;
}
.switch-input:checked ~ .switch-label {
  background: #7867c1;
  /* box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15), inset 0 0 3px rgba(0, 0, 0, 0.2); */
}
.switch-input:checked ~ .switch-label:before {
  opacity: 0;
}
.switch-input:checked ~ .switch-label:after {
  opacity: 1;
}

.switch-handle {
  position: absolute;
  border: 2px solid gray;
  top: 4px;
  left: 6px;
  width: 0;
  height: 13px;
  background: white;
  border-radius: 10px;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);
  background-image: linear-gradient(to bottom, white 40%, #f0f0f0);
  transition: left 0.15s ease-out;
}
.switch-handle:before {
  border: 2px solid gray;
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -6px 0 0 -2px;

  width: 12px;
  height: 12px;
  background: #f9f9f9;
  border-radius: 6px;
  box-shadow: inset 0 1px rgba(0, 0, 0, 0.02);
  background-image: linear-gradient(to bottom, #eeeeee, white);
}
.switch-input:checked ~ .switch-handle {
  left: 40px;
  box-shadow: -1px 1px 5px rgba(0, 0, 0, 0.2);
}

.switch-green > .switch-input:checked ~ .switch-label {
  background: #4fb845;
}

label.select-toggle-btn {
  margin-right: 50px;
  color: gray;
  font-family: "Poppins";
}

.plus-minus-input {
  display: flex;
  /* align-items: center; */
}

span.count-persanttage {
  border-top: 1px solid gray;
  border-bottom: 1px solid gray;
  padding: 2px 14px;
  background: white;
}

button.decrement-button {
  color: white;
  font-size: 26px;
  border-radius: 3px;
  border: none;
  width: 30px;
  height: 30px;
  background: #7867c1;
  display: flex;
  align-items: center;
  justify-content: center;
}

button.increment-button {
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 26px;
  border-radius: 3px;
  border: none;
  width: 30px !important;
  height: 30px;
  background: #7867c1;
}

button.submitbtn {
  background: #7867c1;
  border-radius: 15px;
  border: 2px solid #aa9ede;
  color: white;
  padding: 5px 12px;
  font-size: 33px;
  font-family: "poppins";
  font-weight: 700;
  font-family: "Poppins";
}

.main-graph-image {
  background: white;
  height: 100vh;
}

.heading h1 {
  text-align: center;
  color: rgb(128 128 128 / 75%);
  font-family: "Poppins";
  margin-top: 0;
  font-size: 38px;
  font-weight: 500;
  padding: 24px 0 0;
  font-weight: bold;
}

.main-graph-image {
  height: 100vh !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  padding: 0px 66px;
}
button {
  border: none;
  color: gray;
  font-size: 16px;
}
/* button.btnchange {
  border: none;
  color: gray;
  font-size: 16px;
} */
p.dataTitle {
  color: #7867c1;
  font-size: 30px;
  margin: 10px 0px 10px 0px;
  font-family: "Poppins";
}
.layout-dashboard-main {
  background: white;
  height: 100vh;
}
.icondown {
  width: 31px;
  height: 31px;
  margin-left: 5px;
  cursor: "pointer";
  float: right;
  /* display: flex; */
  /* align-items: center; */
  /* justify-content: center; */
  /* text-align: center; */
  margin: 0 20px;
  position: relative;
  z-index: 999;
}
.clusterGraph {
  width: 100%;
}
.main_navbar_header {
  padding: 8px 28px;
  box-shadow: 0px -4px 11px 4px;
}
/* .loginsigin {
  position: absolute;
  width: 200px;
  background: #fff;
  padding: 10px;
  right: 0;
  top: 55px;
  border-top: 4px solid #FC2D60;
  z-index: 9999;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
} */

.loginsigin a {
  width: 100%;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #a0a0a0;
}
.loginsigin li {
  width: 100%;
  margin: 3px;
}
.loginsigin li:hover {
  width: 100%;
  background: unset;
  box-shadow: unset;
  margin: 0;
}
li.user-header-div.Activediv {
  list-style: none;
}

img.mr-2.profileIcons {
  margin-right: 6px;
}
img.mr-2.logout {
  margin-right: 8px;
}
li.user-header-div {
  list-style: none;
}
.profileIcons {
  width: 20px;
  margin-right: 5px;
}
img.logout {
  margin-right: 9px;
}
.loginsigin {
  position: absolute;
  width: 200px;
  background: #fff;
  padding: 13px;
  right: 28px;
  top: 46px;
  border-top: 4px solid #7867c1;
  z-index: 9999;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
  list-style: none;
  text-align: justify;
  padding-left: 20px;
}
a.hover-primary {
  color: #7867c1;
  font-size: 14px;
  text-decoration: none;
  font-weight: 600;
  /* margin-top: 7px; */
  display: inline-block;
  text-transform: capitalize;
  font-family: "Poppins";
}
img.imgPro {
  margin-top: 11px;
  width: 26px;
}
.main-geoThara-div {
  margin: 70px 0;
}
.elementor-widget-container {
  color: #4ac0ef;
  font-family: "Rubik", Sans-serif;
  font-size: 45px;
  font-weight: 600;
  line-height: 50px;
}
.changing-content {
  color: #7867c1;
  font-family: "Rubik", Sans-serif;
  font-size: 45px;
  font-weight: 600;
  line-height: 50px;
}
.test-1 {
  font-family: "Poppins", Sans-serif;
  font-size: 18px;
  font-weight: 400;
}
.slider-image-div img {
  width: 100%;
  /* height: auto; */
}
.trenddetection {
  display: flex;
  align-items: center;
  justify-content: center;
}
.react-slideshow-container .default-nav {
  background: none !important;
}
.react-slideshow-container svg {
  fill: #fff !important;
}
.topdiv {
  height: 520px;
  overflow: hidden;
  position: relative;
}

.newlogomenu {
  display: flex;
}
.newlogo {
  width: 150px;
}
.container {
  margin: 0 auto;
}
.logomenu {
  width: 100%;
  display: flex;
  padding: 0 40px;
  align-items: end;
  justify-content: center;
}
.newlogomenu {
  display: flex;
  max-width: 1130px;
  margin: 0 auto;
}
.logomenu li {
  list-style: none;
  padding: 0 18px;
}
.logonavbar {
  position: absolute;
  top: 0;
  width: 100%;
  padding: 20px 10px;
  z-index: 999;
  border-top: 1px solid #fff;
  margin-top: 44px;
}
.logomenu a {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #fff;
}
p.emailtext {
  /* position: absolute; */
  /* right: 0; */
  /* margin: 0 auto; */
  color: #fff;
  /* padding: 10px 0 30px; */
  /* display: inline-block; */
  /* width: 100%; */
}
.container-text {
  text-align: right;
  width: 90%;
  /* margin: 0 auto; */
  float: left;
  padding: 9px 0;
  position: absolute;
  z-index: 999;
}
.tobtext {
  position: absolute;
  top: 50%;
  width: 100%;
}
.tobtext h1 {
  color: #ffffff;
  font-family: "DM Sans", Sans-serif;
  font-size: 47px;
  font-weight: 700;
  line-height: 100px;
  padding: 0 66px;
}
.Services {
  object-fit: cover;
  background-repeat: no-repeat;
  padding: 50px 0 80px;
}
.allServices {
  display: flex;
}
.Services1 {
  width: 30.5%;
  background: #fff;
  text-align: center;
  padding: 80px 30px;
  border-radius: 15px;
}
.Services-icon {
  width: 4%;
  display: flex;
  align-items: center;
  justify-content: center;
}
img.Services-icon-img {
  width: 130px;
  margin: 0 auto;
  padding: 20px;
}
h2.nuber {
  color: #6ec1e4;
  font-size: 35px;
  font-weight: 700;
}
h3.datatext {
  font-family: "Rubik", Sans-serif;
  font-size: 25px;
  font-weight: 700;
  font-style: italic;
  letter-spacing: 0px;
  color: #7867c1;
  margin: 7px 0 10px;
}
p.Services-test {
  font-family: "Rubik", Sans-serif;
  font-size: 15px;
  font-weight: 700;
  font-style: italic;
  color: #7867c1;
}
h1.Servicestitle {
  color: #ffffff;
  font-family: "Rubik", Sans-serif;
  font-size: 45px;
  font-weight: 600;
  margin-bottom: 50px;
}
.Services-top {
  padding: 0 65px;
}
.result {
  width: 78%;
}
.datashow {
  width: 30%;
  position: relative;
  background: white;
  padding: 35px;
  border-radius: 5px 0px 0px 5px;
  box-shadow: 2px 1px 11px 3px;
}
.Contactsecdiv {
  display: flex;
  width: 100%;
  margin: 85px 0;
}
.Contactsecdiv-text {
  width: 50%;
  display: flex;
  align-items: center;
}
.Contactsecdiv-img {
  width: 50%;
}
.Contactsecdiv-img img {
  width: 100%;
}
h1.Contacttitle {
  color: #4ac0ef;
  font-family: "Rubik", Sans-serif;
  font-size: 45px;
  font-weight: 600;
  line-height: 50px;
}
h2.contactlink {
  font-size: 24px;
  color: #7867c1;
  margin: 6px 0 0;
}
.Contactsecdiv-img img {
  border-radius: 10px;
}
.bottomsec {
  background: #01102d;
  padding: 60px 0;
}
.footer-text {
  width: 33.33%;
}
.footer-logo {
  width: 33%;
  display: flex;
  align-items: center;
}
.footer {
  display: flex;
}
.footer-logo img {
  width: 220px;
}
.footer-text p {
  text-align: left;
  color: #ffffff;
  font-family: "Poppins", Sans-serif;
  font-size: 16px;
  font-weight: 500;
  padding-bottom: 20px;
}
.scrolled .logonavbar {
  position: fixed;
  background: #000;
  top: -50px;
}
h2.createplay-title {
  font-size: 26px;
  color: #7867c1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation24 {
  max-width: 350px !important;
  width: 100%;
  padding: 0px 10px;
}
button.MuiButtonBase-root.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.canceButtonnewPop.css-1e6y48t-MuiButtonBase-root-MuiButton-root {
  color: #42c1f4;
  padding-bottom: 8px;
  font-size: 16px;
}
.MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
  width: 73px;
  color: #7867c1;
  border: 1px solid #7867c1;
}
h2.add-title {
  color: #7867c1;
  font-size: 27px;
  display: flex;
  justify-content: center;
  padding-bottom: 27px;
}
.allpage {
  background: white;
  border-radius: 5px;
  padding: 15px;
}
.dataTables_length.bs-select {
  color: #7867c1;
}

i.fas.fa-2x.fa-sharp.fa-regular.fa-circle-down {
  color: #7867c1;
}

.clustergraph svg.recharts-surface {
  margin-top: 41px;
  height: 380px !important;
}

/* .clusterGraph.third svg.recharts-surface {
  margin-top: -78px !important;
} */

/* .graphplot.firstgraph {
  width: 300% !important;
} */

button.i-contnet-btn {
  background: #7867c1;
  color: white;
  padding: 1px 16px;
  border-radius: 12px;
}
.Data-plotting .graphplot {
  width: 300%;
}
.icondown11 {
  display: flex;
  height: 98%;
  align-items: end;
}
.icondown474 {
  margin: -5px 11px 0;
}
/* neww csss */

.select-steps-contnet {
  font-size: 29px;
  font-weight: 300;

  color: rgba(128, 128, 128, 0.86);
  font-family: "Poppins", sans-serif;
}

.border-steps {
  color: #9082cc;
  border: 3px solid;
}

.rounded-border-contnet {
  background: #7867c1 !important;
  width: 50px;
  height: 50px;
  border: 1px solid #7867c1;
  color: white;
  font-size: 22px;
  font-family: "Poppins";
}

.upload-data-inputdata {
  margin-top: 30px !important;
}

.spaceonright {
  display: flex;
  justify-content: center;
  align-items: end;
  position: absolute !important;
  left: 43%;
  top: 95%;
}
button.togglebtn {
  display: none;
}
.logo-m {
  display: none;
}
.mobl {
  display: none;
}

.foldermainDisplayDivsec {
  width: 100% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

a.Auth-button.back-btn {
  margin: 0 auto;
}

.show-hide-password {
  display: none !important;
}

.newgraph-div {
  display: flex;
  background: #80808036;
  padding: 44px 0px 0px 0px;
  box-shadow: 0px 3px 8px -3px;
}

/* button.all_graph_buttonnewdiv {
  width: 140px;
  background: #80808094;
  color: black;
  font-family: poppins;
  font-size: 21px;
  text-align: center;
  padding: 5px 8px;
  border-radius: 10px 10px 0px 0px;
  font-weight: 400;
} */

/* button.all_graph_buttonnewdiv {
  width: 140px;
  background: #80808094;
  color: black;
  font-family: poppins;
  font-size: 21px;
  text-align: center;
  padding: 5px 8px;
  border-radius: 10px 10px 0px 0px;
  font-weight: 400;
} */

.otherdiv-main-divv {
  display: flex;
  gap: 20px;
  padding-top: 50px;
}

/* .responsive-graph-second {
  width: 35%;
} */

.second-valuelinechart {
  width: 430px;
}

button.all_graph_buttonnewdiv.active {
  background: #42c1f4;
  color: white;
}

.responsive-graphd-first {
  width: 65%;
  margin-top: 50px;
}

h1.varable-div {
  font-size: 25px;
  font-family: poppins;
  color: #5a5858;
}

input:checked {
  background-color: #7c65be;
}

input:checked ~ span:last-child {
  --tw-translate-x: 1.75rem; /* translate-x-7 */
}

span.diagnostic.mr-3 {
  font-size: 24px;
  font-family: poppins;
  color: #5e5a5a;
}

span.diagnostic-trend.mr-3 {
  padding: 3px;
  background-color: #7c65be;
  font-size: 20px;
  font-family: poppins;
  color: #e5e7eb;
  border-radius: 7px;
}

input.toggle-new-swith {
  width: 58px;
  height: 30px;
  border: none;
  outline: none;
}

.progress-bar {
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: #7c65be;
  /* transition: height 0.3s ease-in-out; */
}

.progress-wrap {
  position: relative;
  height: 166px;
  width: 30px;
  background-color: #7c65be;
  margin-top: 19px;
  border: 2px solid #7c65be;
  border-radius: 5px;
}

.progress-barprogress-text {
  margin-left: 41px;
}

.progressbar-div {
  display: flex;
  gap: 14px;
}

.liner-trned {
  margin-top: 14px;
}

.lner-progress-trend {
  padding: 5px 0px;
  font-size: 17px;
  font-family: poppins;
  color: #444141;
  cursor: pointer;
}

.pie-chart-container {
  width: 75px;
  height: 75px;
  position: relative;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
  border: 3px solid white;
}

.progress-bar11 {
  width: 100%;
  height: 100%;
  position: relative;
  background: #7c65be;
}
.progress11 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  border: 1px;
  height: 100%;
  background-color: #e5dbdbad;
  transition: clip-path 0.3s ease-in-out;
}
/* Optional: Styling for the chart border */
.pie-chart-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid #ccc;
  box-sizing: border-box;
}

.cirlce-progress {
  background: #80808085;
  padding: 6px 7px 12px 6px;
  border-radius: 12px;
}

span.percantage-cion {
  font-size: 30px;
  margin-left: 7px;
}

.lner-progress-trend.stpepercan {
  margin: -26px -3px -14px 0px;
}

.prog-number {
  font-size: 45px;
  margin: -8px 0px 0px 0px;

  font-family: poppins;
  color: #5e5a5a;
}
.pieChart .recharts-wrapper svg {
  width: 60px;
  height: 60px;
}
/* *************************** */

.slider-container {
  --label: 2.75rem;
  --width: 100% !important;
  --thumb: clamp(3rem, calc(2.28rem + 3.18vw), 3.88rem);
  inline-size: var(--width);
  aspect-ratio: 10.665 / 1;
  display: grid;
  padding-inline: var(--space);
  border-radius: 0;
  /* margin-left: 14px; */
  position: relative;
}
.input-slider {
  place-self: center;
  border-radius: 0;
  width: calc(var(--width) - 1rem);
  appearance: none;
  outline: none;
  border: none;
  border-top: 2px solid #5e5a5a;
  height: 0;
}

.input-slider:focus {
  border: 1px solid !important;
}

.input-slider::-webkit-slider-thumb {
  appearance: none;
  width: var(--thumb);
  height: var(--thumb);
  cursor: pointer;
  position: relative;
  z-index: 2;
  margin-top: -18px !important;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 15px solid #7c65be;
}

.input-slider::-moz-range-thumb {
  appearance: none;
  width: var(--thumb);
  height: var(--thumb);
  background-color: #000;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  z-index: 2;
}

.input-slider::-webkit-slider-thumb:before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 6px solid #fff;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.input-slider::-moz-range-thumb:before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 6px solid #fff;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.numeric-sliderrange {
  background: #bdbdbd;
  padding-top: 22px;
  padding-bottom: 22px;
  padding-right: 11px;
  padding-left: 11px;
  border-radius: 12px;
}

.center-border-style {
  display: flex;
  justify-content: center;
}

h2.value-cahrtdiv {
  font-size: 46px;
  padding: 8px 25px;
  font-family: poppins;
  /* width: 98px; */
  text-align: center;
  /* margin-left: -13px; */
  color: #5e5a5a;
}

.numeric-sliderrange.second-div {
  padding: 0;
}

.first-valuelinechart {
  width: 23%;
}

/* .second-valuelinechart {
  width: 60%;
} */

.numariclinechart {
  position: relative;
}

.numer-border {
  color: black;
  background: black;
  width: 38px;
  height: 2px;
  transform: rotate(90deg);
  position: absolute;
  bottom: 31px;
}

.second.numer-border {
  width: 50px;
  position: absolute;
  right: 50%;
  left: 42%;
  background: #5e5a5a;
  top: 50%;
}

.third.numer-border {
  position: absolute;
  right: 0px;
  background: #5e5a5a;
  top: 50%;
}

.first.numer-border {
  position: absolute;
  left: 0px;
  background: #5e5a5a;
  top: 50%;
}

.inner-div {
  position: absolute;
  top: 0;
  width: 26px;
  height: 20px;
  border-radius: 3px;
  margin-left: 0.1px;
  background: #fff;
  transition: top 3s ease;
  transform-origin: top;
  pointer-events: none;
}
.responsive-graphd-first .recharts-surface {
  width: 100% !important;
}

.mapboxgl-ctrl-geocoder.mapboxgl-ctrl {
  display: flex;
  align-items: center;
}

/* Add map box */

.mapboxgl-ctrl-geocoder {
  position: absolute;
  top: 200px;
  right: 10px;
  z-index: 1;
}

/* input.mapboxgl-ctrl-geocoder--input {
  padding: 9px 0px;
  display: none;
} */

/* svg.mapboxgl-ctrl-geocoder--icon.mapboxgl-ctrl-geocoder--icon-search {
  position: absolute;
  left: 7px;
  width: 19px;
  display: none;
}

.mapboxgl-ctrl-geocoder--pin-right {
  display: none;
}

canvas.mapboxgl-canvas {
  width: 1500px !important;
  margin-top: 35px;
} */

.mapboxgl-canvas-container.mapboxgl-interactive.mapboxgl-touch-drag-pan.mapboxgl-touch-zoom-rotate {
  display: flex;
  justify-content: center;
  background-color: white;
}

.mapboxgl-marker.mapboxgl-marker-anchor-center {
  transform: none !important;
}

.select-country-maindiv {
  display: flex;
  justify-content: center;
  position: absolute;
  left: 50px;
  z-index: 9999;
}

select.select-country-box {
  padding: 11px 14px;
  margin-top: 25px;
  border-radius: 9px;
  border: 1px solid gray;
  margin-bottom: 30px;
}

.section-80 {
  width: 50%;
  height: 100%;
  background-color: yellow;

  /* Add any other styling you need */
}

.section-20 {
  width: 20%;
  height: 100%;
  background-color: green;

  /* Add any other styling you need */
}

.sub-section {
  width: 100%;
  height: 50%;
  background-color: red;
  /* Add any other styling you need */
}

/* new cs 21 aug  */

.vediopage {
  width: 70%;
}

.main-vediopage {
  display: flex;
  gap: 6px;
  width: 100%;
  align-items: center;
  /* height: 100vh !important; */
}

i.fas.fa-robot.robotai {
  font-size: 30px;
  border: 1px solid white;
  padding: 11px 9px;
  border-radius: 30px;
  background: #7867c1;
  color: white;
}

input.helpaiinput {
  width: 100%;
  padding: 7px 8px;
  border-radius: 12px;
  background: #cac8c8;
}

i.material-icons.sednaiicon {
  font-size: 31px;
  background: #cac8c8;
  padding: 4px 9px;
  border-radius: 8px;
  color: #7240d6;
}
/* img.social-media-iconss {
  width: 90px;
} */

h1.expoort-heading {
  text-align: center;
  margin-top: 25px;
  margin-bottom: 12px;
  font-family: "Poppins";
  color: #5c5a5a;
  font-size: 35px;
}

h1.count-downtime {
  padding: 0px 7px;
  background: #8080802b;
  text-align: center;
  border-radius: 56px;
  display: flex;
  justify-content: center;
  width: 230px;
  font-size: 45px;
  color: gray;
  font-weight: 300;
}

.socialmediagridicon {
  display: flex;
  gap: 11px;
}

i.fa.fa-download.downloadicon {
  font-size: 42px;
  background: #141414;
  padding: 14px 13px;
  border-radius: 43px;
  width: 67px;
  color: white;
}

img.social-media-iconss {
  width: 90px;
  height: 67px;
  object-fit: contain;
}

.timer-countai {
  display: flex;
  justify-content: center;
  margin-bottom: 38px;
}

.mapboxgl-ctrl.mapboxgl-ctrl-group {
  margin-top: 45rem !important;
  margin-right: 1rem !important;
}

.mapboxgl-ctrl-geocoder.mapboxgl-ctrl {
  display: flex;
  align-items: center;
  position: absolute;
  right: 12px;
  top: 16px;
}

/* .map-vedioshow {
  width: 1290px !important;
  height: 740px !important;
  border-radius: 30px !important;
} */

img.vedioshow-gif {
  width: 1290px !important;
  height: 740px !important;
  object-fit: cover !important;
  /* border-radius: 30px !important; */
}

/* new cs 21 aug  */

ul.recharts-default-legend {
  margin-top: 40px !important;
  margin-left: 50px !important;
}

.right_sidee {
  height: 360px;
  overflow: scroll;
}

.player-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 14px !important;
  transition: opacity 2s ease-in !important;
  opacity: 0;
  position: absolute;
  top: 150px;
  width: 70%;
}

.mapbox-show {
  height: 90vh;
  transition: opacity 2s ease-out; /* Add transition property */
  opacity: 1;
}

.map-vedioshow {
  max-width: 100%;
  height: auto;
}

svg.sendmessagevedio {
  background: #cac8c8;
  border-radius: 8px;
  color: #7867c1;
  width: 45px;
  height: 45px;
  padding: 4px 5px;
}

.chatpast-sectionlist {
  height: 230px;
  overflow: overlay;
}

input.edit-timervideo {
  font-size: 41px;
  text-align: center;
  width: 226px;
  border-radius: 40px;
  padding: 4px 6px;
}

.main-geofont-fam {
  font-family: "Poppins";
}

body {
  font-family: "Poppins" !important;
}

/* 4-22-2024 css */
.videosec img {
  margin: 0 auto;
  width: 100%;
}
p.emailtext {
  margin: unset;
}

.info-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  font-size: 14px;
  font-weight: bold;
  color: #7867c1 !important;
  background-color: #e0e0e0;
  border-radius: 50%;
  cursor: pointer;
  margin-left: 8px;
  box-shadow: 0 3px 4px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s, box-shadow 0.2s;
  position: relative;
  top: -5px;
}

.info-icon:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
}

.info-icon:active {
  transform: scale(1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;AACnB;AACA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,wBAAwB;IACxB,4BAA4B;IAC5B,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;;EAEA;IAME,aAAa;IACb,4BAA4B;EAJ9B;AAMF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;IAC9B,kCAAkC;EACpC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;EACA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oCAAoC;IACpC,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;;EAEA;;;GAGC;;EAED;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;IAC3B,qCAAqC;IACrC;;;yBAGqB;EACvB;EACA;IACE,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;EACvB;EACA;IACE,0BAA0B;IAC1B,yCAAyC;EAC3C;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,SAAS;IACT,UAAU;IACV,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;IAC3B,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,2BAA2B;IAC3B,2BAA2B;IAC3B,uBAAuB;IACvB,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;IACrB,8BAA8B;EAChC;;EAEA;IACE,qBAAqB;IACrB,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;GAEC;;EAED;;KAEG;;EAEH;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAGE,4BAA4B;IAG5B,sBAAsB;;IAEtB,6BAA6B;EAJ/B;;EAOA;IACE,wBAAwB;IACxB,kCAAkC;IAIlC,sBAAsB;EAHxB;EAKA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;;IAE1B,+BAA+B;EACjC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,0BAA0B;;IAE1B,6BAA6B;IAC7B,6BAA6B;EAC/B;EACA;IACE,+BAA+B;IAC/B,mCAAmC;EACrC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAC1B,0BAA0B;IAC1B,6BAA6B;EAC/B;AACF;;AAEA;AACA;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;;;;GAIG;AACH;;GAEG;AACH;EACE,0BAA0B;AAC5B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,QAAQ;EACR,SAAS;EACT,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,aAAa;EACb,OAAO;EACP,QAAQ;EACR,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,wCAAwC;EACxC,yBAAyB;EACzB,sDAAsD;AACxD;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,gBAAgB;;AAEhB;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;AACd;;AAEA,UAAU;;AAEV;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;;GAEG;AACH;EACE,gBAAgB;AAClB;;AAEA;;GAEG;;AAEH;EACE,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;EAGE,QAAQ;EACR,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;EAIE,6BAA6B;EAC7B,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;;;;GAIG;;AAEH;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;AACd;;AAEA;;;GAGG;;AAEH;EACE,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;;EAEE,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,SAAS;EACT,gCAAgC;EAChC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;EACzB,+BAA+B;EAI/B,YAAY;AAHd;;AAMA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,SAAS;EACT,OAAO;EACP,SAAS;EACT,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAIhC,WAAW;EACX,WAAW;AAJb;;AAOA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,wEAAwE;AAC1E;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;;;;;;GASG;;AAEH;EACE,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,gCAAgC;EAChC,oCAAoC;EACpC,YAAY;AACd;;AAEA;EAEE,8BAA8B;EAC9B,sBAAsB;EACtB,6CAA6C;EAC7C,0BAA0B;EAC1B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;EAC/B,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,6CAA6C;EAC7C,oBAAoB;EACpB,2BAA2B;EAC3B,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;GAGG;;AAEH;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,YAAY;;AAEZ;;;GAGG;;AAEH;EACE,eAAe;EACf,QAAQ;EACR,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,oCAAoC;EAIpC,WAAW;EACX,WAAW;EAIX,kBAAkB;AARpB;;AAWA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gBAAgB;;AAEhB,gBAAgB;AAChB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;EACE;IACE,qBAAqB;EACvB;;EAEA;;KAEG;EACH;IACE,WAAW;EACb;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;;GAEG;AACH;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;GAMG;;AAEH;;GAEG;;AAEH;;;GAGG;AACH;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;GAEG;;AAEH;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;;;;;;;;;;;;;;;GAoBG;;AAEH;EACE,UAAU;AACZ;;AAEA;;GAEG;AACH;EACE,kBAAkB;AACpB;;AAEA;;GAEG;AACH;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;AACd;;AAEA;;GAEG;AACH;;EAEE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;GAIG;AACH;;;GAGG;AACH;;GAEG;AACH;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,+BAA+B;AACjC;;AAEA;;GAEG;;AAEH;EACE,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;;;;;;GAQG;;AAEH;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;EACjB,mCAAmC;EACnC,WAAW;EACX,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;;;GAGG;AACH;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,sBAAsB;;AAEtB,gDAAgD;AAChD;;;;;GAKG;;AAEH;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA,sBAAsB;;AAEtB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,2CAA2C;EAC3C,aAAa;AACf;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,YAAY;EACZ,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EAIf,YAAY;AACd;;AAEA;;;EAGE,QAAQ;EACR,eAAe;EACf,uBAAuB;AACzB;;AAEA;;GAEG;AACH;EACE,wCAAwC;AAC1C;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;;;;GAKG;;AAEH;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;;;GAGG;;AAEH;EACE,WAAW;EACX,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EAEtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EAEvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,YAAY;;AAEZ;;GAEG;;AAEH;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;;EAEtB,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;GAGG;;AAEH;EACE,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iLAAiL;EACjL,sBAAsB;EACtB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;GAEG;;AAEH;EACE,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;GAGG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;;EAEvB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,QAAQ;EACR,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,QAAQ;EACR,SAAS;EACT,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;wBACsB;EACtB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA,0BAA0B;;AAE1B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,6BAA6B;EAC7B,uBAAuB;EACvB,aAAa;EACb,4BAA4B;EAC5B,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;;EAElB,8BAA8B;EAC9B,6BAA6B;EAC7B,0DAA0D;EAC1D,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;GAGG;;AAEH;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;;;EAIE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;AACb;;AAEA;;;;;GAKG;;AAEH;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,UAAU;AACZ;;AAEA;;;;;;;;;;;GAWG;;AAEH,kBAAkB;;AAElB;;;EAGE,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;;GAEG;;AAEH;EACE,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,kBAAkB;;AAElB;;GAEG;;AAEH;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EACd,0BAA0B;;EAE1B,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,kBAAkB;EAClB,mBAAmB;;EAEnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EAEE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;;;;;;;GAOG;;AAEH;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;;;GAGG;;AAEH;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;GAIG;;AAEH;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA;;;;;GAKG;;AAEH;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;;GAIG;AACH;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV;;0BAEwB;AAC1B;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,kBAAkB;;EAElB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EAEtB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;AACA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,WAAW;EACX,+BAA+B;EAC/B,YAAY;AACd;AACA;;GAEG;;AAEH;EACE,eAAe;EACf,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;EACzB,sDAAsD;EACtD,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;;EAEhB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;;;;;EAKE;;AAEF;;;;;;GAMG;;AAEH;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,YAAY;;EAEZ,uBAAuB;EACvB,mBAAmB;EACnB,mEAAmE;EACnE,eAAe;EAIf,iEAAiE;AACnE;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB;qCACmC;EAInC,0BAA0B;EAI1B,uCAAuC;AACzC;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EAId,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,2CAA2C;AAC7C;AACA;EACE,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,qCAAqC;EACrC,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,uFAAuF;AACzF;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAI1C,gEAAgE;EAIhE,+BAA+B;AACjC;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,qBAAqB;;EAErB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAI3C,4DAA4D;AAC9D;AACA;EACE,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;EACvC,iCAAiC;EACjC,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;AACA;;;;GAIG;AACH;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;;;;;;;;;;GAUG;;AAEH;EACE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,SAAS;EACT,6BAA6B;EAC7B,aAAa;EACb,wCAAwC;EACxC,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,cAAc;EACd,oBAAoB;EACpB,WAAW;EACX,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;AACA;EACE,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,WAAW;EACX,cAAc;AAChB;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EAKE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AAJf;AAMA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA,cAAc;;AAEd;EACE,eAAe;EACf,gBAAgB;;EAEhB,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,SAAS;EACT,QAAQ;AACV;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;;;;;;;;;;GAUG;;AAEH;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE;IACE,wBAAwB;IACxB,4BAA4B;IAC5B,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;EACA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oCAAoC;IACpC,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;;EAEA;;;GAGC;;EAED;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;IAC3B,qCAAqC;IACrC;;;yBAGqB;EACvB;EACA;IACE,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;EACvB;EACA;IACE,0BAA0B;IAC1B,yCAAyC;EAC3C;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,SAAS;IACT,UAAU;IACV,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;IAC3B,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,2BAA2B;IAC3B,2BAA2B;IAC3B,uBAAuB;IACvB,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;IACrB,8BAA8B;EAChC;;EAEA;IACE,qBAAqB;IACrB,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;GAEC;;EAED;;KAEG;;EAEH;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAGE,4BAA4B;IAG5B,sBAAsB;;IAEtB,6BAA6B;EAJ/B;;EAOA;IACE,wBAAwB;IACxB,kCAAkC;IAIlC,sBAAsB;EAHxB;EAKA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;;IAE1B,+BAA+B;EACjC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,0BAA0B;;IAE1B,6BAA6B;IAC7B,6BAA6B;EAC/B;EACA;IACE,+BAA+B;IAC/B,mCAAmC;EACrC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAC1B,0BAA0B;IAC1B,6BAA6B;EAC/B;AACF;;AAEA;AACA;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;;;;GAIG;AACH;;GAEG;AACH;EACE,0BAA0B;AAC5B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,QAAQ;EACR,SAAS;EACT,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,aAAa;EACb,OAAO;EACP,QAAQ;EACR,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,wCAAwC;EACxC,yBAAyB;EACzB,sDAAsD;AACxD;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,gBAAgB;;AAEhB;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;AACd;;AAEA,UAAU;;AAEV;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;;GAEG;AACH;EACE,gBAAgB;AAClB;;AAEA;;GAEG;;AAEH;EACE,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;EAGE,QAAQ;EACR,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;EAIE,6BAA6B;EAC7B,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;;;;GAIG;;AAEH;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;AACd;;AAEA;;;GAGG;;AAEH;EACE,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;;EAEE,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,SAAS;EACT,gCAAgC;EAChC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;EACzB,+BAA+B;EAI/B,YAAY;AAHd;;AAMA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,SAAS;EACT,OAAO;EACP,SAAS;EACT,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAIhC,WAAW;EACX,WAAW;AAJb;;AAOA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,wEAAwE;AAC1E;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;;;;;;GASG;;AAEH;EACE,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,gCAAgC;EAChC,oCAAoC;EACpC,YAAY;AACd;;AAEA;EAEE,8BAA8B;EAC9B,sBAAsB;EACtB,6CAA6C;EAC7C,0BAA0B;EAC1B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;EAC/B,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,6CAA6C;EAC7C,oBAAoB;EACpB,2BAA2B;EAC3B,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;GAGG;;AAEH;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,YAAY;;AAEZ;;;GAGG;;AAEH;EACE,eAAe;EACf,QAAQ;EACR,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,oCAAoC;EAIpC,WAAW;EACX,WAAW;EAIX,kBAAkB;AARpB;;AAWA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gBAAgB;;AAEhB,gBAAgB;AAChB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;EACE;IACE,qBAAqB;EACvB;;EAEA;;KAEG;EACH;IACE,WAAW;EACb;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;;GAEG;AACH;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;GAMG;;AAEH;;GAEG;;AAEH;;;GAGG;AACH;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;GAEG;;AAEH;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;;;;;;;;;;;;;;;GAoBG;;AAEH;EACE,UAAU;AACZ;;AAEA;;GAEG;AACH;EACE,kBAAkB;AACpB;;AAEA;;GAEG;AACH;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;AACd;;AAEA;;GAEG;AACH;;EAEE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;GAIG;AACH;;;GAGG;AACH;;GAEG;AACH;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,+BAA+B;AACjC;;AAEA;;GAEG;;AAEH;EACE,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;;;;;;GAQG;;AAEH;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;EACjB,mCAAmC;EACnC,WAAW;EACX,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;;;GAGG;AACH;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,sBAAsB;;AAEtB,gDAAgD;AAChD;;;;;GAKG;;AAEH;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA,sBAAsB;;AAEtB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,2CAA2C;EAC3C,aAAa;AACf;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,YAAY;EACZ,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EAIf,YAAY;AACd;;AAEA;;;EAGE,QAAQ;EACR,eAAe;EACf,uBAAuB;AACzB;;AAEA;;GAEG;AACH;EACE,wCAAwC;AAC1C;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;;;;GAKG;;AAEH;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;;;GAGG;;AAEH;EACE,WAAW;EACX,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EAEtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EAEvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,YAAY;;AAEZ;;GAEG;;AAEH;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;;EAEtB,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;GAGG;;AAEH;EACE,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iLAAiL;EACjL,sBAAsB;EACtB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;GAEG;;AAEH;EACE,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;GAGG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;;EAEvB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,QAAQ;EACR,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,QAAQ;EACR,SAAS;EACT,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;wBACsB;EACtB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA,0BAA0B;;AAE1B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,6BAA6B;EAC7B,uBAAuB;EACvB,aAAa;EACb,4BAA4B;EAC5B,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;;EAElB,8BAA8B;EAC9B,6BAA6B;EAC7B,0DAA0D;EAC1D,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;GAGG;;AAEH;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;;;EAIE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;AACb;;AAEA;;;;;GAKG;;AAEH;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,UAAU;AACZ;;AAEA;;;;;;;;;;;GAWG;;AAEH,kBAAkB;;AAElB;;;EAGE,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;;GAEG;;AAEH;EACE,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,kBAAkB;;AAElB;;GAEG;;AAEH;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EACd,0BAA0B;;EAE1B,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,kBAAkB;EAClB,mBAAmB;;EAEnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EAEE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;;;;;;;GAOG;;AAEH;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;;;GAGG;;AAEH;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;GAIG;;AAEH;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA;;;;;GAKG;;AAEH;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;;GAIG;AACH;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV;;0BAEwB;AAC1B;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,kBAAkB;;EAElB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EAEtB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;AACA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,WAAW;EACX,+BAA+B;EAC/B,YAAY;AACd;AACA;;GAEG;;AAEH;EACE,eAAe;EACf,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;EACzB,sDAAsD;EACtD,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;;EAEhB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;;;;;EAKE;;AAEF;;;;;;GAMG;;AAEH;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,YAAY;;EAEZ,uBAAuB;EACvB,mBAAmB;EACnB,mEAAmE;EACnE,eAAe;EAIf,iEAAiE;AACnE;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB;qCACmC;EAInC,0BAA0B;EAI1B,uCAAuC;AACzC;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EAId,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,2CAA2C;AAC7C;AACA;EACE,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,qCAAqC;EACrC,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,uFAAuF;AACzF;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAI1C,gEAAgE;EAIhE,+BAA+B;AACjC;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,qBAAqB;;EAErB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAI3C,4DAA4D;AAC9D;AACA;EACE,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;EACvC,iCAAiC;EACjC,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;AACA;;;;GAIG;AACH;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;;;;;;;;;;GAUG;;AAEH;EACE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,SAAS;EACT,6BAA6B;EAC7B,aAAa;EACb,wCAAwC;EACxC,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,cAAc;EACd,oBAAoB;EACpB,WAAW;EACX,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;AACA;EACE,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,WAAW;EACX,cAAc;AAChB;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EAKE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AAJf;AAMA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA,cAAc;;AAEd;EACE,eAAe;EACf,gBAAgB;;EAEhB,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,SAAS;EACT,QAAQ;AACV;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;;;;;;;;;;GAUG;;AAEH;;;;;;;;;;GAUG;;AAEH;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,kBAAkB;AAC/C;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,sCAAsC;AACxC;AACA,2CAA2C;AAC3C;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,wBAAwB;;EAExB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA,gCAAgC;;AAEhC;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qDAAqD;EACrD,yBAAyB;EACzB,wBAAwB;EACxB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,4BAA4B;EAC5B,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,oCAAoC;EACpC,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,oCAAoC;EACpC,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;GAEG;;AAEH;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,gBAAgB;;AAEhB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;AACZ;;AAEA;;;GAGG;;AAEH;;;;;;;;;;;;;;GAcG;;AAEH;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,wBAAwB;;EAExB,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,uBAAuB;;EAEvB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA,mBAAmB;;AAEnB;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;;GAEG;;AAEH;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EAGE,gBAAgB;EAWhB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,gBAAgB;AAXlB;;AAcA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;;;;GAIG;;AAEH;EACE,wBAAwB;EACxB,wBAAwB;EACxB,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA,mBAAmB;;AAEnB;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EAEnB,2BAA2B;EAC3B,yCAAyC;EACzC,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,+BAA+B,EAAE,4BAA4B;EAC7D,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,2CAA2C;EAC3C,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C","sourcesContent":["body {\n  font-family: Poppins;\n}\n.tablepreper {\n  display: flex;\n  justify-content: center;\n  background-color: #e1e1e1;\n  padding: 50px 0px;\n}\n/* Custom CSS for the table */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n.loading-spinner {\n  border: 8px solid rgba(0, 0, 0, 0.1);\n  border-left-color: #7986cb;\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\np {\n  margin-top: 20px;\n  font-size: 18px;\n}\n.custom-table {\n  width: 80%;\n  border-collapse: collapse;\n}\n\n.custom-table th,\n.custom-table td {\n  padding: 8px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n\n.custom-table th {\n  background-color: #f2f2f2;\n}\n\n.custom-table tbody tr:hover {\n  background-color: #f2f2f2;\n}\n\n.custom-table tbody tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.custom-table a {\n  color: blue;\n  text-decoration: none;\n}\n\n.custom-table a:hover {\n  text-decoration: underline;\n}\n\n@media (min-width: 320px) and (max-width: 420px) {\n  .slider-image-div img {\n    height: 400px !important;\n    object-fit: cover !important;\n    padding: 0px 10px;\n  }\n  .slider-image-div {\n    height: auto;\n    padding: 0 0px !important;\n  }\n  .socialmediagridicon {\n    display: grid !important;\n  }\n\n  .graph-newdesign11 {\n    display: flex;\n    margin-left: 11px !important;\n  }\n\n  .graph-newdesign11 {\n    display: flex;\n    margin-left: 11px !important;\n  }\n}\n\n@media (min-width: 320px) and (max-width: 767px) {\n  .main-vediopage {\n    display: block !important;\n  }\n\n  .vediopage {\n    width: 100% !important;\n  }\n\n  .socialmediagridicon {\n    /* display: flex !important; */\n    justify-content: center !important;\n  }\n\n  p.dataTitle {\n    font-size: 16px !important;\n  }\n\n  .form-outline.mb-2 {\n    height: 80px !important;\n  }\n\n  p.Subscription {\n    font-size: 18px !important;\n  }\n\n  .homepagepay {\n    background: #42c1f4 !important;\n    padding-bottom: 12px !important;\n  }\n\n  .auth-divide-section {\n    display: block !important;\n  }\n\n  .Registerpage {\n    margin: 0px 20px !important;\n  }\n\n  .forgotpage {\n    margin: 0px 20px !important;\n  }\n  .spaceonright {\n    left: 40% !important;\n    top: 90% !important;\n  }\n\n  select.custom-select.custom-select-sm.form-control.form-control-sm {\n    width: 80% !important;\n  }\n\n  .tobtext {\n    top: 30% !important;\n  }\n\n  table {\n    border-collapse: collapse !important;\n    width: 100% !important;\n  }\n  .dataTable td {\n    font-size: 11px !important;\n  }\n\n  /* .table-responsive {\n  margin: 130px 0 0;\n  font-family: \"Figtree\", sans-serif;\n} */\n\n  input.form-control.form-control-sm.ml-0.my-1 {\n    max-width: auto !important;\n    height: 45px !important;\n    float: none !important;\n  }\n\n  .dataTable th {\n    font-size: 12px !important;\n    padding: 10px 10px !important;\n  }\n\n  .thanktexthome.userlist {\n    padding: 0px 10px !important;\n  }\n\n  img.logo-dashboard {\n    width: 110px !important;\n  }\n\n  .rounded-border-contnet {\n    width: 40px !important;\n    height: 40px !important;\n  }\n\n  img.imgPro {\n    width: 16px !important;\n  }\n\n  p.count {\n    font-size: 13px !important;\n  }\n\n  .heading h1 {\n    font-size: 23px !important;\n    margin-bottom: 12px !important;\n  }\n\n  .elementor-widget-container {\n    font-size: 22px !important;\n  }\n  .spaceonright {\n    margin-top: 90px !important;\n    /* padding-bottom: 12px !important; */\n    /* display: flex;\n    align-items: center;\n    justify-content: center !important;\n    text-align: center; */\n  }\n  .logo-m img {\n    max-width: 120px !important;\n    margin: 0 auto !important;\n  }\n  .container-text {\n    width: 100% !important;\n  }\n  .mobl {\n    display: block !important;\n  }\n  .topdiv {\n    overflow: unset !important;\n  }\n  .logo-m {\n    display: block !important;\n  }\n  .togglediv {\n    display: flex;\n    padding: 0 20px;\n  }\n\n  .logo-m {\n    width: 100%;\n  }\n  button.togglebtn {\n    display: block !important;\n  }\n  .logomenu {\n    width: 100% !important;\n    display: block !important;\n    padding: 0 !important;\n  }\n  .logomenu li {\n    padding: 10px 0 !important;\n    border-bottom: 1px solid #dddd !important;\n  }\n  .scrolled .logonavbar {\n    position: absolute !important;\n  }\n  .newlogo {\n    width: 150px;\n    display: none;\n  }\n  .mobl .newlogomenu {\n    position: absolute;\n    background: #000;\n    width: 230px;\n    z-index: 9999;\n    top: 30px;\n    left: 20px;\n    padding: 0 10px;\n  }\n  .logonavbar {\n    width: 200px !important;\n    padding: 20px 10px;\n    z-index: 999;\n    border-top: unset !important;\n    margin-top: 34px !important;\n    background: #000;\n    display: none;\n  }\n  p.emailtext {\n    display: none;\n  }\n  .oneinputtitle {\n    margin-top: 0 !important;\n  }\n\n  .Data-plotting {\n    display: block !important;\n  }\n  .Data-plotting .graphplot {\n    width: 100% !important;\n  }\n  .graphdetail {\n    width: 100% !important;\n  }\n  .graphdetail > div {\n    margin-top: 0 !important;\n    display: unset !important;\n  }\n  .icondown {\n    margin-left: 5px !important;\n    margin-top: 10px !important;\n    float: unset !important;\n    display: unset !important;\n  }\n  .select-steps-contnet {\n    font-size: 16px !important;\n  }\n  .clusterPlot141 {\n    display: block !important;\n  }\n  button.i-contnet-btn {\n    border-radius: 100% !important;\n    width: 30px !important;\n    height: 30px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    margin-left: 5px !important;\n  }\n\n  .confidenceContainer {\n    display: block !important;\n    margin-left: -9px !important;\n  }\n\n  .confidence {\n    width: 97% !important;\n    margin-left: 0 auto !important;\n  }\n\n  .clusterPlot.clusterPlot141 {\n    width: 97% !important;\n    margin-left: 10px !important;\n  }\n\n  .clustergraph svg.recharts-surface {\n    margin-top: 16px !important;\n    height: auto !important;\n  }\n\n  .oneinputtitle.select-method {\n    margin-top: 13px !important;\n  }\n\n  .dataresult {\n    display: block !important;\n    margin-bottom: 12px !important;\n  }\n\n  .datashow {\n    width: 100% !important;\n    margin-bottom: 18px !important;\n  }\n\n  .result {\n    width: 100% !important;\n  }\n\n  .Data-plotting {\n    margin-left: 0 !important;\n  }\n\n  /* .Data-plotting .graphplot {\n  width: auto !important;\n} */\n\n  /* .recharts-wrapper {\n    width: 270px !important;\n  } */\n\n  p.dataTitle.preprosesing-cont {\n    margin-top: 40px !important;\n  }\n\n  p.dataTitle.confidence-cont {\n    margin-top: 46px !important;\n  }\n\n  label.select-toggle-btn {\n    font-size: 12px !important;\n  }\n\n  h2.number-lenght.text-red-800 {\n    margin-bottom: 21px !important;\n  }\n\n  .straoght-border {\n    margin-left: -4px !important;\n\n    margin-top: -11px !important;\n  }\n  .straoght-border {\n    width: 65px !important;\n\n    margin-left: -10px !important;\n  }\n\n  h2.number-lenght.text-red-800 {\n    display: flex !important;\n    justify-content: center !important;\n  }\n\n  h2.number-lenght.text-red-800 {\n    width: 40px !important;\n  }\n  .Services1 {\n    width: 100% !important;\n  }\n  .allServices {\n    display: block !important;\n  }\n  .Services {\n    background-size: cover !important;\n  }\n  .Services-top .grid {\n    display: unset !important;\n  }\n  .Services-top {\n    padding: 0 30px !important;\n  }\n\n  .changing-content {\n    font-size: 22px !important;\n\n    line-height: inherit !important;\n  }\n  .test-1 {\n    font-size: 13px !important;\n  }\n  h1.Servicestitle {\n    font-size: 24px !important;\n    text-align: center !important;\n  }\n  h1.Contacttitle {\n    font-size: 24px !important;\n    text-align: center !important;\n  }\n  .Contactsecdiv-text {\n    width: 100% !important;\n    display: unset !important;\n  }\n  h2.contactlink {\n    font-size: 18px !important;\n\n    margin: 0px 0 30px !important;\n    text-align: center !important;\n  }\n  .Services-icon {\n    margin: 5px auto 2px !important;\n    transform: rotate(90deg) !important;\n  }\n  .footer {\n    display: block !important;\n  }\n  .topdiv {\n    height: auto !important;\n  }\n  .Contactsecdiv {\n    display: block !important;\n    margin: 30px 0 !important;\n  }\n  .Contactsecdiv-img {\n    width: 100% !important;\n  }\n  .tobtext h1 {\n    font-size: 18px !important;\n    padding: 0 20px !important;\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 767px) and (max-width: 1170px) {\n}\n\n.loginRight .loginsigin li {\n  list-style: none;\n}\n.topdiv {\n  height: auto !important;\n}\n/* .elementor-widget-container {\n\n  font-size: 32px !important;\n  \n} */\n/* .changing-content {\n  font-size: 32px !important;\n} */\n.Services-top {\n  padding: 0 15px !important;\n}\n.Services1 {\n  padding: 10px 10px !important;\n}\n.tobtext h1 {\n  font-size: 30px;\n  padding: 0 20px !important;\n}\n.bgCo {\n  background: #42c1f4 !important;\n}\n\n.loginRight {\n  position: absolute;\n  background: #fff;\n  width: 150px;\n  box-shadow: 0px 13px 18px #eee;\n  padding: 20px;\n  right: 0;\n  top: 98px;\n  border-top: 4px solid #1acb1a;\n  border-radius: 4px 3px 0px 0px;\n}\n\n.drop_down_open {\n  cursor: pointer;\n}\n\n.home_active .Header-main-div {\n  position: absolute;\n  top: 0;\n  z-index: 9999;\n  left: 0;\n  right: 0;\n  background: transparent !important;\n}\n\n.home_active {\n  position: relative;\n}\n\n.active-header-info {\n  border-bottom: 2.5px solid #1e40af;\n  color: #000 !important;\n  font-weight: 500;\n  padding: 0px 0px 8px 0px;\n}\n\nimg.HomeimgSize {\n  width: 100%;\n  max-width: 40px;\n  padding: 6px 0px;\n}\n\n.active > .page-link,\n.page-link.active {\n  z-index: 3;\n  color: var(--bs-pagination-active-color);\n  background-color: #0746a5;\n  border-color: var(--bs-pagination-active-border-color);\n}\n\n.first-tab,\n.second-tab,\n.third-tab {\n  padding: 3px 0px;\n}\n\n.blogs_forms {\n  width: 100%;\n  max-width: 600px;\n}\n\n/* css dec 14  */\n\n.toggle-data-main {\n  display: none;\n}\n\n.contactuspage {\n  margin: 0 0 10px;\n}\n\n.menu-icon,\n.cross-icon {\n  color: white;\n}\n\n/* SWAL  */\n\n.errorAlert .swal-text,\n.errorAlert-login .swal-text {\n  color: #d14f4f;\n}\n\n.successAlert .swal-text,\n.successAlert-login .swal-text {\n  color: #59cf65;\n}\n\n.swal-button--danger {\n  background-color: #e64942 !important;\n  width: 86px !important;\n}\n\n.swal-button--cancel {\n  color: #555;\n  background-color: #efefef;\n  width: 86px !important;\n  border: none;\n  outline: none;\n}\n\n.swal-text {\n  text-align: center;\n  font-family: \"Figtree\", sans-serif;\n}\n\n/* .swal-icon:first-child {\n  margin-top: 55px;\n} */\n.swal-icon:first-child {\n  margin-top: 27px;\n}\n\n/* .swal-icon:first-child {\n  margin-top: 45px;\n} */\n\n.swal-icon {\n  margin: 10px auto;\n}\n\n.errorAlert .swal-title,\n.errorAlert-login .swal-title {\n  color: #d14f4f;\n  font-family: \"Figtree\", sans-serif;\n  letter-spacing: 0.5px;\n}\n\n.warningAlert .swal-title,\n.warningAlert-login .swal-title {\n  color: #d99836;\n  font-family: \"Figtree\", sans-serif;\n  letter-spacing: 0.5px;\n}\n\n.successAl1ert .swal-title,\n.successAlert-login .swal-title {\n  color: #59cf65;\n  font-family: \"Figtree\", sans-serif;\n  letter-spacing: 0.5px;\n}\n\n.swal-modal .swal-text {\n  color: #49454f;\n  font-family: \"Figtree\", sans-serif;\n  letter-spacing: 0.25px;\n  margin-top: 0px;\n}\n\n.swal-title {\n  padding: 0px 16px !important;\n  font-size: 16px !important;\n}\n\n.swal-footer {\n  text-align: center !important;\n}\n\n.css-1qqsdnr-MuiAutocomplete-root\n  .MuiAutocomplete-inputRoot\n  .MuiAutocomplete-input {\n  width: 0;\n  min-width: 30px;\n  max-height: 12px !important;\n}\n\n.css-1qqsdnr-MuiAutocomplete-root .MuiOutlinedInput-root {\n  height: 40px !important;\n}\n\n.eventSearchbar\n  .css-1qqsdnr-MuiAutocomplete-root\n  .MuiOutlinedInput-root\n  .MuiAutocomplete-input {\n  padding: 12px 15px !important;\n  outline: none !important;\n  border-radius: 0 !important;\n}\n\nsvg.MuiSvgIcon-root.MuiSvgIcon-fontSizeSmall.css-ptiqhd-MuiSvgIcon-root {\n  background: #1e40af;\n  color: white !important;\n  font-weight: bolder !important;\n  border-radius: 33px !important;\n  width: 25px !important;\n  height: 25px !important;\n  margin: -3px -5px !important;\n}\n\n/* .swal-icon img {\n  max-width: 100%;\n  max-height: 100%;\n  display: unset;\n} */\n\n.swal-icon img {\n  max-width: 100%;\n  max-width: 60px !important;\n  max-height: 100%;\n  display: unset;\n}\n\n.swal-footer {\n  text-align: right;\n  padding-top: 13px;\n  margin-top: 0 !important;\n  padding: 13px 16px;\n  border-radius: inherit;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.table-responsive {\n  margin: 40px 0 0;\n  font-family: \"Figtree\", sans-serif;\n}\n\n.table > :not(:first-child) {\n  border-top: 0 !important;\n}\n\n.dataTable td {\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.dataTable tr td:nth-child(2) {\n  align-items: center;\n  /* padding-top: 12px; */\n  padding-left: 10px;\n  /* padding-bottom: 10px; */\n  text-align: center;\n  height: 44px;\n}\n\n.dataTable tr td:nth-child(1) {\n  align-items: center;\n  /* padding-top: 12px; */\n  padding-left: 11px;\n  /* padding-bottom: 10px; */\n  text-align: center;\n  height: 44px;\n}\n\n/* .dataTable tr:nth-child(2n + 2) {\n  background: rgba(36, 114, 252, 0.08);\n  font-family: poppins !important;\n} */\n\n.dataTable tr:nth-child(2n + 2) {\n  background: rgb(148 142 209 / 37%);\n  font-family: poppins !important;\n}\n\n.dataTable\n  button.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.MuiButtonBase-root.deletebutt.css-1e6y48t-MuiButtonBase-root-MuiButton-root {\n  margin: 0 !important;\n  min-width: auto !important;\n}\n\n.dataTable a:hover {\n  background: none;\n}\n\n.table > thead {\n  vertical-align: bottom;\n  background: rgb(136 121 201 / 82%);\n}\n\n.col-sm-12.col-md-6 {\n  display: unset !important;\n  font-family: poppins !important;\n}\n\n.col-md-6 {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.savebtn {\n  width: 160px !important;\n  height: 47px;\n  grid-gap: 10px;\n  gap: 10px;\n  background: #2472fc00 !important;\n  font-size: 16px !important;\n  font-family: \"Figtree\", sans-serif;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px !important;\n  border: 1px solid #084ec5;\n  font-family: poppins !important;\n}\n\n.savebtn {\n  float: right;\n}\n\n.dataTable th {\n  font-size: 16px;\n  padding: 8px 25px;\n  font-weight: 700;\n  color: #000;\n  font-family: \"poppins\", sans-serif !important;\n}\n\n.table-bordered > :not(caption) > * > * {\n  border-width: 0 !important;\n}\n\n.table-bordered > :not(caption) > * {\n  border-width: 0px 0;\n}\n\n.homepagepay.usr {\n  background: #42c1f4;\n  padding-bottom: 35px;\n}\n.table-striped > tbody > tr:nth-of-type(odd) > * {\n  --bs-table-accent-bg: rgb(255 255 255);\n  color: var(--bs-table-striped-color);\n  font-family: poppins !important;\n}\n\n.css-1d3z3hw-MuiOutlinedInput-notchedOutline {\n  text-align: left;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  top: -5px;\n  left: 0;\n  margin: 0;\n  padding: 0 8px;\n  pointer-events: none;\n  border-radius: inherit;\n  border-style: solid;\n  border-width: 1px;\n  overflow: hidden;\n  min-width: 0%;\n}\n\nthead[data-test=\"table-foot\"] {\n  display: none;\n}\n\nselect.custom-select.custom-select-sm.form-control.form-control-sm {\n  height: 44px;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.bs-select select {\n  display: inline-block !important;\n}\n\n.bs-select select {\n  float: left;\n  width: 100%;\n}\n\n.form-control-sm {\n  min-height: calc(1.5em + 0.5rem + 2px);\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  border-radius: 0.25rem;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  appearance: none;\n  border-radius: 0.375rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.custom-select-sm {\n  margin: 0 !important;\n  height: 50px;\n  width: 150px;\n  border-radius: 8px;\n}\n\n/* input.form-control.form-control-sm.ml-0.my-1 {\n  height: 47px;\n  margin: 0 11px;\n  max-width: 335px;\n  border-radius: 8px;\n  display: flex;\n  align-items: flex-end !important;\n  justify-content: flex-end !important;\n  float: right;\n} */\n\ninput.form-control.form-control-sm.ml-0.my-1 {\n  height: 34px;\n  /* margin: 0 11px; */\n  max-width: 335px;\n  /* border-radius: 8px; */\n  display: flex;\n  align-items: flex-end !important;\n  justify-content: flex-end !important;\n  float: right;\n}\n\nbutton.MuiButtonBase-root.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.close_btn.css-1e6y48t-MuiButtonBase-root-MuiButton-root {\n  margin-right: 23px;\n  background: #2472fc !important;\n  color: #fff !important;\n  font-family: \"Figtree\", sans-serif !important;\n  font-size: 16px !important;\n  border-radius: 4px !important;\n  margin-right: 16px !important;\n  padding: 6px 25px !important;\n  margin: 0px 16px 0 0 !important;\n  text-transform: capitalize !important;\n  width: 107px;\n}\n\nbutton.MuiButtonBase-root.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.submit_block.css-1e6y48t-MuiButtonBase-root-MuiButton-root {\n  border: 2px solid #2472fc;\n  border-radius: 4px;\n  padding: 4px 25px;\n  color: #2472fc;\n  font-family: \"Figtree\", sans-serif !important;\n  text-transform: none;\n  font-weight: 600 !important;\n  font-size: 16px !important;\n  width: 107px;\n  background: none;\n}\n\n/* h2#\\:r1\\: {\n  border-bottom: 1px solid rgb(204, 194, 194);\n  padding: 10px 30px;\n} */\n\nselect.active_blockinput {\n  width: 100%;\n  border: 1px solid;\n  padding: 7px 13px;\n  font-size: 19px;\n  font-weight: 62%;\n  height: 50px;\n  border-radius: 4px;\n}\n\n/* DEC 15  */\n\n/* .toggle-data-main {\n  position: absolute;\n  top: 23px;\n} */\n\n.logout-section {\n  position: fixed;\n  top: 50%;\n  right: 0;\n  background: #3bd56a;\n  padding: 14px;\n  border-radius: 50%;\n  z-index: 11111;\n}\n\n.swal-modal {\n  max-width: 348px;\n  background-color: #fff;\n  min-width: 340px;\n  border-radius: 8px;\n  box-shadow: 3px 4px 5px 1px #00000080;\n  height: auto;\n}\n\n/* Dec 16  */\n.contact-email-logo {\n  background: #3730a3;\n  font-size: 15px;\n  color: #fff;\n  border-radius: 50px;\n  padding: 15px;\n}\n\n.log-out-icon {\n  color: #fff;\n  padding: 5px 7px 0 0;\n}\n\n.profile_dialog-box\n  .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation24.MuiDialog-paper {\n  width: 100%;\n  min-width: 950px;\n  height: 100%;\n  min-height: 600px;\n}\n\ni.fa-solid.fa-xmark {\n  float: right;\n}\n\nbutton.add-event-btn {\n  color: blue;\n  border: 1px solid blue;\n  border-radius: 4px;\n  font-size: 13px;\n  padding: 6px;\n}\n\nbutton.remove-event-btn {\n  color: red;\n  border: 1px solid red;\n  border-radius: 4px;\n  font-size: 13px;\n  padding: 6px;\n}\n\n/* side bar icon css0 */\nimg.iconimage-path {\n  max-width: 30px;\n}\n\nspan.ml-3.flex-1.whitespace-nowrap {\n  /* font-size: 18px; */\n  font-weight: 400;\n}\n\n/* 20 Dec 2022 */\n.Topdiv {\n  background: rgba(36, 114, 252, 0.06);\n}\n\n.Topdiv {\n  width: 100%;\n  float: left;\n}\n\n.Topdiv {\n  position: relative;\n}\n\n.verifydiv {\n  background: rgba(36, 114, 252, 0.06);\n}\n\n.verifyemail {\n  max-width: 600px;\n}\n\n.login-content {\n  max-width: 380px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  width: 90%;\n}\n\n.verifylogo {\n  text-align: center;\n}\n\nimg.login-logo {\n  max-width: 200px;\n  display: unset;\n}\n\n.verifyemailtext {\n  text-align: center;\n}\n\n.verifyemailtext h1 {\n  padding: 17px 0 12px;\n}\n\na.successfullyButton {\n  padding: 10px;\n  color: #1e22aa;\n  text-transform: capitalize;\n  font-size: 16px;\n  width: 160px;\n  display: inline-block;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 47px;\n  border-radius: 8px;\n  margin: 31px auto 0;\n  border: 1px solid #1e22aa;\n}\n\n.thankyoupage {\n  background: rgba(36, 114, 252, 0.06);\n}\n\n.login-content-registering {\n  max-width: 500px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  width: 90%;\n}\n\n.thanktext {\n  padding: 25px;\n  width: 100%;\n  border: 1px solid #0d6efd00;\n  border-radius: 8px;\n  box-shadow: 0px 1px 5px #0d6efd45;\n  background: #fff;\n}\n\n.logo-content {\n  text-align: center;\n  margin: 10px 0 20px;\n}\n\n.thanktext p {\n  line-height: 28px;\n  text-align: center;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n/* 20 Dec 2022 */\n\n/* 21 Dec 2022 */\n.login-links a {\n  color: #4338ca;\n}\n\n.login-links.last-link a {\n  color: #c74646;\n  margin-top: 20px;\n}\n\nul.navbar-link-items {\n  display: flex;\n  justify-content: center;\n  align-items: baseline;\n}\n\n.blog-item.first {\n  border-top: 0px solid;\n  padding-top: 0;\n}\n\n.blog-item {\n  border-top: 2px solid #ddd;\n  padding-top: 15px;\n}\n\n/* .container.fighting-imges {\n  max-width: 1180px;\n} */\n\n@media (min-width: 1550px) and (max-width: 1900px) {\n  img.fight-finder-ligo {\n    width: 80% !important;\n  }\n\n  /* .box-div {\n    padding: 119px;\n  } */\n  .container.absolute.top-50.text-center {\n    left: 12rem;\n  }\n}\n\n.grop-box-content.relative.flex.flex-col.items-start.px-6.bg-white.border.border-t-0.border-gray-200.py-7.rounded-b-2xl {\n  min-height: 70%;\n}\n\nh1.empty-data {\n  font-size: 24px;\n  text-align: center;\n  color: black;\n  padding: 54px 10px;\n  text-transform: uppercase;\n}\n\n.event-dataimg img {\n  float: left;\n  margin-right: 15px;\n  margin-bottom: 2px;\n}\n\n.eventimg-contnet img {\n  height: 100%;\n}\n\n.eventimg-contnet {\n  height: 240px;\n  overflow: hidden;\n}\n\n.heading-contnet-fight {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 11%;\n  top: 0 !important;\n  width: 100%;\n}\n\n.focus\\:ring-4:focus {\n  box-shadow: unset;\n}\n\niframe.map_image {\n  height: 400px;\n}\n\n/* .related-blogs-contnet {\n  float: left;\n} */\n.fontsize20 {\n  font-size: 24px;\n  font-weight: bold;\n}\n\ninput.form-control.input-groups {\n  border-radius: 50px 0px 0px 50px;\n}\n\n.search_bar .form-control:focus {\n  box-shadow: unset;\n}\n\n.search_bar button:hover {\n  background: #060692;\n}\n\n/* \n.Home-events-img {\n  height: 410px;\n}\n.Home-events-img.relative img {\n  height: 100%;\n} */\n\n/* .Home-events-actives {\n  height: 440px !important;\n} */\n\n/* .Home-events-actives img {\n  height: 100%;\n  width: 100%;\n} */\n.fighter-images-events1 {\n  height: 400px;\n  overflow: hidden;\n}\n\n.fighter-images-events1 img {\n  width: 100%;\n  height: 400px;\n  object-fit: cover;\n}\n\n.Home-events-img-contnet {\n  height: 410px;\n  width: 100%;\n}\n\n.Home-events-img-contnet img {\n  height: 100%;\n  width: 100%;\n}\n\n.eventimg-contnet img {\n  width: 100%;\n}\n\n.dataTable tr td:nth-child(3) {\n  align-items: center;\n  /* padding-top: 12px; */\n  padding-left: 10px;\n  /* padding-bottom: 10px; */\n  text-align: center;\n  height: 44px;\n}\n\n.dataTable tr td:nth-child(4) {\n  align-items: center;\n  /* padding-top: 12px; */\n  padding-left: 10px;\n  /* padding-bottom: 10px; */\n  text-align: center;\n  height: 44px;\n}\n\n.dataTable tr td:nth-child(5) {\n  align-items: center;\n  /* padding-top: 12px; */\n  padding-left: 10px;\n  /* padding-bottom: 10px; */\n  height: 44px;\n}\n\n.dataTable tr td:nth-child(7) {\n  align-items: center;\n  /* padding-top: 12px; */\n  padding-left: 10px;\n  /* padding-bottom: 10px; */\n  height: 44px;\n}\n\n.box-div.bg-blue-800.py-8.pb-5.px-3.my-4.transition.ease-in-out.delay-150.hover\\:-translate-y-1.hover\\:scale-70.hover\\:bg-blue-500.duration-300.hover\\:text-white.w3-animate-zoom.ease-in {\n  height: 193px;\n}\n\n.welcome-event-home {\n  top: 30% !important;\n  font-family: \"Rajdhani\", sans-serif;\n  left: 30px;\n}\n\n.welcome-event-home11 {\n  top: 25% !important;\n  font-family: \"Rajdhani\", sans-serif;\n  left: 30px;\n}\n\nbutton.blog-btn.bg-blue-800.hover\\:bg-blue-700.text-white.uppercase {\n  font-size: 12px;\n  width: 60px;\n  padding: 3px;\n  border-radius: 3px;\n  margin-right: 17px;\n  letter-spacing: 2px;\n  font-weight: 500;\n  font-family: \"Rajdhani\";\n}\n\n.not-fount-data {\n  font-size: 27px;\n  color: black;\n  text-align: center !important;\n  width: 100%;\n}\n\n.not-fount-data_content {\n  text-align: center;\n  font-size: 25px;\n  color: black;\n}\n\n.fight-finder-header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 99;\n  transition: all 0.3s ease-out 0s;\n  padding: 24px;\n  background-color: white;\n  font-family: poppins !important;\n}\n\n/* 9-01-2023 */\n.userpage {\n  background: #fff;\n  width: 97%;\n  margin: 0px auto;\n  padding: 40px;\n  border-radius: 8px;\n}\n\n.SelectEventTypeDiv .MuiInputBase-root.MuiOutlinedInput-root {\n  width: 100%;\n}\n\n.SelectEventTypeDiv h1 {\n  margin-bottom: 10px;\n}\n\n.UserdetailsEventsDiv h1 {\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  margin-top: 20px;\n}\n\n.eventTitleInput {\n  width: 100%;\n  height: 48px;\n  padding: 0 10px;\n  background: #fff;\n  border: 1px solid #ddd;\n  /* margin-bottom: 10px; */\n  border-radius: 8px;\n  margin-top: 5px;\n}\n\n.SelectEventTypeDiv\n  .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {\n  padding: 11px 14px;\n}\n\n.SelectEventTypeDiv .MuiOutlinedInput-notchedOutline {\n  border-color: #ddd;\n  border-radius: 8px;\n}\n\n.AgeEventsDiv h4 {\n  margin-bottom: 4px;\n}\n\n.AgeEventsDiv\n  .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary {\n  width: 100%;\n  margin-bottom: 19px;\n}\n\n.AgeEventsDiv .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input {\n  padding: 12px 14px;\n}\n\nfieldset.MuiOutlinedInput-notchedOutline {\n  border-color: #ddd;\n  border-radius: 8px;\n}\n\n.CompLevelEventsDiv h4 {\n  margin-bottom: 6px;\n}\n\n.CompLevelEventsDiv\n  .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary {\n  width: 100%;\n  margin-bottom: 19px;\n}\n\n/* .SelectEventTypeDiv {\n  margin: 0 !important;\n} */\n\n.countryEventsDiv h4 {\n  margin-bottom: 6px;\n}\n\n.EventdetailsEventsDiv h1 {\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  margin-top: 20px;\n}\n\n.EventAddAddressArea textarea.eventAddressArea {\n  width: 100%;\n  height: 200px !important;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  /* margin-bottom: 19px; */\n  margin-top: 6px;\n  padding: 6px;\n}\n\n.descrclass,\ninput.eventZipCodeInput {\n  width: 100%;\n  height: 48px;\n  padding: 0 10px;\n  background: #fff;\n  border: 1px solid #ddd;\n  /* margin-bottom: 19px; */\n  border-radius: 8px;\n  /* margin-top: 8px; */\n}\n\n.SelectEventCountryDiv h1 {\n  margin: 0 0 6px;\n}\n\n.countryEventsDiv\n  .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary {\n  width: 100%;\n}\n\n.SelectEventCountryDiv\n  .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary {\n  width: 100%;\n  margin-bottom: 19px;\n}\n\n.MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input {\n  padding: 12px 13px;\n}\n\n.taskDueDate .MuiInput-underline:before {\n  border-bottom: none;\n}\n\nlabel.taskDueDate {\n  border: 1px solid #ddd;\n  height: 57px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 200px;\n  padding: 0 10px;\n  margin: 6px 0 19px;\n}\n\n.SelectEventDateDiv .MuiInput-underline:hover:not(.Mui-disabled):before {\n  border-bottom: none;\n}\n\n.SchooldetailsEventsDiv h1 {\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 20px;\n}\n\n.OrganizerSocialEvent .css-14lo706 {\n  display: none;\n}\n\n.OrganizerSocialEvent .css-14lo706 span {\n  display: none;\n}\n\n.userform {\n  max-width: 600px;\n}\n\n.SchoolEventTimeEvent legend {\n  display: none;\n}\n\n.SchoolEventTimeEvent label {\n  display: none;\n}\n\n/* .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input {\n  font: inherit;\n  letter-spacing: inherit;\n  color: currentColor;\n  padding: 4px 0 5px;\n  border: 0;\n  box-sizing: content-box;\n  background: none;\n  height: 31px !important;\n  margin: 0;\n  -webkit-tap-highlight-color: transparent;\n  display: block;\n  min-width: 0;\n  width: 100%;\n  -webkit-animation-name: mui-auto-fill-cancel;\n  animation-name: mui-auto-fill-cancel;\n  -webkit-animation-duration: 10ms;\n  animation-duration: 10ms;\n  padding: 11px 14px 12px;\n  padding-right: 0;\n} */\n\n.SchoolEventTimeEvent .MuiInputAdornment-root.MuiInputAdornment-positionEnd {\n  padding: 0;\n}\n\n/* .SchoolEventTimeEvent input {\n  padding: 9px 11px 13px;\n} */\n.SchoolEventTimeEvent h1 {\n  margin-bottom: 6px;\n}\n\n/* .SchoolEventTimeEvent .MuiFormControl-root.MuiTextField-root {\n  margin-bottom: 20px;\n} */\n.taskDueDate .MuiFormControl-root.MuiTextField-root {\n  margin-bottom: 0;\n}\n\n.OrganizerSocialEvent h1 {\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  margin-top: 20px;\n}\n\n.EventAcceptForeignDiv {\n  margin: 0 0 20px;\n}\n\n.EventAcceptForeignDiv h1 {\n  margin: 0 0 8px;\n}\n\n.EventAcceptForeignDiv label {\n  margin: 0 10px;\n}\n\n.EventDetailsEventDiv,\n.SpecialInstEvent,\n.DateSeminarEvent {\n  margin: 0 0 0px;\n}\n\n.SubmitHandlerEventAdd button {\n  background: #1e22aa;\n  color: #fff;\n  padding: 11px 43px;\n  text-transform: uppercase;\n  font-size: 15px;\n  font-weight: bold;\n  letter-spacing: 0.3px;\n  /* margin: 15px 0 0; */\n  border: none;\n}\n\n/* .SelectEventCountryDiv input {\n   margin: 0 0 10px;\n} */\n.CostSeminarEvent,\n.EventAddZipCodeArea h4 {\n  margin-bottom: 6px;\n}\n\n.DateSeminarEvent h1 {\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 20px;\n}\n\n.SpecialInstEvent h1 {\n  margin-bottom: 8px;\n}\n\n.SpecialInstEvent textarea {\n  height: 200px !important;\n  /* margin-top: 9px; */\n  padding: 10px;\n}\n\n.EventDetailsEventDiv textarea {\n  height: 200px !important;\n  margin-top: 9px;\n  padding: 10px;\n}\n\n.CostSeminarEvent h1 {\n  margin: 0 0 6px;\n}\n\n/* .Minimumdiv {\n  display: flex;\n  margin-top: 7px;\n  width: 100%;\n} */\n/* .Minimum {\n  width: 50%;\n  margin-right: 10px;\n} */\n/* .Minimum1 {\n  width: 50%;\n} */\n.Minimumdiv h4 {\n  margin-bottom: 6px;\n}\n\n.SelectEventCountryDiv textarea {\n  height: 200px !important;\n  padding: 6px;\n}\n\ninput:focus-visible {\n  outline: none;\n}\n\ninput:focus {\n  border: 1px solid #0072ff;\n}\n\n.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-width: 1px !important;\n}\n\ntextarea:focus-visible {\n  outline: none;\n}\n\n.auth-logo-contnet {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\nimg.auth-logo {\n  width: 30% !important;\n}\n\n.auth-logo-contnet-register {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.App_import input#email {\n  font-size: 14px;\n  font-weight: 300;\n}\n\n.App_import input#password {\n  font-size: 14px;\n  font-weight: 300;\n}\n\n.login-form-fight {\n  font-family: poppins !important;\n}\n\nh1.title-font-blogs {\n  font-family: \"Rajdhani\", sans-serif;\n  font-size: 22px;\n  font-weight: 900;\n  font-style: normal;\n  line-height: 27px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: #000;\n}\n\n.post_meta {\n  margin-bottom: 15px;\n}\n\nspan.post_meta_item.post_date {\n  font-family: \"Rajdhani\", sans-serif;\n  font-weight: 700;\n}\n\np.leading-relaxed11 {\n  color: #000000e0;\n  font-size: 16px;\n  line-height: 30px;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 400;\n}\n\n.public-footer {\n  float: left;\n  width: 100%;\n  box-shadow: 1px 1px 4px #a3a3a3;\n}\n\n/* body {\n  font-family: \"Rajdhani\", sans-serif;\n} */\n\np.blog-title11.sm\\:text-xl.md\\:text-2xl.lg\\:text-2xl.xl\\:text-2xl.font-bold.text-blue-800 {\n  font-family: \"Rajdhani\", sans-serif;\n}\n\nul.footer-list-item {\n  font-family: poppins;\n}\n\n/* .achivements_button {\n  background: #1e40af;\n  color: #fff;\n  padding: 8px 20px;\n  font-weight: 500;\n  text-transform: uppercase;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 14px;\n} */\n\n.achivements_button {\n  background: #1e40af;\n  color: #fff;\n  padding: 4px 7px;\n  font-weight: 500;\n  text-transform: uppercase;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 14px;\n}\n\nh1.titelhome {\n  text-align: center;\n  padding-top: 50px;\n  color: #1e40af;\n  font-size: 38px;\n  font-weight: bold;\n}\n\nh4.fontsize56 {\n  text-align: center;\n  /* padding: 50px 0; */\n  color: #fff;\n  /* font-size: 56px; */\n  font-weight: bold;\n}\n\nh3.fontsize38 {\n  padding: 4px 0 4px;\n  color: #1e40af;\n  font-weight: bold;\n  font-family: \"Rajdhani\", sans-serif;\n}\n\nbutton.viewbtn {\n  background: #1e40af;\n  color: #fff;\n  padding: 12px 26px;\n  font-weight: 500;\n  text-transform: uppercase;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 14px;\n}\n\n.Home-events-img11 {\n  height: 370px;\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\nh4.pagetitleall {\n  text-align: center;\n  padding: 0 0 4px;\n  color: #fff;\n  font-size: 23px;\n  font-weight: bold;\n}\n\n.eventspage {\n  padding: 90px 0 30px;\n}\n\n.eventsec {\n  float: left;\n  width: 100%;\n  margin-bottom: 80px;\n}\n\n.Home-events-page {\n  width: 33.33%;\n}\n\n.eventimg {\n  height: 280px;\n  overflow: hidden;\n}\n\n.eventimg img {\n  object-fit: cover;\n  height: 100%;\n}\n\n.Home-events-page {\n  width: 32.33%;\n  margin: 5px;\n  box-shadow: 1px 1px 6px #ddd;\n  padding: 28px;\n  border-radius: 9px;\n  float: left;\n}\n\n.fighter-name2 {\n  padding: 20px 0 0;\n}\n\nspan.eventdate {\n  font-size: 18px;\n  color: #000;\n  margin-bottom: 7px !important;\n  display: inline-block;\n}\n\n.fighter-name2 h2 {\n  font-size: 24px !important;\n  font-weight: 700;\n  color: #1e40af;\n}\n\n.eventdetails {\n  float: left;\n  width: 100%;\n  padding: 30px 0 60px;\n}\n\nh2.relatedtitle {\n  text-align: center;\n  padding: 40px 0 60px;\n  color: #1e40af;\n  font-size: 38px !important;\n  font-weight: bold;\n  font-family: \"Rajdhani\", sans-serif;\n  float: left;\n  width: 100%;\n}\n\n.blogpage1 {\n  padding: 108px 0 39px;\n}\n\n.blogdetailepage {\n  padding: 50px 0 30px;\n}\n\n.commontext {\n  margin: -54px 0 20px;\n}\n\n.commontext span {\n  background: #1e40af;\n  color: #fff;\n  padding: 10px 19px;\n  font-size: 14px;\n  font-weight: 500;\n  text-transform: uppercase;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.datedetailssec {\n  background: #1e40af;\n  color: #fff;\n  padding: 10px 19px;\n  font-size: 14px;\n  font-weight: 500;\n  text-transform: uppercase;\n  font-family: \"Poppins\", sans-serif;\n}\n\nh1.blogtitledetails {\n  padding: 5px 0 14px;\n  color: #1e40af;\n  font-size: 38px;\n  font-weight: bold;\n  font-family: \"Rajdhani\", sans-serif;\n}\n\n.aboutpage {\n  padding: 50px 0;\n}\n\n.bakground {\n  background: #f7f7f7;\n  width: 100%;\n  float: left;\n}\n\nh2.titleourpage {\n  text-align: center;\n  padding: 50px 0 0;\n  color: #1e40af;\n  font-size: 38px !important;\n  font-weight: bold;\n}\n\n/* .addevent {\n  margin-top: 162px;\n  margin-bottom: 40px;\n} */\n.Relatedevents {\n  width: 100%;\n  float: left;\n}\n\n.terms-cojnn p {\n  font-size: 15px;\n  line-height: 30px;\n}\n\n.eventimg-contnet {\n  width: 100%;\n  float: left;\n}\n\n.event-dataimg {\n  float: left;\n  width: 100%;\n}\n\n.related-blogs-contnet {\n  float: left;\n}\n\n.eventsbak {\n  background-size: cover;\n  background-repeat: no-repeat;\n  opacity: 0.8;\n  padding: 24px 24px;\n  margin: 0 0 -4px;\n}\n\n.fourth-contnet-font-fam {\n  font-family: \"Poppins\";\n}\n\n/* scroll bar modify */\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n/* body {\n  overflow-y: scroll; \n}\nbody::-webkit-scrollbar {\n    display: none;\n} */\n\n::-webkit-scrollbar {\n  width: 6px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 20px !important;\n}\n\n/* scroll bar modify */\n\n.menuhome {\n  position: relative;\n}\n\n.header-sidebar-coontnet {\n  position: absolute;\n  width: 100%;\n}\n\n.MuiAutocomplete-root.MuiAutocomplete-hasClearIcon.form-control.input-groups.font-normal.rounded-md.text-gray-700.bg-white.border.border-solid.border-gray-300.css-1qqsdnr-MuiAutocomplete-root {\n  padding: 0;\n  height: 40px;\n  border: none !important;\n}\n\n.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-fullWidth.MuiInputBase-formControl.MuiInputBase-adornedEnd.MuiAutocomplete-inputRoot.css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root {\n  padding: 2px;\n  border-radius: 0 !important;\n}\n\n.MuiAutocomplete-root.form-control.input-groups.font-normal.rounded-md.text-gray-700.bg-white.border.border-solid.border-gray-300.css-1qqsdnr-MuiAutocomplete-root {\n  padding: 0 !important;\n  height: 40px !important;\n  border: none !important;\n  border-radius: 30px 0px 0px 30px !important;\n  outline: none;\n}\n\n.searchsec\n  .css-1qqsdnr-MuiAutocomplete-root\n  .MuiOutlinedInput-root\n  .MuiAutocomplete-input {\n  padding: 11px 13px !important;\n}\n\n.css-1qqsdnr-MuiAutocomplete-root .MuiOutlinedInput-root {\n  padding: 1px !important;\n}\n\nbutton#mui-p-80405-T-1 {\n  font-family: \"Rajdhani\", sans-serif !important;\n  font-weight: bold;\n}\n\n.css-nwrfgk-MuiButtonBase-root-MuiTab-root {\n  color: black !important;\n  font-weight: 500;\n  font-size: 17px !important;\n  line-height: 1.25;\n  padding: 12px 16px;\n  font-weight: bold !important;\n  font-family: \"Rajdhani\", sans-serif !important;\n}\n\n.css-1aquho2-MuiTabs-indicator {\n  background-color: #42c1f4 !important;\n  font-family: \"Rajdhani\", sans-serif !important;\n}\n\n.org-div {\n  float: left;\n  width: 100%;\n}\n\n.searchsec fieldset.MuiOutlinedInput-notchedOutline {\n  border-color: none !important;\n  border-radius: 0;\n}\n\n.searchsec .search_bar button:hover {\n  background: none !important;\n}\n\n.searchsec .MuiButtonBase-root.MuiIconButton-root.MuiIconButton-sizeMedium {\n  background: none;\n}\n\n.search_bar input:focus {\n  border: none;\n}\n\n.searchsec fieldset.MuiOutlinedInput-notchedOutline {\n  border-radius: 50px 0 0 50px !important;\n}\n\ni.fa-solid.fa-arrow-right {\n  padding: 0px 6px;\n}\n\n.lkjDVC {\n  min-width: 322px;\n  max-width: 600px !important;\n  height: 48px;\n  border: dashed 2px #0a6ae7;\n  padding: 8px 16px 8px 8px;\n  border-radius: 5px;\n  cursor: pointer;\n  -webkit-box-flex: 0;\n  -webkit-flex-grow: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n}\n\n.css-1qqsdnr-MuiAutocomplete-root\n  .MuiAutocomplete-inputRoot\n  .MuiAutocomplete-input {\n  width: 0;\n  min-width: 30px;\n  height: 31px !important;\n}\n\n/* .MuiTabs-flexContainer.css-heg063-MuiTabs-flexContainer {\n  margin-left: 25px;\n} */\n.searchsec .MuiOutlinedInput-root .MuiAutocomplete-input {\n  padding: 7.5px 4px 7.5px 20px !important;\n}\n\n/* .we .css-13xfq8m-MuiTabPanel-root {\n  padding-top: 29px !important;\n} */\n\n.about-us-content td {\n  padding: 12px;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 35px;\n  font-family: \"Poppins\";\n  width: 50% !important;\n}\n\n.about-us-content img {\n  border-radius: 14px;\n  width: 100% !important;\n}\n\n/* .about-us-content h2 {\n  font-size: 21px !important;\n  font-family: \"Rajdhani\", sans-serif;\n  text-align: center;\n  font-weight: bold;\n} */\n\n.about-us-content table {\n  border-color: #f0f8ff00 !important;\n}\n\n.font-fam-contnet {\n  font-family: \"Rajdhani\", sans-serif;\n  font-size: 16px !important;\n}\n\n.popins-font-fam {\n  font-family: poppins !important;\n  font-size: 15px !important;\n}\n\n/* .inputCntnr.error {\n  border: 2px solid #d10d0dbf;\n  border-radius: 7px;\n} */\n\ntextarea.eventTitleInput-desc {\n  width: 100%;\n  height: 200px !important;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  /* margin-bottom: 19px; */\n  margin-top: 6px;\n  padding: 6px;\n}\n\n.css-1u3bzj6-MuiFormControl-root-MuiTextField-root {\n  width: 100% !important;\n  height: 50% !important;\n}\n\n.css-nxo287-MuiInputBase-input-MuiOutlinedInput-input {\n  padding: 13px 14px !important;\n}\n\nlabel[data-shrink=\"false\"]\n  + .MuiInputBase-formControl\n  .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input {\n  padding: 10px 14px !important;\n}\n\n.blogs_forms11 {\n  width: 80% !important;\n}\n\n.switch-box {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 34px;\n}\n\n.switch-box input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider-toggle {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\n.slider-toggle:before {\n  position: absolute;\n  content: \"\";\n  height: 26px;\n  width: 26px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\ninput:checked + .slider-toggle {\n  background-color: #2164f3;\n}\n\ninput:focus + .slider-toggle {\n  box-shadow: 0 0 1px #42c1f4;\n}\n\ninput:checked + .slider-toggle:before {\n  -webkit-transform: translateX(26px);\n  -ms-transform: translateX(26px);\n  transform: translateX(26px);\n}\n\n/* Rounded sliders */\n.slider-toggle.round {\n  border-radius: 34px;\n}\n\n.slider-toggle.round:before {\n  border-radius: 50%;\n}\n\n.MuiBox-root.css-0 {\n  padding-bottom: 12px !important;\n}\n\n.css-13xfq8m-MuiTabPanel-root {\n  padding: 0 !important;\n}\n\n/* 9 march */\n\n/* .feedbackAboutAreaMainD.events-search-feed {\n  width: 80%;\n} */\n\n.css-vqmohf-MuiButtonBase-root-MuiRadio-root.Mui-checked {\n  color: #193ad2 !important;\n}\n\n.react-slideshow-container .default-nav:first-of-type {\n  margin-right: 0px !important;\n  border-right: 14;\n  border-top: 0;\n  padding: 3px 10px 3px 7px !important;\n  left: 20px !important;\n}\n\n.react-slideshow-container .default-nav:last-of-type {\n  margin-left: 0px !important;\n  right: 20px !important;\n\n  padding: 3px 10px 3px 7px !important;\n}\n\n.react-slideshow-container .default-nav {\n  height: 30px;\n  background: rgb(255 255 255 / 30%);\n  width: 30px;\n  border: 0;\n  text-align: center;\n  color: #fff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ReactCollapse--collapse {\n  transition: height 500ms;\n}\n\n/* .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation24.MuiDialog-paper.MuiDialog-paperScrollPaper.MuiDialog-paperWidthSm.css-1t1j96h-MuiPaper-root-MuiDialog-paper {\n  width: 100%;\n  height: auto;\n} */\n\n.crop-contnet {\n  height: 0 max-content;\n  height: auto;\n  height: 0;\n  margin-left: -13px;\n  margin-top: 11px;\n}\n\ntextarea.event-desc-contnet {\n  width: 100%;\n  height: 200px !important;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  /* margin-bottom: 19px; */\n  margin-top: 6px;\n  padding: 6px;\n}\n\ni.fa.fa-search.text-black.text-md {\n  font-size: 17px;\n  padding-left: 4px;\n}\n\n.aero-angle-dowun {\n  transform: rotate(177deg);\n  height: 22px;\n}\n\ni.fas.fa-angle-down {\n  margin-left: 8px;\n  font-size: 19px;\n}\n\n.slider-image-div {\n  height: auto;\n  padding: 0 25px;\n}\n\n.evetns-search-image img {\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  object-fit: cover;\n  object-position: top;\n}\n\n.evetns-search-image {\n  height: 200px;\n  overflow: hidden;\n}\n\np.leading-relaxed11.file-search {\n  font-size: 12px !important;\n  line-height: 22px !important;\n}\n\nh1.title-font-blogs.events-search-title {\n  font-size: 19px;\n  /* margin-bottom: 2px !important; */\n}\n\np.post_meta_item11.post_date {\n  font-family: \"Rajdhani\", sans-serif;\n  font-weight: 700;\n}\n\ni.fas.fa-solid.fa-calendar-days {\n  font-size: 16px;\n  margin-right: 8px;\n}\n\ni.fa-solid.fa-globe {\n  margin-right: 8px;\n}\n\n.back-img-photo {\n  background-image: url(https://images.unsplash.com/photo-1499336315816-097655dcfbda?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=crop&amp;w=2710&amp;q=80);\n  background-size: cover;\n  width: 100%;\n  background-repeat: no-repeat;\n}\n\nsection.back-image-logo12 {\n  height: 100% !important;\n}\n\nmain.profile-page-thoughts {\n  margin-top: 33%;\n}\n\nmain.profile-page-thought-de {\n  margin-top: 27%;\n  margin-bottom: 3%;\n}\n\n.bell-tottal-count {\n  position: relative;\n}\n\nspan.total-noti-count {\n  position: absolute;\n  top: -7px;\n  left: 10px;\n  background: #ee2d2df2;\n  color: white;\n  border-radius: 20px;\n  height: 22px;\n  padding: 0px 5px;\n}\n\n.close-btn-back-profile {\n  float: right;\n  margin-bottom: 16px;\n}\n\n.profilePic-admin-image {\n  position: absolute;\n  top: -68px !important;\n  right: 13px;\n}\n\nlabel.upload-profileImg.absolute {\n  right: 18px;\n  bottom: 6px;\n}\n\n.notification-alert {\n  position: absolute;\n  width: 34%;\n  padding: 0px;\n  right: 0;\n  top: 85px;\n}\n\ni.fas.fa-caret-up {\n  font-size: 41px;\n  position: absolute;\n  bottom: -13px;\n  left: 38%;\n  color: #8080803d;\n}\n\nh1.see-all-noti-page {\n  margin-top: 21px;\n  border: 1px solid #8080804d;\n  padding: 9px 9px;\n  border-radius: 4px;\n}\n\n.fighting-imges-disussion {\n  min-height: 100vh !important;\n}\n\ni.far.fa-comment-dots.text-black {\n  font-size: 19px !important;\n}\n\n/* i.fa.fa-search {\n  font-size: 17px;\n} */\n\n.travel-div {\n  font-size: 36px;\n  text-align: center;\n  /* padding: 73px 0px; */\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 400;\n  font-family: poppins !important;\n}\n\n.the-martial-nexus {\n  text-align: center;\n  margin-left: 17px;\n  font-family: \"Rajdhani\", sans-serif;\n}\n\n.the-martial-nexus.uppercase h1 {\n  line-height: 22px;\n}\n\n/* .text-div-nexus {\n  width: 60%;\n  padding-left: 12%;\n} */\n\n/* .search-bar-for-event {\n  width: 40%;\n} */\n\n/* .typing-key-event {\n  top: 24%;\n} */\n\n.text-div-nexus {\n  /* width: 60%; */\n  /* padding-left: 12%; */\n  text-align: center;\n}\n\n.typing-key-event {\n  top: 15% !important;\n}\n\nbutton.tags-button-events {\n  background: #0743b1;\n  color: white;\n  font-weight: bold;\n  margin: 0px 10px;\n  width: 60px;\n  padding: 5px;\n  border-radius: 20px;\n  margin-top: 8px;\n}\n\n.insta-user img {\n  width: 6%;\n  object-fit: cover;\n}\n\n.insta-user {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.border-replay-comment {\n  border: 1px solid #80808070;\n  border-right: 2px solid var(--newCommunityTheme-line);\n  display: block;\n  height: 100%;\n  width: 50%;\n}\n\n.border-line-replay {\n  position: absolute;\n  height: calc(89% - 68%);\n\n  margin-left: 12px;\n}\n\n.social-media-text {\n  margin-left: 30px;\n}\n\narticle.comment-article {\n  margin-left: -44px;\n}\n\n.comment-text-pera {\n  margin-left: 47px !important;\n}\n\n.comment-art-box {\n  position: relative;\n}\n\n.border-replay-comment1 {\n  border: 1px solid #80808070;\n  border-right: 2px solid var(--newCommunityTheme-line);\n  display: block;\n  height: 100%;\n  width: 100%;\n}\n\n.border-line-replay1 {\n  position: absolute;\n  height: calc(100% - 0%);\n  margin-left: 12px;\n  width: 0;\n  top: 55px;\n  left: -20px;\n}\n\n.border-line-replay2 {\n  position: absolute;\n  height: calc(90% - 0%);\n  margin-left: 12px;\n  width: 0;\n  top: 55px;\n  left: -20px;\n}\n\n.border-replay-comment2 {\n  border: 1px solid #80808070;\n  border-right: 2px solid var(--newCommunityTheme-line);\n  display: block;\n  height: 100%;\n  width: 100%;\n}\n\n.deletion-dialog-delete\n  .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation24 {\n  max-width: 400px !important;\n  width: 100%;\n}\n\nbutton.delte-btn-dialog {\n  width: 100px;\n  background: #f75151;\n  color: white;\n  font-weight: 400;\n  padding: 5px 0px;\n  border-radius: 5px;\n}\n\nbutton.cancel-btn-dialog {\n  width: 100px;\n  background: #3360f7;\n  color: white;\n  font-weight: 400;\n  padding: 5px 0px;\n  border-radius: 5px;\n}\n\nbutton.save_profilepic {\n  width: 100px;\n  background: #3360f7;\n  color: white;\n  font-weight: 400;\n  padding: 7px 0px;\n  border-radius: 5px;\n}\n\nbutton.save_profilepic-btn {\n  width: 100px;\n  color: #3360f7;\n  font-weight: 400;\n  padding: 5px 0px;\n  border-radius: 5px;\n  border: 2px solid #3360f7;\n  margin-left: 12px;\n  margin-right: 12px;\n}\n\nbutton.deletion-btn-open-popup {\n  width: 120px;\n  background: #f04040c4;\n  color: white;\n  font-weight: 400;\n  padding: 7px 0px;\n  border-radius: 5px;\n}\n\n.profile-submit-buttons {\n  margin: 0px 26px;\n}\n\n.user-profile_discussion img {\n  width: 150px !important;\n  height: 150px !important;\n  object-fit: cover !important;\n}\n\n.discussion-cards-home {\n  width: 100% !important;\n  height: 265px !important;\n  min-height: 100% !important;\n}\n\nbutton.crop-contnet {\n  right: -35px;\n  top: -9px !important;\n  color: #808080a6;\n}\n\ni.fa.fa-edit.text-lg.text-gray-800 {\n  color: #808080cf;\n}\n\n.search-bar-usersearch {\n  /* position: absolute !important;\n  top: 12% !important; */\n  width: 100% !important;\n  left: 12%;\n}\n\n.search-userpopup {\n  position: absolute;\n  top: 26px;\n  left: 35px;\n}\n\n.input-group-user-search.searchsec {\n  width: 56%;\n}\n\n.search-bar-usersearch {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n}\n\n.searchsec1 .MuiAutocomplete-root.form-control.input-groups.font-normal {\n  width: 400px;\n}\n\nbutton.my-post-section {\n  background: #1e40afe3;\n  margin: 6px 11px;\n  padding: 6px 8px;\n  width: 118px;\n  border-radius: 6px;\n  color: white;\n}\n\n.search-input-users {\n  text-align: center;\n}\n\ninput.newSearchActInputPp {\n  width: 50% !important;\n  border-radius: 5px;\n  padding: 10px 9px;\n  border: 1px solid #8080806b;\n}\n\n/* phone number flag css */\n\n.react-tel-input .selected-flag .flag {\n  position: absolute;\n  top: 50% !important;\n  margin-top: -12px !important;\n}\n\n.react-tel-input .form-control {\n  font-size: 16px;\n  background: #ffffff;\n  border: 1px solid #cacaca8a;\n  border-radius: 0px !important;\n  width: 238px !important;\n  outline: none;\n  padding: 9px 50px !important;\n  /* transition: box-shadow ease .25s,border-color ease .25s; */\n  color: #495057;\n}\n\n.react-tel-input .form-control:focus {\n  background-color: #fff;\n  border-color: #1365bd !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.react-tel-input .selected-flag:before {\n  content: \"\";\n  display: block;\n  position: absolute;\n\n  border-radius: 4px 2px 2px 4px;\n  border: 1px solid transparent;\n  transition: box-shadow ease 0.25s, border-color ease 0.25s;\n  height: 0 !important;\n}\n\n/* phone number flag css */\n.follower-total-count {\n  cursor: pointer;\n}\n\nbutton.search-users-popup-btn {\n  background: #1266e5db;\n  color: white;\n  width: 114px;\n  padding: 5px 1px;\n  font-weight: 300;\n  font-family: poppins;\n  border-radius: 4px;\n}\n\n.search-users-popup {\n  float: right !important;\n}\n\n.common-tabs-posts {\n  height: 100% !important;\n}\n\n.btn-box-delete-info {\n  right: -42px !important;\n  top: 31px !important;\n}\n\n.searchsec button:hover {\n  background: #1e40af;\n}\n\n.no-posts-found {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 60px;\n}\n\n.terms-privacy-fight {\n  font-family: poppins !important;\n}\n\n.common-text-font-fam {\n  font-family: \"Rajdhani\", sans-serif;\n}\n\n.no-posts-found h1 {\n  font-size: 27px;\n  font-weight: 500;\n}\n\n/* canvas.mapboxgl-canvas {\n  width: 1256px !important;\n  height: 400px !important;\n} */\n\n.show-hide-password {\n  position: absolute;\n  bottom: 8px;\n  right: 11px;\n}\n\n.filter-sort-by {\n  /* width: 25%; */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.eventSearchbar\n  fieldset.MuiOutlinedInput-notchedOutline.css-1d3z3hw-MuiOutlinedInput-notchedOutline {\n  /* FONT-VARIANT: JIS04; */\n  border-radius: 0 !important;\n}\n\n.eventSearchbar\n  .css-1qqsdnr-MuiAutocomplete-root\n  .MuiOutlinedInput-root\n  .MuiAutocomplete-input {\n  padding: 2.5px 1px 4.5px 7px;\n}\n\nbutton.search-enter-btn {\n  padding: 13px !important;\n  height: 40px !important;\n}\n\n.input-group.eventSearchbar {\n  margin-top: 36px;\n  margin-right: 12px;\n}\n\n.css-nwrfgk-MuiButtonBase-root-MuiTab-root.Mui-selected {\n  background-color: rgb(36 101 199) !important;\n  color: white !important;\n  border-color: rgb(36 101 199);\n  font-size: 17px;\n  font-weight: bold;\n  font-family: \"Rajdhani\", sans-serif !important;\n}\n\nbutton.all_jobs_poject_buttonnewdiv.active1 {\n  /* background: rgb(36 101 199); */\n  color: white;\n  font-size: 15px;\n  /* width: 101px; */\n  padding: 8px 10px;\n  font-weight: 500;\n  font-family: \"Poppins\";\n  /* margin-right: 12px; */\n  border: 0px solid rgb(36 101 199);\n}\n\nbutton.all_jobs_poject_buttonnewdiv {\n  color: rgb(30 64 175);\n  font-size: 14px;\n  padding: 8px 10px;\n  font-weight: 700;\n  font-family: \"Poppins\";\n  /* margin-right: 12px; */\n  border: 1px solid;\n}\n\n.aero-down-icon {\n  margin-top: -13px !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* margin-right: 15px; */\n}\n\ni.fas.fa-caret-down.aeroafflian {\n  font-size: 32px;\n  color: rgb(30 64 175);\n}\n\n.mactching-div {\n  text-align: center;\n  padding: 12px 12px;\n  color: white;\n  font-size: 17px;\n  font-family: \"Poppins\";\n  font-weight: 400;\n  margin-bottom: 12px;\n}\n\ni.fa.fa-search.search-user-icon {\n  position: absolute;\n  top: -5px;\n  right: 207px;\n  color: #808080c2;\n  z-index: 30;\n}\n\n.search-user-btn input {\n  border: 1px solid gray;\n  padding: 10px 31px;\n  border-radius: 30px;\n  position: absolute;\n  right: 0px;\n  top: -22px;\n  width: 100%;\n}\n\n/* .user-search-div {\n  position: absolute;\n  width: 35%;\n  right: 29%;\n  top: 98px;\n} */\n\n.user-search-div {\n  position: absolute;\n  width: 30%;\n  right: 35%;\n  top: 95px;\n}\n\ni.fas.fa-sort-down {\n  font-size: 20px;\n  margin-left: 14px;\n  height: 27px;\n}\n\ntextarea.thougt-textarea {\n  height: 200px !important;\n}\n\np.poem-word {\n  height: 166px !important;\n}\n\n.upcoming-evetns-near {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\nbutton.terms-privacy-fight:active {\n  background: #1e40af !important;\n}\n\n.slider-image-div img {\n  height: 620px;\n  object-fit: cover;\n  border-radius: 10px;\n}\n\n.transparent-image {\n  position: absolute;\n  bottom: 0;\n  padding: 170px 0px;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n\ntextarea.w-full.px-3.py-2.border.border-slate-400.placeholder-text-sm.rounded {\n  height: 100px !important;\n}\n\n.search-bar-for-event {\n  /* width: 40%; */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0px 357px;\n}\n\n.recent-searhces {\n  display: flex;\n  align-items: center;\n  margin: 0px 3px;\n  font-family: poppins !important;\n}\n\n.event-tabele-data {\n  width: 100%;\n  margin: 0 auto;\n  padding: 0;\n}\n\n/* .event-tabele-data::-webkit-scrollbar {\n  width: 1em;\n}\n \n.event-tabele-data::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n \n.event-tabele-data::-webkit-scrollbar-thumb {\n  background-color: darkgrey;\n  outline: 1px solid slategrey;\n} */\n\n/* 21 March 2023 */\n\n.css-1qqsdnr-MuiAutocomplete-root\n  .MuiOutlinedInput-root\n  .MuiAutocomplete-input {\n  /* padding: 7.5px 4px 7.5px 6px; */\n  border-radius: 64px 0px 0px 64px !important;\n}\n\n/* .dataTables_length.bs-select {\n  margin: -17px !important;\n} */\n\nbutton.search-enter-btn:hover {\n  background-color: #1e40af !important;\n}\n\na.mapboxgl-ctrl-logo {\n  display: none !important;\n}\n\n.mapboxgl-ctrl-attrib-inner {\n  display: none !important;\n}\n\nbutton.mapboxgl-popup-close-button {\n  padding: 2px 10px !important;\n}\n\n/* 21 March 2023 */\n\n/* .eventSearchbar input#tags-outlined {\n  height: 12px !important;\n} */\n\n.DAMSidebar li span {\n  display: none;\n  transition: 1s;\n}\n\n.DAMSidebar {\n  width: 80px;\n  transition: 1s;\n}\n\n.DAMSidebar .whitespace-nowrap {\n  display: none;\n  transition: 1s;\n}\n\n.sidebarmenu2 {\n  transition: 0.5s;\n}\n\n.logo_sec {\n  width: 35%;\n}\n\n.search-user-btn {\n  width: 30%;\n}\n\n.userid12 {\n  width: 35%;\n  display: flex;\n  justify-content: end;\n}\n\n.wordbreadkdiv {\n  word-wrap: break-word !important;\n}\n\n.eidt-profile {\n  position: absolute;\n  right: 51px;\n  top: -9px;\n  color: #007eff;\n  cursor: pointer;\n}\n\n.event-tags-div\n  .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-fullWidth.MuiInputBase-formControl.MuiInputBase-adornedEnd.MuiAutocomplete-inputRoot.css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root {\n  padding: 0 !important;\n  margin: 0 !important;\n  height: 53px;\n}\n\nimg.fight-finder-ligo {\n  width: 100%;\n  max-width: 200px;\n}\n\ndiv#search-event-boxx {\n  max-height: 400px;\n  overflow-y: scroll;\n}\n\ni.fa.fa-ellipsis-v {\n  cursor: pointer;\n}\n\n.scroll-top-btn {\n  position: fixed;\n  bottom: 80px;\n  right: 20px;\n  background: no-repeat !important;\n  border: none;\n  outline: none;\n  cursor: pointer;\n}\n\ni.fas.fa-arrow-up.aero-scroll {\n  font-size: 30px;\n  background: white;\n  padding: 5px 7px;\n  border-radius: 24px;\n  color: black;\n}\n\n.fighter-images-events1.neweventsadd {\n  height: 280px !important;\n  border-radius: 11px !important;\n}\n\n.eventsbak.bgblack-trasn {\n  border-radius: 8px !important;\n}\n\n.flex.flex-col.p-6.mx-auto.max-w-lg.text-gray-900.bg-white.rounded-lg.border.border-gray-100.shadow.w-full.my-ideas {\n  height: 280px !important;\n  border-radius: 11px;\n}\n\n.text-div-nexus {\n  margin-top: 25px !important;\n}\n\n.grid.grid-cols-2.gap-4.skillstag {\n  align-items: center !important;\n}\n\np.common-text-font-fam.text-black-800.font-medium.text-lg {\n  font-size: 13px !important;\n  color: #000000c2 !important;\n  text-align: center !important;\n}\n\nbutton.scroll-top-btn {\n  z-index: 999 !important;\n}\n\n.Home-events-img11.Publiceventde.resize-image {\n  height: 200px !important;\n}\n\ni.fa.fa-home {\n  font-size: 22px;\n}\n\ni.fa.fa-home.text-lg.mr-2.text-gray-600 {\n  font-size: 18px !important;\n}\n\nh4.common-text-font-fam.text-white.sm\\:text-3xl.md\\:text-5xl.font-bold {\n  font-size: 90px !important;\n}\n\n.w-full.p-3.mt-2.bg-white.rounded.shadow.flex.flex-shrink-0 {\n  display: flex;\n  align-items: center;\n}\n\nimg.rounded-full.max-w-none.w-12.h-12.mr-4 {\n  margin: 0px 0px !important;\n}\n\n.grid.grid-cols-1.gap-2.box-border.mx-4 {\n  margin-bottom: 50px;\n}\n\n.eveantag1212 .MuiOutlinedInput-root .MuiAutocomplete-input {\n  border-radius: 4px !important;\n  margin-right: 4px;\n}\n\n.eveantag1212 .MuiOutlinedInput-root {\n  height: 48px !important;\n  width: 100% !important;\n}\n\ntextarea.block.p-2\\.5.w-full.text-sm.text-gray-900.bg-gray-50.rounded-lg.border.border-gray-300.focus\\:ring-blue-500.focus\\:border-blue-500.bg-white.dark\\:border-gray-600.dark\\:placeholder-gray-400.dark\\:text-black.dark\\:focus\\:ring-blue-500.dark\\:focus\\:border-blue-500 {\n  height: 150px !important;\n}\n\nbutton.affilian-post-btn {\n  color: white;\n  padding: 7px 37px;\n  border-radius: 5px;\n  width: 167px;\n}\n\n.mapboxgl-popup-content {\n  position: relative;\n  background: #fff;\n  border-radius: 3px;\n  box-shadow: 0 1px 2px rgb(0 0 0/10%);\n  padding: 10px 10px 15px;\n  pointer-events: auto;\n  width: 100px !important;\n  text-align: center !important;\n  font-family: \"Poppins\";\n}\n\n.save_profilepic-btn.close-prfile11 {\n  position: relative;\n}\n\nbutton.save_profilepic-btn.close-prfile {\n  position: absolute;\n  top: -38px;\n  left: 133px;\n}\n\n.swal-modal.errorAlert {\n  height: 230px;\n}\n\n.successLogout {\n  width: 107px;\n  border: none;\n  background: #7867c1;\n  color: #fff;\n  padding: 10px 0;\n  border-radius: 8px;\n  margin: 13px;\n  font-size: 16px;\n  cursor: pointer;\n  font-family: \"poppins\";\n}\n\n.successfullyButton {\n  background: #1f92b5;\n  font-weight: 300;\n  font-family: \"Poppins\";\n  display: inline-block;\n  text-decoration: none;\n}\n\nimg.logo-dashboard {\n  width: 139px;\n}\n\na.successfullyButton {\n  padding: 10px;\n  color: #1e22aa;\n  text-transform: capitalize;\n\n  display: inline-block;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border-radius: 8px;\n  margin: 20px auto 0;\n\n  color: white;\n}\n\nimg.dashboardImg {\n  width: 300px;\n}\n\n.dashboardDiv {\n  display: flex;\n  justify-content: center;\n  margin: 20px;\n}\n\n.update {\n  width: 13%;\n}\n\n.dash {\n  margin: 10px;\n}\n\n.filesDiv {\n  display: flex;\n  justify-content: space-between;\n  height: 34px;\n}\n\nbutton.del {\n  height: 23px;\n  margin: 14px;\n  color: #42c1f4;\n  border-radius: 13px;\n  border: 0px;\n}\n\n#file-input-area {\n  display: none;\n}\n\n.button {\n  background-color: #007bff;\n  border: none;\n  color: white;\n  padding: 10px 40px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 16px;\n  cursor: pointer;\n  border-radius: 10px;\n  font-family: \"poppins\";\n}\n\ntext.recharts-text.recharts-cartesian-axis-tick-value {\n  font-size: 13px;\n}\n\n.chatmapdiv {\n  padding: 20px 20px 10px 0px;\n}\n\np.fileName {\n  display: flex;\n  justify-content: center;\n  background: white;\n  border-radius: 4px;\n  padding: 6px;\n}\n\n#membershipHeading {\n  font-family: \"poppins\";\n  padding: 10px 0;\n  font-size: 20px;\n  font-weight: 600;\n  font-family: \"poppins\";\n}\nh3.price {\n  padding-bottom: 13px;\n  font-weight: 500;\n  color: #7867c1;\n  font-size: 18px;\n}\np.errorMsg {\n  margin: 0 !important;\n  font-size: 13px;\n  color: #e31e00;\n  font-family: poppins;\n}\n\n.divGraph {\n  background-color: white;\n  border-radius: 10px;\n}\n\n.chartDiv {\n  background: white;\n  padding: 30px 32px 24px 0px;\n  border-radius: 10px;\n  position: relative;\n}\n\nbutton.del.btnSS {\n  float: right;\n  background: #42c1f4;\n  color: white;\n}\n\n/* select.method-select {\n  border: none;\n  padding: 4px;\n  margin: 11px;\n  border-radius: 12px;\n  color: #42c1f4;\n  outline: none !important;\n} */\n\np.count {\n  color: #42c1f4;\n  display: flex;\n  align-items: center;\n}\n\nimg.error-page {\n  width: 60%;\n  display: flex;\n  justify-content: center;\n  margin: auto;\n  margin-top: 32px;\n}\n\na.hover-primary.subs {\n  margin-right: 10px;\n}\n\np#notfound {\n  font-size: 34px;\n  font-family: \"Poppins\";\n  text-align: center;\n  margin-top: 115px;\n}\n\nselect.custom-select.custom-select-sm.form-control.form-control-sm {\n  width: 168px;\n  margin-bottom: 22px !important;\n}\n\n.userlistdiv {\n  width: 60%;\n  margin: auto;\n  background: white;\n  padding: 26px;\n  border-radius: 10px;\n}\n\ntable.table.table-bordered.table-sm.table-striped.dataTable {\n  margin: auto;\n  width: 100%;\n}\n\n/* .thanktexthome.userlist {\n  width: 60%;\n  margin: auto;\n} */\n\n.thanktexthome.userlist {\n  margin: auto;\n  padding: 0px 130px;\n}\n\n/* ul.pagination {\n  width: 60%;\n  margin: auto;\n  margin-top: 20px;\n} */\n\nli.page-item {\n  display: inline-block;\n  margin-left: 17px;\n  cursor: pointer;\n}\n\nbutton.del.add {\n  width: 30px;\n}\n\nrect.recharts-brush-slide {\n  fill-opacity: 1;\n}\n\n.dataresult {\n  display: flex;\n}\n\n.datashow {\n  width: 30%;\n  position: relative;\n}\n\n.result {\n  width: 70%;\n}\n\n/* data result */\n.dataresult {\n  margin: 12px;\n}\n\n.datashow {\n  width: 21%;\n  background: white;\n  padding: 35px;\n  border-radius: 5px 0px 0px 5px;\n  box-shadow: 2px 1px 11px 3px;\n}\n/* h2.dataheading {\n  display: flex;\n  justify-content: center;\n  color: #16414a;\n  font-size: 39px;\n} */\n\nh2.dataheading {\n  display: flex;\n  justify-content: center;\n  color: gray;\n  font-size: 40px;\n  font-weight: 700;\n}\n\nbutton.btnchange {\n  border: none;\n  color: gray;\n  font-size: 25px;\n  font-weight: 400;\n  font-family: \"Poppins\";\n}\n\n/* p.dataText {\n  font-size: 13px;\n  margin: 2px;\n  color: #8d9191;\n} */\np.dataText {\n  font-size: 14px;\n  margin: 2px;\n  color: #8d9191;\n  font-family: \"Poppins\";\n}\n.Data-plotting {\n  display: flex;\n  background: white;\n  margin-left: 10px;\n  padding: 12px;\n  border-radius: 0px 5px 5px 0px;\n  box-shadow: 2px 1px 11px 3px;\n}\n.graphplot {\n  width: 90%;\n}\n.graphdetail {\n  width: 31%;\n  /* display: flex;\n  justify-content: center;\n  align-items: self-end; */\n}\n.graphdetail > div {\n  height: 40px;\n  padding-left: 13px;\n  margin-top: 270px;\n  display: flex;\n  justify-content: center;\n}\n.confidenceContainer {\n  display: flex;\n}\n.clustergraph {\n  height: 380px;\n}\n.confidence {\n  width: 50%;\n  background: white;\n  margin-left: 10px;\n  margin-top: 10px;\n  box-shadow: 2px 1px 11px 3px;\n  height: 460px;\n}\n.clusterPlot {\n  background: white;\n  margin-top: 10px;\n  margin-left: 10px;\n  width: 50%;\n  border-radius: 0px 5px 5px 0px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 2px 1px 11px 3px;\n}\n\nh2.corelate {\n  margin-bottom: 95px;\n}\n.addpagelink {\n  position: absolute;\n  bottom: 13px;\n  left: 20px;\n}\n.addpagelink a {\n  list-style: none;\n  color: grey;\n  text-decoration: none;\n}\nlabel.fileupload {\n  border-radius: 5px;\n\n  font-size: 14px;\n  border: 1.2px solid #7867c1;\n  padding: 1px 6px;\n  color: white;\n  background: #7867c1;\n  margin: 2px;\n}\n.dropzone-content {\n  display: flex;\n  flex-direction: row;\n}\n\n.dataText {\n  font-size: 12px;\n  margin-left: 8px;\n  color: gray;\n}\nselect.method-select {\n  border: 1px solid gray;\n  padding: 0 13px;\n  width: 150px;\n  border-radius: 3px;\n  color: gray;\n  background: white;\n  outline: none !important;\n}\np.dataToggle {\n  color: gray;\n  font-size: 13px;\n}\n/* toggle button */\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 22px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 17px;\n  width: 17px;\n  left: 4px;\n  bottom: 2px;\n  background-color: white;\n  transition: 0.4s;\n}\n\ninput:checked + .slider {\n  background-color: #2196f3;\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px #2196f3;\n}\n\ninput:checked + .slider:before {\n  -webkit-transform: translateX(26px);\n  -ms-transform: translateX(26px);\n  transform: translateX(26px);\n}\n\n/* Rounded sliders */\n.slider.round {\n  border-radius: 34px;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}\n.clusterPlot {\n  padding: 6px;\n  /* padding-top: 20px; */\n}\n.toggledec {\n  display: flex;\n  align-items: center;\n}\ninput.confiInput {\n  width: 50px;\n  padding: 5px;\n  border: none;\n  border-radius: 3px;\n  text-align: center;\n  margin: 0px;\n  color: #42c1f4;\n}\nbutton.del {\n  height: 23px;\n  margin: 0px;\n  color: white;\n  border-radius: 5px;\n  border: 1px solid gray;\n  background: #7867c1;\n}\n\nbutton.submitbtn {\n  background: #7867c1;\n  border-radius: 5px;\n  border: 2px solid #9788d8;\n  color: white;\n  padding: 5px 16px;\n  font-size: 23px;\n  font-family: \"poppins\";\n}\n\n.leftsideimport {\n  display: flex;\n}\n\n.addfiledata {\n  padding-left: 100px;\n}\n\n.headerstyle a {\n  list-style: none;\n  color: grey;\n  text-decoration: none;\n  font-size: 25px;\n}\n.headerstyle {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0px 8px 17px -10px;\n}\n.containeraddfile {\n  width: 82%;\n  box-shadow: 0px 1px 11px 1px;\n  margin: auto;\n  /* padding: 0px; */\n}\n\n.leftsideimport {\n  background: white;\n}\n.containeraddfile {\n  background: white;\n}\n\nh2.dataheading {\n  margin: 0px;\n  /* margin-bottom: 30px; */\n}\n\n.dashboardpage {\n  background: #42c1f440;\n}\n\n.homepage {\n  background: #42c1f4;\n  padding: 40px 0;\n  height: 100vh;\n}\n\n.action-btnss {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\ni.fa.fa-solid.fa-check {\n  color: #10c910;\n  font-size: 22px;\n}\n\ni.fa.fa-solid.fa-times {\n  color: red;\n  font-size: 22px;\n}\n\n.dataTables_length.bs-select {\n  width: 102px !important;\n}\n\n.setting-action-btn {\n  display: flex;\n  justify-content: center;\n}\n.table-responsive tr {\n  padding: 10px 0 !important;\n  width: 100%;\n  font-family: poppins !important;\n  height: 53px;\n}\n/* .setting-action-btn {\n  height: 53px;\n} */\n\ni.fa.fa-gear {\n  font-size: 21px;\n  /* pointer-events: initial; */\n  cursor: pointer;\n}\n\nul.pagination {\n  /* width: 60%; */\n  margin: auto;\n  margin-top: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.active > .page-link,\n.page-link.active {\n  background-color: #948ed1;\n  border-color: var(--bs-pagination-active-border-color);\n  padding: 5px 18px;\n  color: white;\n  font-size: 18px;\n  border-radius: 11px;\n}\n\n.main-upload-data {\n  display: flex;\n  gap: 13px;\n  align-items: center;\n  height: 100px;\n}\n\nh2.number-lenght.text-red-800 {\n  background: #7867c1;\n  /* width: 40px; */\n  padding: 9px 22px;\n  border-radius: 27px;\n  color: white;\n  font-family: \"Poppins\";\n}\n\n.oneinputtitle {\n  margin-top: 39px;\n}\n\n.straoght-border {\n  border: 3px solid;\n  width: 59px;\n  transform: (14deg 7deg);\n  transform: rotate(90deg);\n  margin-left: -4px;\n  color: #7867c1b5;\n}\n.dropzone-part {\n  padding-top: 16px;\n  padding-bottom: 8;\n}\n\nselect.method-select {\n  border: 1px solid gray;\n  margin-top: 12px;\n\n  width: 100%;\n  border-radius: 3px;\n  color: gray;\n  background: white;\n  font-family: \"Poppins\";\n  outline: none !important;\n}\n\n/**\n * The switch widget!\n * Usage:\n *   <input type=\"checkbox\" switch[=\"type\"] id=\"toggleSwitch\" />\n *   <label for=\"toggleSwitch\" data-on-label=\"On\" data-off-label=\"Off\"></label>\n */\n\n/*\n  * Copyright (c) 2013 Thibaut Courouble\n  * http://www.cssflow.com\n  *\n  * Licensed under the MIT License:\n  * https://www.opensource.org/licenses/mit-license.php\n  */\n\n.switch {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  width: 56px;\n  height: 20px;\n\n  background-color: white;\n  border-radius: 18px;\n  box-shadow: inset 0 -1px white, inset 0 1px 1px rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n  background-image: -webkit-linear-gradient(top, #eeeeee, white 25px);\n  background-image: -moz-linear-gradient(top, #eeeeee, white 25px);\n  background-image: -o-linear-gradient(top, #eeeeee, white 25px);\n  background-image: linear-gradient(to bottom, #eeeeee, white 25px);\n}\n\n.switch-input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n}\n\n.switch-label {\n  position: relative;\n  border: 2px solid gray;\n  display: block;\n  height: inherit;\n  font-size: 10px;\n  text-transform: uppercase;\n  background: #808080e1;\n  border-radius: inherit;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.12),\n    inset 0 0 2px rgba(0, 0, 0, 0.15);\n  -webkit-transition: 0.15s ease-out;\n  -moz-transition: 0.15s ease-out;\n  -o-transition: 0.15s ease-out;\n  transition: 0.15s ease-out;\n  -webkit-transition-property: opacity background;\n  -moz-transition-property: opacity background;\n  -o-transition-property: opacity background;\n  transition-property: opacity background;\n}\n.switch-label:before,\n.switch-label:after {\n  position: absolute;\n  top: 50%;\n  margin-top: -0.5em;\n  line-height: 1;\n  -webkit-transition: inherit;\n  -moz-transition: inherit;\n  -o-transition: inherit;\n  transition: inherit;\n}\n.switch-label:before {\n  content: attr(data-off);\n  right: 11px;\n  color: #aaa;\n  text-shadow: 0 1px rgba(255, 255, 255, 0.5);\n}\n.switch-label:after {\n  content: attr(data-on);\n  left: 11px;\n  color: white;\n  text-shadow: 0 1px rgba(0, 0, 0, 0.2);\n  opacity: 0;\n}\n.switch-input:checked ~ .switch-label {\n  background: #7867c1;\n  /* box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15), inset 0 0 3px rgba(0, 0, 0, 0.2); */\n}\n.switch-input:checked ~ .switch-label:before {\n  opacity: 0;\n}\n.switch-input:checked ~ .switch-label:after {\n  opacity: 1;\n}\n\n.switch-handle {\n  position: absolute;\n  border: 2px solid gray;\n  top: 4px;\n  left: 6px;\n  width: 0;\n  height: 13px;\n  background: white;\n  border-radius: 10px;\n  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);\n  background-image: -webkit-linear-gradient(top, white 40%, #f0f0f0);\n  background-image: -moz-linear-gradient(top, white 40%, #f0f0f0);\n  background-image: -o-linear-gradient(top, white 40%, #f0f0f0);\n  background-image: linear-gradient(to bottom, white 40%, #f0f0f0);\n  -webkit-transition: left 0.15s ease-out;\n  -moz-transition: left 0.15s ease-out;\n  -o-transition: left 0.15s ease-out;\n  transition: left 0.15s ease-out;\n}\n.switch-handle:before {\n  border: 2px solid gray;\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin: -6px 0 0 -2px;\n\n  width: 12px;\n  height: 12px;\n  background: #f9f9f9;\n  border-radius: 6px;\n  box-shadow: inset 0 1px rgba(0, 0, 0, 0.02);\n  background-image: -webkit-linear-gradient(top, #eeeeee, white);\n  background-image: -moz-linear-gradient(top, #eeeeee, white);\n  background-image: -o-linear-gradient(top, #eeeeee, white);\n  background-image: linear-gradient(to bottom, #eeeeee, white);\n}\n.switch-input:checked ~ .switch-handle {\n  left: 40px;\n  box-shadow: -1px 1px 5px rgba(0, 0, 0, 0.2);\n}\n\n.switch-green > .switch-input:checked ~ .switch-label {\n  background: #4fb845;\n}\n\nlabel.select-toggle-btn {\n  margin-right: 50px;\n  color: gray;\n  font-family: \"Poppins\";\n}\n\n.plus-minus-input {\n  display: flex;\n  /* align-items: center; */\n}\n\nspan.count-persanttage {\n  border-top: 1px solid gray;\n  border-bottom: 1px solid gray;\n  padding: 2px 14px;\n  background: white;\n}\n\nbutton.decrement-button {\n  color: white;\n  font-size: 26px;\n  border-radius: 3px;\n  border: none;\n  width: 30px;\n  height: 30px;\n  background: #7867c1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbutton.increment-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-size: 26px;\n  border-radius: 3px;\n  border: none;\n  width: 30px !important;\n  height: 30px;\n  background: #7867c1;\n}\n\nbutton.submitbtn {\n  background: #7867c1;\n  border-radius: 15px;\n  border: 2px solid #aa9ede;\n  color: white;\n  padding: 5px 12px;\n  font-size: 33px;\n  font-family: \"poppins\";\n  font-weight: 700;\n  font-family: \"Poppins\";\n}\n\n.main-graph-image {\n  background: white;\n  height: 100vh;\n}\n\n.heading h1 {\n  text-align: center;\n  color: rgb(128 128 128 / 75%);\n  font-family: \"Poppins\";\n  margin-top: 0;\n  font-size: 38px;\n  font-weight: 500;\n  padding: 24px 0 0;\n  font-weight: bold;\n}\n\n.main-graph-image {\n  height: 100vh !important;\n  background-repeat: no-repeat !important;\n  background-size: cover !important;\n  padding: 0px 66px;\n}\nbutton {\n  border: none;\n  color: gray;\n  font-size: 16px;\n}\n/* button.btnchange {\n  border: none;\n  color: gray;\n  font-size: 16px;\n} */\np.dataTitle {\n  color: #7867c1;\n  font-size: 30px;\n  margin: 10px 0px 10px 0px;\n  font-family: \"Poppins\";\n}\n.layout-dashboard-main {\n  background: white;\n  height: 100vh;\n}\n.icondown {\n  width: 31px;\n  height: 31px;\n  margin-left: 5px;\n  cursor: \"pointer\";\n  float: right;\n  /* display: flex; */\n  /* align-items: center; */\n  /* justify-content: center; */\n  /* text-align: center; */\n  margin: 0 20px;\n  position: relative;\n  z-index: 999;\n}\n.clusterGraph {\n  width: 100%;\n}\n.main_navbar_header {\n  padding: 8px 28px;\n  box-shadow: 0px -4px 11px 4px;\n}\n/* .loginsigin {\n  position: absolute;\n  width: 200px;\n  background: #fff;\n  padding: 10px;\n  right: 0;\n  top: 55px;\n  border-top: 4px solid #FC2D60;\n  z-index: 9999;\n  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);\n} */\n\n.loginsigin a {\n  width: 100%;\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 19px;\n  color: #a0a0a0;\n}\n.loginsigin li {\n  width: 100%;\n  margin: 3px;\n}\n.loginsigin li:hover {\n  width: 100%;\n  background: unset;\n  box-shadow: unset;\n  margin: 0;\n}\nli.user-header-div.Activediv {\n  list-style: none;\n}\n\nimg.mr-2.profileIcons {\n  margin-right: 6px;\n}\nimg.mr-2.logout {\n  margin-right: 8px;\n}\nli.user-header-div {\n  list-style: none;\n}\n.profileIcons {\n  width: 20px;\n  margin-right: 5px;\n}\nimg.logout {\n  margin-right: 9px;\n}\n.loginsigin {\n  position: absolute;\n  width: 200px;\n  background: #fff;\n  padding: 13px;\n  right: 28px;\n  top: 46px;\n  border-top: 4px solid #7867c1;\n  z-index: 9999;\n  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);\n  list-style: none;\n  text-align: justify;\n  padding-left: 20px;\n}\na.hover-primary {\n  color: #7867c1;\n  font-size: 14px;\n  text-decoration: none;\n  font-weight: 600;\n  /* margin-top: 7px; */\n  display: inline-block;\n  text-transform: capitalize;\n  font-family: \"Poppins\";\n}\nimg.imgPro {\n  margin-top: 11px;\n  width: 26px;\n}\n.main-geoThara-div {\n  margin: 70px 0;\n}\n.elementor-widget-container {\n  color: #4ac0ef;\n  font-family: \"Rubik\", Sans-serif;\n  font-size: 45px;\n  font-weight: 600;\n  line-height: 50px;\n}\n.changing-content {\n  color: #7867c1;\n  font-family: \"Rubik\", Sans-serif;\n  font-size: 45px;\n  font-weight: 600;\n  line-height: 50px;\n}\n.test-1 {\n  font-family: \"Poppins\", Sans-serif;\n  font-size: 18px;\n  font-weight: 400;\n}\n.slider-image-div img {\n  width: 100%;\n  /* height: auto; */\n}\n.trenddetection {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.react-slideshow-container .default-nav {\n  background: none !important;\n}\n.react-slideshow-container svg {\n  fill: #fff !important;\n}\n.topdiv {\n  height: 520px;\n  overflow: hidden;\n  position: relative;\n}\n\n.newlogomenu {\n  display: flex;\n}\n.newlogo {\n  width: 150px;\n}\n.container {\n  margin: 0 auto;\n}\n.logomenu {\n  width: 100%;\n  display: flex;\n  padding: 0 40px;\n  align-items: end;\n  justify-content: center;\n}\n.newlogomenu {\n  display: flex;\n  max-width: 1130px;\n  margin: 0 auto;\n}\n.logomenu li {\n  list-style: none;\n  padding: 0 18px;\n}\n.logonavbar {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  padding: 20px 10px;\n  z-index: 999;\n  border-top: 1px solid #fff;\n  margin-top: 44px;\n}\n.logomenu a {\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: #fff;\n}\np.emailtext {\n  /* position: absolute; */\n  /* right: 0; */\n  /* margin: 0 auto; */\n  color: #fff;\n  /* padding: 10px 0 30px; */\n  /* display: inline-block; */\n  /* width: 100%; */\n}\n.container-text {\n  text-align: right;\n  width: 90%;\n  /* margin: 0 auto; */\n  float: left;\n  padding: 9px 0;\n  position: absolute;\n  z-index: 999;\n}\n.tobtext {\n  position: absolute;\n  top: 50%;\n  width: 100%;\n}\n.tobtext h1 {\n  color: #ffffff;\n  font-family: \"DM Sans\", Sans-serif;\n  font-size: 47px;\n  font-weight: 700;\n  line-height: 100px;\n  padding: 0 66px;\n}\n.Services {\n  object-fit: cover;\n  background-repeat: no-repeat;\n  padding: 50px 0 80px;\n}\n.allServices {\n  display: flex;\n}\n.Services1 {\n  width: 30.5%;\n  background: #fff;\n  text-align: center;\n  padding: 80px 30px;\n  border-radius: 15px;\n}\n.Services-icon {\n  width: 4%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\nimg.Services-icon-img {\n  width: 130px;\n  margin: 0 auto;\n  padding: 20px;\n}\nh2.nuber {\n  color: #6ec1e4;\n  font-size: 35px;\n  font-weight: 700;\n}\nh3.datatext {\n  font-family: \"Rubik\", Sans-serif;\n  font-size: 25px;\n  font-weight: 700;\n  font-style: italic;\n  letter-spacing: 0px;\n  color: #7867c1;\n  margin: 7px 0 10px;\n}\np.Services-test {\n  font-family: \"Rubik\", Sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  font-style: italic;\n  color: #7867c1;\n}\nh1.Servicestitle {\n  color: #ffffff;\n  font-family: \"Rubik\", Sans-serif;\n  font-size: 45px;\n  font-weight: 600;\n  margin-bottom: 50px;\n}\n.Services-top {\n  padding: 0 65px;\n}\n.result {\n  width: 78%;\n}\n.datashow {\n  width: 30%;\n  position: relative;\n  background: white;\n  padding: 35px;\n  border-radius: 5px 0px 0px 5px;\n  box-shadow: 2px 1px 11px 3px;\n}\n.Contactsecdiv {\n  display: flex;\n  width: 100%;\n  margin: 85px 0;\n}\n.Contactsecdiv-text {\n  width: 50%;\n  display: flex;\n  align-items: center;\n}\n.Contactsecdiv-img {\n  width: 50%;\n}\n.Contactsecdiv-img img {\n  width: 100%;\n}\nh1.Contacttitle {\n  color: #4ac0ef;\n  font-family: \"Rubik\", Sans-serif;\n  font-size: 45px;\n  font-weight: 600;\n  line-height: 50px;\n}\nh2.contactlink {\n  font-size: 24px;\n  color: #7867c1;\n  margin: 6px 0 0;\n}\n.Contactsecdiv-img img {\n  border-radius: 10px;\n}\n.bottomsec {\n  background: #01102d;\n  padding: 60px 0;\n}\n.footer-text {\n  width: 33.33%;\n}\n.footer-logo {\n  width: 33%;\n  display: flex;\n  align-items: center;\n}\n.footer {\n  display: flex;\n}\n.footer-logo img {\n  width: 220px;\n}\n.footer-text p {\n  text-align: left;\n  color: #ffffff;\n  font-family: \"Poppins\", Sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  padding-bottom: 20px;\n}\n.scrolled .logonavbar {\n  position: fixed;\n  background: #000;\n  top: -50px;\n}\nh2.createplay-title {\n  font-size: 26px;\n  color: #7867c1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation24 {\n  max-width: 350px !important;\n  width: 100%;\n  padding: 0px 10px;\n}\nbutton.MuiButtonBase-root.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.canceButtonnewPop.css-1e6y48t-MuiButtonBase-root-MuiButton-root {\n  color: #42c1f4;\n  padding-bottom: 8px;\n  font-size: 16px;\n}\n.MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {\n  width: 73px;\n  color: #7867c1;\n  border: 1px solid #7867c1;\n}\nh2.add-title {\n  color: #7867c1;\n  font-size: 27px;\n  display: flex;\n  justify-content: center;\n  padding-bottom: 27px;\n}\n.allpage {\n  background: white;\n  border-radius: 5px;\n}\n.allpage {\n  background: white;\n  border-radius: 5px;\n  padding: 15px;\n}\n.dataTables_length.bs-select {\n  color: #7867c1;\n}\n\ni.fas.fa-2x.fa-sharp.fa-regular.fa-circle-down {\n  color: #7867c1;\n}\n\n.clustergraph svg.recharts-surface {\n  margin-top: 41px;\n  height: 380px !important;\n}\n\n/* .clusterGraph.third svg.recharts-surface {\n  margin-top: -78px !important;\n} */\n\n/* .graphplot.firstgraph {\n  width: 300% !important;\n} */\n\nbutton.i-contnet-btn {\n  background: #7867c1;\n  color: white;\n  padding: 1px 16px;\n  border-radius: 12px;\n}\n.Data-plotting .graphplot {\n  width: 300%;\n}\n.icondown11 {\n  display: flex;\n  height: 98%;\n  align-items: end;\n}\n.icondown474 {\n  margin: -5px 11px 0;\n}\n/* neww csss */\n\n.select-steps-contnet {\n  font-size: 29px;\n  font-weight: 300;\n\n  color: rgba(128, 128, 128, 0.86);\n  font-family: \"Poppins\", sans-serif;\n}\n\n.border-steps {\n  color: #9082cc;\n  border: 3px solid;\n}\n\n.rounded-border-contnet {\n  background: #7867c1 !important;\n  width: 50px;\n  height: 50px;\n  border: 1px solid #7867c1;\n  color: white;\n  font-size: 22px;\n  font-family: \"Poppins\";\n}\n\n.upload-data-inputdata {\n  margin-top: 30px !important;\n}\n\n.spaceonright {\n  display: flex;\n  justify-content: center;\n  align-items: end;\n  position: absolute !important;\n  left: 43%;\n  top: 95%;\n}\nbutton.togglebtn {\n  display: none;\n}\n.logo-m {\n  display: none;\n}\n.mobl {\n  display: none;\n}\n\n.foldermainDisplayDivsec {\n  width: 100% !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\na.Auth-button.back-btn {\n  margin: 0 auto;\n}\n\n.show-hide-password {\n  display: none !important;\n}\n\n.newgraph-div {\n  display: flex;\n  background: #80808036;\n  padding: 44px 0px 0px 0px;\n  box-shadow: 0px 3px 8px -3px;\n}\n\nbutton.all_graph_buttonnewdiv {\n  width: 140px;\n  background: #8080806b;\n  color: black;\n  font-family: poppins;\n  font-size: 21px;\n  text-align: center;\n  padding: 5px 8px;\n  border-radius: 10px 10px 0px 0px;\n  font-weight: 400;\n}\n\n/* button.all_graph_buttonnewdiv {\n  width: 140px;\n  background: #80808094;\n  color: black;\n  font-family: poppins;\n  font-size: 21px;\n  text-align: center;\n  padding: 5px 8px;\n  border-radius: 10px 10px 0px 0px;\n  font-weight: 400;\n} */\n\n.graph-newdesign11 {\n  display: flex;\n  margin-left: 30px;\n}\n\n@media (min-width: 320px) and (max-width: 420px) {\n  .slider-image-div img {\n    height: 400px !important;\n    object-fit: cover !important;\n    padding: 0px 10px;\n  }\n  .slider-image-div {\n    height: auto;\n    padding: 0 0px !important;\n  }\n}\n\n@media (min-width: 320px) and (max-width: 767px) {\n  p.dataTitle {\n    font-size: 16px !important;\n  }\n\n  .form-outline.mb-2 {\n    height: 80px !important;\n  }\n\n  p.Subscription {\n    font-size: 18px !important;\n  }\n\n  .homepagepay {\n    background: #42c1f4 !important;\n    padding-bottom: 12px !important;\n  }\n\n  .auth-divide-section {\n    display: block !important;\n  }\n\n  .Registerpage {\n    margin: 0px 20px !important;\n  }\n\n  .forgotpage {\n    margin: 0px 20px !important;\n  }\n  .spaceonright {\n    left: 40% !important;\n    top: 90% !important;\n  }\n\n  select.custom-select.custom-select-sm.form-control.form-control-sm {\n    width: 80% !important;\n  }\n\n  .tobtext {\n    top: 30% !important;\n  }\n\n  table {\n    border-collapse: collapse !important;\n    width: 100% !important;\n  }\n  .dataTable td {\n    font-size: 11px !important;\n  }\n\n  /* .table-responsive {\n  margin: 130px 0 0;\n  font-family: \"Figtree\", sans-serif;\n} */\n\n  input.form-control.form-control-sm.ml-0.my-1 {\n    max-width: auto !important;\n    height: 45px !important;\n    float: none !important;\n  }\n\n  .dataTable th {\n    font-size: 12px !important;\n    padding: 10px 10px !important;\n  }\n\n  .thanktexthome.userlist {\n    padding: 0px 10px !important;\n  }\n\n  img.logo-dashboard {\n    width: 110px !important;\n  }\n\n  .rounded-border-contnet {\n    width: 40px !important;\n    height: 40px !important;\n  }\n\n  img.imgPro {\n    width: 16px !important;\n  }\n\n  p.count {\n    font-size: 13px !important;\n  }\n\n  .heading h1 {\n    font-size: 23px !important;\n    margin-bottom: 12px !important;\n  }\n\n  .elementor-widget-container {\n    font-size: 22px !important;\n  }\n  .spaceonright {\n    margin-top: 90px !important;\n    /* padding-bottom: 12px !important; */\n    /* display: flex;\n    align-items: center;\n    justify-content: center !important;\n    text-align: center; */\n  }\n  .logo-m img {\n    max-width: 120px !important;\n    margin: 0 auto !important;\n  }\n  .container-text {\n    width: 100% !important;\n  }\n  .mobl {\n    display: block !important;\n  }\n  .topdiv {\n    overflow: unset !important;\n  }\n  .logo-m {\n    display: block !important;\n  }\n  .togglediv {\n    display: flex;\n    padding: 0 20px;\n  }\n\n  .logo-m {\n    width: 100%;\n  }\n  button.togglebtn {\n    display: block !important;\n  }\n  .logomenu {\n    width: 100% !important;\n    display: block !important;\n    padding: 0 !important;\n  }\n  .logomenu li {\n    padding: 10px 0 !important;\n    border-bottom: 1px solid #dddd !important;\n  }\n  .scrolled .logonavbar {\n    position: absolute !important;\n  }\n  .newlogo {\n    width: 150px;\n    display: none;\n  }\n  .mobl .newlogomenu {\n    position: absolute;\n    background: #000;\n    width: 230px;\n    z-index: 9999;\n    top: 30px;\n    left: 20px;\n    padding: 0 10px;\n  }\n  .logonavbar {\n    width: 200px !important;\n    padding: 20px 10px;\n    z-index: 999;\n    border-top: unset !important;\n    margin-top: 34px !important;\n    background: #000;\n    display: none;\n  }\n  p.emailtext {\n    display: none;\n  }\n  .oneinputtitle {\n    margin-top: 0 !important;\n  }\n\n  .Data-plotting {\n    display: block !important;\n  }\n  .Data-plotting .graphplot {\n    width: 100% !important;\n  }\n  .graphdetail {\n    width: 100% !important;\n  }\n  .graphdetail > div {\n    margin-top: 0 !important;\n    display: unset !important;\n  }\n  .icondown {\n    margin-left: 5px !important;\n    margin-top: 10px !important;\n    float: unset !important;\n    display: unset !important;\n  }\n  .select-steps-contnet {\n    font-size: 16px !important;\n  }\n  .clusterPlot141 {\n    display: block !important;\n  }\n  button.i-contnet-btn {\n    border-radius: 100% !important;\n    width: 30px !important;\n    height: 30px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    margin-left: 5px !important;\n  }\n\n  .confidenceContainer {\n    display: block !important;\n    margin-left: -9px !important;\n  }\n\n  .confidence {\n    width: 97% !important;\n    margin-left: 0 auto !important;\n  }\n\n  .clusterPlot.clusterPlot141 {\n    width: 97% !important;\n    margin-left: 10px !important;\n  }\n\n  .clustergraph svg.recharts-surface {\n    margin-top: 16px !important;\n    height: auto !important;\n  }\n\n  .oneinputtitle.select-method {\n    margin-top: 13px !important;\n  }\n\n  .dataresult {\n    display: block !important;\n    margin-bottom: 12px !important;\n  }\n\n  .datashow {\n    width: 100% !important;\n    margin-bottom: 18px !important;\n  }\n\n  .result {\n    width: 100% !important;\n  }\n\n  .Data-plotting {\n    margin-left: 0 !important;\n  }\n\n  /* .Data-plotting .graphplot {\n  width: auto !important;\n} */\n\n  /* .recharts-wrapper {\n    width: 270px !important;\n  } */\n\n  p.dataTitle.preprosesing-cont {\n    margin-top: 40px !important;\n  }\n\n  p.dataTitle.confidence-cont {\n    margin-top: 46px !important;\n  }\n\n  label.select-toggle-btn {\n    font-size: 12px !important;\n  }\n\n  h2.number-lenght.text-red-800 {\n    margin-bottom: 21px !important;\n  }\n\n  .straoght-border {\n    margin-left: -4px !important;\n\n    margin-top: -11px !important;\n  }\n  .straoght-border {\n    width: 65px !important;\n\n    margin-left: -10px !important;\n  }\n\n  h2.number-lenght.text-red-800 {\n    display: flex !important;\n    justify-content: center !important;\n  }\n\n  h2.number-lenght.text-red-800 {\n    width: 40px !important;\n  }\n  .Services1 {\n    width: 100% !important;\n  }\n  .allServices {\n    display: block !important;\n  }\n  .Services {\n    background-size: cover !important;\n  }\n  .Services-top .grid {\n    display: unset !important;\n  }\n  .Services-top {\n    padding: 0 30px !important;\n  }\n\n  .changing-content {\n    font-size: 22px !important;\n\n    line-height: inherit !important;\n  }\n  .test-1 {\n    font-size: 13px !important;\n  }\n  h1.Servicestitle {\n    font-size: 24px !important;\n    text-align: center !important;\n  }\n  h1.Contacttitle {\n    font-size: 24px !important;\n    text-align: center !important;\n  }\n  .Contactsecdiv-text {\n    width: 100% !important;\n    display: unset !important;\n  }\n  h2.contactlink {\n    font-size: 18px !important;\n\n    margin: 0px 0 30px !important;\n    text-align: center !important;\n  }\n  .Services-icon {\n    margin: 5px auto 2px !important;\n    transform: rotate(90deg) !important;\n  }\n  .footer {\n    display: block !important;\n  }\n  .topdiv {\n    height: auto !important;\n  }\n  .Contactsecdiv {\n    display: block !important;\n    margin: 30px 0 !important;\n  }\n  .Contactsecdiv-img {\n    width: 100% !important;\n  }\n  .tobtext h1 {\n    font-size: 18px !important;\n    padding: 0 20px !important;\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 767px) and (max-width: 1170px) {\n}\n\n.loginRight .loginsigin li {\n  list-style: none;\n}\n.topdiv {\n  height: auto !important;\n}\n/* .elementor-widget-container {\n\n  font-size: 32px !important;\n  \n} */\n/* .changing-content {\n  font-size: 32px !important;\n} */\n.Services-top {\n  padding: 0 15px !important;\n}\n.Services1 {\n  padding: 10px 10px !important;\n}\n.tobtext h1 {\n  font-size: 30px;\n  padding: 0 20px !important;\n}\n.bgCo {\n  background: #42c1f4 !important;\n}\n\n.loginRight {\n  position: absolute;\n  background: #fff;\n  width: 150px;\n  box-shadow: 0px 13px 18px #eee;\n  padding: 20px;\n  right: 0;\n  top: 98px;\n  border-top: 4px solid #1acb1a;\n  border-radius: 4px 3px 0px 0px;\n}\n\n.drop_down_open {\n  cursor: pointer;\n}\n\n.home_active .Header-main-div {\n  position: absolute;\n  top: 0;\n  z-index: 9999;\n  left: 0;\n  right: 0;\n  background: transparent !important;\n}\n\n.home_active {\n  position: relative;\n}\n\n.active-header-info {\n  border-bottom: 2.5px solid #1e40af;\n  color: #000 !important;\n  font-weight: 500;\n  padding: 0px 0px 8px 0px;\n}\n\nimg.HomeimgSize {\n  width: 100%;\n  max-width: 40px;\n  padding: 6px 0px;\n}\n\n.active > .page-link,\n.page-link.active {\n  z-index: 3;\n  color: var(--bs-pagination-active-color);\n  background-color: #0746a5;\n  border-color: var(--bs-pagination-active-border-color);\n}\n\n.first-tab,\n.second-tab,\n.third-tab {\n  padding: 3px 0px;\n}\n\n.blogs_forms {\n  width: 100%;\n  max-width: 600px;\n}\n\n/* css dec 14  */\n\n.toggle-data-main {\n  display: none;\n}\n\n.contactuspage {\n  margin: 0 0 10px;\n}\n\n.menu-icon,\n.cross-icon {\n  color: white;\n}\n\n/* SWAL  */\n\n.errorAlert .swal-text,\n.errorAlert-login .swal-text {\n  color: #d14f4f;\n}\n\n.successAlert .swal-text,\n.successAlert-login .swal-text {\n  color: #59cf65;\n}\n\n.swal-button--danger {\n  background-color: #e64942 !important;\n  width: 86px !important;\n}\n\n.swal-button--cancel {\n  color: #555;\n  background-color: #efefef;\n  width: 86px !important;\n  border: none;\n  outline: none;\n}\n\n.swal-text {\n  text-align: center;\n  font-family: \"Figtree\", sans-serif;\n}\n\n/* .swal-icon:first-child {\n  margin-top: 55px;\n} */\n.swal-icon:first-child {\n  margin-top: 27px;\n}\n\n/* .swal-icon:first-child {\n  margin-top: 45px;\n} */\n\n.swal-icon {\n  margin: 10px auto;\n}\n\n.errorAlert .swal-title,\n.errorAlert-login .swal-title {\n  color: #d14f4f;\n  font-family: \"Figtree\", sans-serif;\n  letter-spacing: 0.5px;\n}\n\n.warningAlert .swal-title,\n.warningAlert-login .swal-title {\n  color: #d99836;\n  font-family: \"Figtree\", sans-serif;\n  letter-spacing: 0.5px;\n}\n\n.successAl1ert .swal-title,\n.successAlert-login .swal-title {\n  color: #59cf65;\n  font-family: \"Figtree\", sans-serif;\n  letter-spacing: 0.5px;\n}\n\n.swal-modal .swal-text {\n  color: #49454f;\n  font-family: \"Figtree\", sans-serif;\n  letter-spacing: 0.25px;\n  margin-top: 0px;\n}\n\n.swal-title {\n  padding: 0px 16px !important;\n  font-size: 16px !important;\n}\n\n.swal-footer {\n  text-align: center !important;\n}\n\n.css-1qqsdnr-MuiAutocomplete-root\n  .MuiAutocomplete-inputRoot\n  .MuiAutocomplete-input {\n  width: 0;\n  min-width: 30px;\n  max-height: 12px !important;\n}\n\n.css-1qqsdnr-MuiAutocomplete-root .MuiOutlinedInput-root {\n  height: 40px !important;\n}\n\n.eventSearchbar\n  .css-1qqsdnr-MuiAutocomplete-root\n  .MuiOutlinedInput-root\n  .MuiAutocomplete-input {\n  padding: 12px 15px !important;\n  outline: none !important;\n  border-radius: 0 !important;\n}\n\nsvg.MuiSvgIcon-root.MuiSvgIcon-fontSizeSmall.css-ptiqhd-MuiSvgIcon-root {\n  background: #1e40af;\n  color: white !important;\n  font-weight: bolder !important;\n  border-radius: 33px !important;\n  width: 25px !important;\n  height: 25px !important;\n  margin: -3px -5px !important;\n}\n\n/* .swal-icon img {\n  max-width: 100%;\n  max-height: 100%;\n  display: unset;\n} */\n\n.swal-icon img {\n  max-width: 100%;\n  max-width: 60px !important;\n  max-height: 100%;\n  display: unset;\n}\n\n.swal-footer {\n  text-align: right;\n  padding-top: 13px;\n  margin-top: 0 !important;\n  padding: 13px 16px;\n  border-radius: inherit;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.table-responsive {\n  margin: 40px 0 0;\n  font-family: \"Figtree\", sans-serif;\n}\n\n.table > :not(:first-child) {\n  border-top: 0 !important;\n}\n\n.dataTable td {\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.dataTable tr td:nth-child(2) {\n  align-items: center;\n  /* padding-top: 12px; */\n  padding-left: 10px;\n  /* padding-bottom: 10px; */\n  text-align: center;\n  height: 44px;\n}\n\n.dataTable tr td:nth-child(1) {\n  align-items: center;\n  /* padding-top: 12px; */\n  padding-left: 11px;\n  /* padding-bottom: 10px; */\n  text-align: center;\n  height: 44px;\n}\n\n/* .dataTable tr:nth-child(2n + 2) {\n  background: rgba(36, 114, 252, 0.08);\n  font-family: poppins !important;\n} */\n\n.dataTable tr:nth-child(2n + 2) {\n  background: rgb(148 142 209 / 37%);\n  font-family: poppins !important;\n}\n\n.dataTable\n  button.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.MuiButtonBase-root.deletebutt.css-1e6y48t-MuiButtonBase-root-MuiButton-root {\n  margin: 0 !important;\n  min-width: auto !important;\n}\n\n.dataTable a:hover {\n  background: none;\n}\n\n.table > thead {\n  vertical-align: bottom;\n  background: rgb(136 121 201 / 82%);\n}\n\n.col-sm-12.col-md-6 {\n  display: unset !important;\n  font-family: poppins !important;\n}\n\n.col-md-6 {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.savebtn {\n  width: 160px !important;\n  height: 47px;\n  grid-gap: 10px;\n  gap: 10px;\n  background: #2472fc00 !important;\n  font-size: 16px !important;\n  font-family: \"Figtree\", sans-serif;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px !important;\n  border: 1px solid #084ec5;\n  font-family: poppins !important;\n}\n\n.savebtn {\n  float: right;\n}\n\n.dataTable th {\n  font-size: 16px;\n  padding: 8px 25px;\n  font-weight: 700;\n  color: #000;\n  font-family: \"poppins\", sans-serif !important;\n}\n\n.table-bordered > :not(caption) > * > * {\n  border-width: 0 !important;\n}\n\n.table-bordered > :not(caption) > * {\n  border-width: 0px 0;\n}\n\n.homepagepay.usr {\n  background: #42c1f4;\n  padding-bottom: 35px;\n}\n.table-striped > tbody > tr:nth-of-type(odd) > * {\n  --bs-table-accent-bg: rgb(255 255 255);\n  color: var(--bs-table-striped-color);\n  font-family: poppins !important;\n}\n\n.css-1d3z3hw-MuiOutlinedInput-notchedOutline {\n  text-align: left;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  top: -5px;\n  left: 0;\n  margin: 0;\n  padding: 0 8px;\n  pointer-events: none;\n  border-radius: inherit;\n  border-style: solid;\n  border-width: 1px;\n  overflow: hidden;\n  min-width: 0%;\n}\n\nthead[data-test=\"table-foot\"] {\n  display: none;\n}\n\nselect.custom-select.custom-select-sm.form-control.form-control-sm {\n  height: 44px;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.bs-select select {\n  display: inline-block !important;\n}\n\n.bs-select select {\n  float: left;\n  width: 100%;\n}\n\n.form-control-sm {\n  min-height: calc(1.5em + 0.5rem + 2px);\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  border-radius: 0.25rem;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  appearance: none;\n  border-radius: 0.375rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.custom-select-sm {\n  margin: 0 !important;\n  height: 50px;\n  width: 150px;\n  border-radius: 8px;\n}\n\n/* input.form-control.form-control-sm.ml-0.my-1 {\n  height: 47px;\n  margin: 0 11px;\n  max-width: 335px;\n  border-radius: 8px;\n  display: flex;\n  align-items: flex-end !important;\n  justify-content: flex-end !important;\n  float: right;\n} */\n\ninput.form-control.form-control-sm.ml-0.my-1 {\n  height: 34px;\n  /* margin: 0 11px; */\n  max-width: 335px;\n  /* border-radius: 8px; */\n  display: flex;\n  align-items: flex-end !important;\n  justify-content: flex-end !important;\n  float: right;\n}\n\nbutton.MuiButtonBase-root.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.close_btn.css-1e6y48t-MuiButtonBase-root-MuiButton-root {\n  margin-right: 23px;\n  background: #2472fc !important;\n  color: #fff !important;\n  font-family: \"Figtree\", sans-serif !important;\n  font-size: 16px !important;\n  border-radius: 4px !important;\n  margin-right: 16px !important;\n  padding: 6px 25px !important;\n  margin: 0px 16px 0 0 !important;\n  text-transform: capitalize !important;\n  width: 107px;\n}\n\nbutton.MuiButtonBase-root.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.submit_block.css-1e6y48t-MuiButtonBase-root-MuiButton-root {\n  border: 2px solid #2472fc;\n  border-radius: 4px;\n  padding: 4px 25px;\n  color: #2472fc;\n  font-family: \"Figtree\", sans-serif !important;\n  text-transform: none;\n  font-weight: 600 !important;\n  font-size: 16px !important;\n  width: 107px;\n  background: none;\n}\n\n/* h2#\\:r1\\: {\n  border-bottom: 1px solid rgb(204, 194, 194);\n  padding: 10px 30px;\n} */\n\nselect.active_blockinput {\n  width: 100%;\n  border: 1px solid;\n  padding: 7px 13px;\n  font-size: 19px;\n  font-weight: 62%;\n  height: 50px;\n  border-radius: 4px;\n}\n\n/* DEC 15  */\n\n/* .toggle-data-main {\n  position: absolute;\n  top: 23px;\n} */\n\n.logout-section {\n  position: fixed;\n  top: 50%;\n  right: 0;\n  background: #3bd56a;\n  padding: 14px;\n  border-radius: 50%;\n  z-index: 11111;\n}\n\n.swal-modal {\n  max-width: 348px;\n  background-color: #fff;\n  min-width: 340px;\n  border-radius: 8px;\n  box-shadow: 3px 4px 5px 1px #00000080;\n  height: auto;\n}\n\n/* Dec 16  */\n.contact-email-logo {\n  background: #3730a3;\n  font-size: 15px;\n  color: #fff;\n  border-radius: 50px;\n  padding: 15px;\n}\n\n.log-out-icon {\n  color: #fff;\n  padding: 5px 7px 0 0;\n}\n\n.profile_dialog-box\n  .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation24.MuiDialog-paper {\n  width: 100%;\n  min-width: 950px;\n  height: 100%;\n  min-height: 600px;\n}\n\ni.fa-solid.fa-xmark {\n  float: right;\n}\n\nbutton.add-event-btn {\n  color: blue;\n  border: 1px solid blue;\n  border-radius: 4px;\n  font-size: 13px;\n  padding: 6px;\n}\n\nbutton.remove-event-btn {\n  color: red;\n  border: 1px solid red;\n  border-radius: 4px;\n  font-size: 13px;\n  padding: 6px;\n}\n\n/* side bar icon css0 */\nimg.iconimage-path {\n  max-width: 30px;\n}\n\nspan.ml-3.flex-1.whitespace-nowrap {\n  /* font-size: 18px; */\n  font-weight: 400;\n}\n\n/* 20 Dec 2022 */\n.Topdiv {\n  background: rgba(36, 114, 252, 0.06);\n}\n\n.Topdiv {\n  width: 100%;\n  float: left;\n}\n\n.Topdiv {\n  position: relative;\n}\n\n.verifydiv {\n  background: rgba(36, 114, 252, 0.06);\n}\n\n.verifyemail {\n  max-width: 600px;\n}\n\n.login-content {\n  max-width: 380px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  width: 90%;\n}\n\n.verifylogo {\n  text-align: center;\n}\n\nimg.login-logo {\n  max-width: 200px;\n  display: unset;\n}\n\n.verifyemailtext {\n  text-align: center;\n}\n\n.verifyemailtext h1 {\n  padding: 17px 0 12px;\n}\n\na.successfullyButton {\n  padding: 10px;\n  color: #1e22aa;\n  text-transform: capitalize;\n  font-size: 16px;\n  width: 160px;\n  display: inline-block;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 47px;\n  border-radius: 8px;\n  margin: 31px auto 0;\n  border: 1px solid #1e22aa;\n}\n\n.thankyoupage {\n  background: rgba(36, 114, 252, 0.06);\n}\n\n.login-content-registering {\n  max-width: 500px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  width: 90%;\n}\n\n.thanktext {\n  padding: 25px;\n  width: 100%;\n  border: 1px solid #0d6efd00;\n  border-radius: 8px;\n  box-shadow: 0px 1px 5px #0d6efd45;\n  background: #fff;\n}\n\n.logo-content {\n  text-align: center;\n  margin: 10px 0 20px;\n}\n\n.thanktext p {\n  line-height: 28px;\n  text-align: center;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n/* 20 Dec 2022 */\n\n/* 21 Dec 2022 */\n.login-links a {\n  color: #4338ca;\n}\n\n.login-links.last-link a {\n  color: #c74646;\n  margin-top: 20px;\n}\n\nul.navbar-link-items {\n  display: flex;\n  justify-content: center;\n  align-items: baseline;\n}\n\n.blog-item.first {\n  border-top: 0px solid;\n  padding-top: 0;\n}\n\n.blog-item {\n  border-top: 2px solid #ddd;\n  padding-top: 15px;\n}\n\n/* .container.fighting-imges {\n  max-width: 1180px;\n} */\n\n@media (min-width: 1550px) and (max-width: 1900px) {\n  img.fight-finder-ligo {\n    width: 80% !important;\n  }\n\n  /* .box-div {\n    padding: 119px;\n  } */\n  .container.absolute.top-50.text-center {\n    left: 12rem;\n  }\n}\n\n.grop-box-content.relative.flex.flex-col.items-start.px-6.bg-white.border.border-t-0.border-gray-200.py-7.rounded-b-2xl {\n  min-height: 70%;\n}\n\nh1.empty-data {\n  font-size: 24px;\n  text-align: center;\n  color: black;\n  padding: 54px 10px;\n  text-transform: uppercase;\n}\n\n.event-dataimg img {\n  float: left;\n  margin-right: 15px;\n  margin-bottom: 2px;\n}\n\n.eventimg-contnet img {\n  height: 100%;\n}\n\n.eventimg-contnet {\n  height: 240px;\n  overflow: hidden;\n}\n\n.heading-contnet-fight {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 11%;\n  top: 0 !important;\n  width: 100%;\n}\n\n.focus\\:ring-4:focus {\n  box-shadow: unset;\n}\n\niframe.map_image {\n  height: 400px;\n}\n\n/* .related-blogs-contnet {\n  float: left;\n} */\n.fontsize20 {\n  font-size: 24px;\n  font-weight: bold;\n}\n\ninput.form-control.input-groups {\n  border-radius: 50px 0px 0px 50px;\n}\n\n.search_bar .form-control:focus {\n  box-shadow: unset;\n}\n\n.search_bar button:hover {\n  background: #060692;\n}\n\n/* \n.Home-events-img {\n  height: 410px;\n}\n.Home-events-img.relative img {\n  height: 100%;\n} */\n\n/* .Home-events-actives {\n  height: 440px !important;\n} */\n\n/* .Home-events-actives img {\n  height: 100%;\n  width: 100%;\n} */\n.fighter-images-events1 {\n  height: 400px;\n  overflow: hidden;\n}\n\n.fighter-images-events1 img {\n  width: 100%;\n  height: 400px;\n  object-fit: cover;\n}\n\n.Home-events-img-contnet {\n  height: 410px;\n  width: 100%;\n}\n\n.Home-events-img-contnet img {\n  height: 100%;\n  width: 100%;\n}\n\n.eventimg-contnet img {\n  width: 100%;\n}\n\n.dataTable tr td:nth-child(3) {\n  align-items: center;\n  /* padding-top: 12px; */\n  padding-left: 10px;\n  /* padding-bottom: 10px; */\n  text-align: center;\n  height: 44px;\n}\n\n.dataTable tr td:nth-child(4) {\n  align-items: center;\n  /* padding-top: 12px; */\n  padding-left: 10px;\n  /* padding-bottom: 10px; */\n  text-align: center;\n  height: 44px;\n}\n\n.dataTable tr td:nth-child(5) {\n  align-items: center;\n  /* padding-top: 12px; */\n  padding-left: 10px;\n  /* padding-bottom: 10px; */\n  height: 44px;\n}\n\n.dataTable tr td:nth-child(7) {\n  align-items: center;\n  /* padding-top: 12px; */\n  padding-left: 10px;\n  /* padding-bottom: 10px; */\n  height: 44px;\n}\n\n.box-div.bg-blue-800.py-8.pb-5.px-3.my-4.transition.ease-in-out.delay-150.hover\\:-translate-y-1.hover\\:scale-70.hover\\:bg-blue-500.duration-300.hover\\:text-white.w3-animate-zoom.ease-in {\n  height: 193px;\n}\n\n.welcome-event-home {\n  top: 30% !important;\n  font-family: \"Rajdhani\", sans-serif;\n  left: 30px;\n}\n\n.welcome-event-home11 {\n  top: 25% !important;\n  font-family: \"Rajdhani\", sans-serif;\n  left: 30px;\n}\n\nbutton.blog-btn.bg-blue-800.hover\\:bg-blue-700.text-white.uppercase {\n  font-size: 12px;\n  width: 60px;\n  padding: 3px;\n  border-radius: 3px;\n  margin-right: 17px;\n  letter-spacing: 2px;\n  font-weight: 500;\n  font-family: \"Rajdhani\";\n}\n\n.not-fount-data {\n  font-size: 27px;\n  color: black;\n  text-align: center !important;\n  width: 100%;\n}\n\n.not-fount-data_content {\n  text-align: center;\n  font-size: 25px;\n  color: black;\n}\n\n.fight-finder-header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 99;\n  transition: all 0.3s ease-out 0s;\n  padding: 24px;\n  background-color: white;\n  font-family: poppins !important;\n}\n\n/* 9-01-2023 */\n.userpage {\n  background: #fff;\n  width: 97%;\n  margin: 0px auto;\n  padding: 40px;\n  border-radius: 8px;\n}\n\n.SelectEventTypeDiv .MuiInputBase-root.MuiOutlinedInput-root {\n  width: 100%;\n}\n\n.SelectEventTypeDiv h1 {\n  margin-bottom: 10px;\n}\n\n.UserdetailsEventsDiv h1 {\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  margin-top: 20px;\n}\n\n.eventTitleInput {\n  width: 100%;\n  height: 48px;\n  padding: 0 10px;\n  background: #fff;\n  border: 1px solid #ddd;\n  /* margin-bottom: 10px; */\n  border-radius: 8px;\n  margin-top: 5px;\n}\n\n.SelectEventTypeDiv\n  .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {\n  padding: 11px 14px;\n}\n\n.SelectEventTypeDiv .MuiOutlinedInput-notchedOutline {\n  border-color: #ddd;\n  border-radius: 8px;\n}\n\n.AgeEventsDiv h4 {\n  margin-bottom: 4px;\n}\n\n.AgeEventsDiv\n  .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary {\n  width: 100%;\n  margin-bottom: 19px;\n}\n\n.AgeEventsDiv .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input {\n  padding: 12px 14px;\n}\n\nfieldset.MuiOutlinedInput-notchedOutline {\n  border-color: #ddd;\n  border-radius: 8px;\n}\n\n.CompLevelEventsDiv h4 {\n  margin-bottom: 6px;\n}\n\n.CompLevelEventsDiv\n  .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary {\n  width: 100%;\n  margin-bottom: 19px;\n}\n\n/* .SelectEventTypeDiv {\n  margin: 0 !important;\n} */\n\n.countryEventsDiv h4 {\n  margin-bottom: 6px;\n}\n\n.EventdetailsEventsDiv h1 {\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  margin-top: 20px;\n}\n\n.EventAddAddressArea textarea.eventAddressArea {\n  width: 100%;\n  height: 200px !important;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  /* margin-bottom: 19px; */\n  margin-top: 6px;\n  padding: 6px;\n}\n\n.descrclass,\ninput.eventZipCodeInput {\n  width: 100%;\n  height: 48px;\n  padding: 0 10px;\n  background: #fff;\n  border: 1px solid #ddd;\n  /* margin-bottom: 19px; */\n  border-radius: 8px;\n  /* margin-top: 8px; */\n}\n\n.SelectEventCountryDiv h1 {\n  margin: 0 0 6px;\n}\n\n.countryEventsDiv\n  .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary {\n  width: 100%;\n}\n\n.SelectEventCountryDiv\n  .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary {\n  width: 100%;\n  margin-bottom: 19px;\n}\n\n.MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input {\n  padding: 12px 13px;\n}\n\n.taskDueDate .MuiInput-underline:before {\n  border-bottom: none;\n}\n\nlabel.taskDueDate {\n  border: 1px solid #ddd;\n  height: 57px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 200px;\n  padding: 0 10px;\n  margin: 6px 0 19px;\n}\n\n.SelectEventDateDiv .MuiInput-underline:hover:not(.Mui-disabled):before {\n  border-bottom: none;\n}\n\n.SchooldetailsEventsDiv h1 {\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 20px;\n}\n\n.OrganizerSocialEvent .css-14lo706 {\n  display: none;\n}\n\n.OrganizerSocialEvent .css-14lo706 span {\n  display: none;\n}\n\n.userform {\n  max-width: 600px;\n}\n\n.SchoolEventTimeEvent legend {\n  display: none;\n}\n\n.SchoolEventTimeEvent label {\n  display: none;\n}\n\n/* .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input {\n  font: inherit;\n  letter-spacing: inherit;\n  color: currentColor;\n  padding: 4px 0 5px;\n  border: 0;\n  box-sizing: content-box;\n  background: none;\n  height: 31px !important;\n  margin: 0;\n  -webkit-tap-highlight-color: transparent;\n  display: block;\n  min-width: 0;\n  width: 100%;\n  -webkit-animation-name: mui-auto-fill-cancel;\n  animation-name: mui-auto-fill-cancel;\n  -webkit-animation-duration: 10ms;\n  animation-duration: 10ms;\n  padding: 11px 14px 12px;\n  padding-right: 0;\n} */\n\n.SchoolEventTimeEvent .MuiInputAdornment-root.MuiInputAdornment-positionEnd {\n  padding: 0;\n}\n\n/* .SchoolEventTimeEvent input {\n  padding: 9px 11px 13px;\n} */\n.SchoolEventTimeEvent h1 {\n  margin-bottom: 6px;\n}\n\n/* .SchoolEventTimeEvent .MuiFormControl-root.MuiTextField-root {\n  margin-bottom: 20px;\n} */\n.taskDueDate .MuiFormControl-root.MuiTextField-root {\n  margin-bottom: 0;\n}\n\n.OrganizerSocialEvent h1 {\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  margin-top: 20px;\n}\n\n.EventAcceptForeignDiv {\n  margin: 0 0 20px;\n}\n\n.EventAcceptForeignDiv h1 {\n  margin: 0 0 8px;\n}\n\n.EventAcceptForeignDiv label {\n  margin: 0 10px;\n}\n\n.EventDetailsEventDiv,\n.SpecialInstEvent,\n.DateSeminarEvent {\n  margin: 0 0 0px;\n}\n\n.SubmitHandlerEventAdd button {\n  background: #1e22aa;\n  color: #fff;\n  padding: 11px 43px;\n  text-transform: uppercase;\n  font-size: 15px;\n  font-weight: bold;\n  letter-spacing: 0.3px;\n  /* margin: 15px 0 0; */\n  border: none;\n}\n\n/* .SelectEventCountryDiv input {\n   margin: 0 0 10px;\n} */\n.CostSeminarEvent,\n.EventAddZipCodeArea h4 {\n  margin-bottom: 6px;\n}\n\n.DateSeminarEvent h1 {\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 20px;\n}\n\n.SpecialInstEvent h1 {\n  margin-bottom: 8px;\n}\n\n.SpecialInstEvent textarea {\n  height: 200px !important;\n  /* margin-top: 9px; */\n  padding: 10px;\n}\n\n.EventDetailsEventDiv textarea {\n  height: 200px !important;\n  margin-top: 9px;\n  padding: 10px;\n}\n\n.CostSeminarEvent h1 {\n  margin: 0 0 6px;\n}\n\n/* .Minimumdiv {\n  display: flex;\n  margin-top: 7px;\n  width: 100%;\n} */\n/* .Minimum {\n  width: 50%;\n  margin-right: 10px;\n} */\n/* .Minimum1 {\n  width: 50%;\n} */\n.Minimumdiv h4 {\n  margin-bottom: 6px;\n}\n\n.SelectEventCountryDiv textarea {\n  height: 200px !important;\n  padding: 6px;\n}\n\ninput:focus-visible {\n  outline: none;\n}\n\ninput:focus {\n  border: 1px solid #0072ff;\n}\n\n.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-width: 1px !important;\n}\n\ntextarea:focus-visible {\n  outline: none;\n}\n\n.auth-logo-contnet {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\nimg.auth-logo {\n  width: 30% !important;\n}\n\n.auth-logo-contnet-register {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.App_import input#email {\n  font-size: 14px;\n  font-weight: 300;\n}\n\n.App_import input#password {\n  font-size: 14px;\n  font-weight: 300;\n}\n\n.login-form-fight {\n  font-family: poppins !important;\n}\n\nh1.title-font-blogs {\n  font-family: \"Rajdhani\", sans-serif;\n  font-size: 22px;\n  font-weight: 900;\n  font-style: normal;\n  line-height: 27px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: #000;\n}\n\n.post_meta {\n  margin-bottom: 15px;\n}\n\nspan.post_meta_item.post_date {\n  font-family: \"Rajdhani\", sans-serif;\n  font-weight: 700;\n}\n\np.leading-relaxed11 {\n  color: #000000e0;\n  font-size: 16px;\n  line-height: 30px;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 400;\n}\n\n.public-footer {\n  float: left;\n  width: 100%;\n  box-shadow: 1px 1px 4px #a3a3a3;\n}\n\n/* body {\n  font-family: \"Rajdhani\", sans-serif;\n} */\n\np.blog-title11.sm\\:text-xl.md\\:text-2xl.lg\\:text-2xl.xl\\:text-2xl.font-bold.text-blue-800 {\n  font-family: \"Rajdhani\", sans-serif;\n}\n\nul.footer-list-item {\n  font-family: poppins;\n}\n\n/* .achivements_button {\n  background: #1e40af;\n  color: #fff;\n  padding: 8px 20px;\n  font-weight: 500;\n  text-transform: uppercase;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 14px;\n} */\n\n.achivements_button {\n  background: #1e40af;\n  color: #fff;\n  padding: 4px 7px;\n  font-weight: 500;\n  text-transform: uppercase;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 14px;\n}\n\nh1.titelhome {\n  text-align: center;\n  padding-top: 50px;\n  color: #1e40af;\n  font-size: 38px;\n  font-weight: bold;\n}\n\nh4.fontsize56 {\n  text-align: center;\n  /* padding: 50px 0; */\n  color: #fff;\n  /* font-size: 56px; */\n  font-weight: bold;\n}\n\nh3.fontsize38 {\n  padding: 4px 0 4px;\n  color: #1e40af;\n  font-weight: bold;\n  font-family: \"Rajdhani\", sans-serif;\n}\n\nbutton.viewbtn {\n  background: #1e40af;\n  color: #fff;\n  padding: 12px 26px;\n  font-weight: 500;\n  text-transform: uppercase;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 14px;\n}\n\n.Home-events-img11 {\n  height: 370px;\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\nh4.pagetitleall {\n  text-align: center;\n  padding: 0 0 4px;\n  color: #fff;\n  font-size: 23px;\n  font-weight: bold;\n}\n\n.eventspage {\n  padding: 90px 0 30px;\n}\n\n.eventsec {\n  float: left;\n  width: 100%;\n  margin-bottom: 80px;\n}\n\n.Home-events-page {\n  width: 33.33%;\n}\n\n.eventimg {\n  height: 280px;\n  overflow: hidden;\n}\n\n.eventimg img {\n  object-fit: cover;\n  height: 100%;\n}\n\n.Home-events-page {\n  width: 32.33%;\n  margin: 5px;\n  box-shadow: 1px 1px 6px #ddd;\n  padding: 28px;\n  border-radius: 9px;\n  float: left;\n}\n\n.fighter-name2 {\n  padding: 20px 0 0;\n}\n\nspan.eventdate {\n  font-size: 18px;\n  color: #000;\n  margin-bottom: 7px !important;\n  display: inline-block;\n}\n\n.fighter-name2 h2 {\n  font-size: 24px !important;\n  font-weight: 700;\n  color: #1e40af;\n}\n\n.eventdetails {\n  float: left;\n  width: 100%;\n  padding: 30px 0 60px;\n}\n\nh2.relatedtitle {\n  text-align: center;\n  padding: 40px 0 60px;\n  color: #1e40af;\n  font-size: 38px !important;\n  font-weight: bold;\n  font-family: \"Rajdhani\", sans-serif;\n  float: left;\n  width: 100%;\n}\n\n.blogpage1 {\n  padding: 108px 0 39px;\n}\n\n.blogdetailepage {\n  padding: 50px 0 30px;\n}\n\n.commontext {\n  margin: -54px 0 20px;\n}\n\n.commontext span {\n  background: #1e40af;\n  color: #fff;\n  padding: 10px 19px;\n  font-size: 14px;\n  font-weight: 500;\n  text-transform: uppercase;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.datedetailssec {\n  background: #1e40af;\n  color: #fff;\n  padding: 10px 19px;\n  font-size: 14px;\n  font-weight: 500;\n  text-transform: uppercase;\n  font-family: \"Poppins\", sans-serif;\n}\n\nh1.blogtitledetails {\n  padding: 5px 0 14px;\n  color: #1e40af;\n  font-size: 38px;\n  font-weight: bold;\n  font-family: \"Rajdhani\", sans-serif;\n}\n\n.aboutpage {\n  padding: 50px 0;\n}\n\n.bakground {\n  background: #f7f7f7;\n  width: 100%;\n  float: left;\n}\n\nh2.titleourpage {\n  text-align: center;\n  padding: 50px 0 0;\n  color: #1e40af;\n  font-size: 38px !important;\n  font-weight: bold;\n}\n\n/* .addevent {\n  margin-top: 162px;\n  margin-bottom: 40px;\n} */\n.Relatedevents {\n  width: 100%;\n  float: left;\n}\n\n.terms-cojnn p {\n  font-size: 15px;\n  line-height: 30px;\n}\n\n.eventimg-contnet {\n  width: 100%;\n  float: left;\n}\n\n.event-dataimg {\n  float: left;\n  width: 100%;\n}\n\n.related-blogs-contnet {\n  float: left;\n}\n\n.eventsbak {\n  background-size: cover;\n  background-repeat: no-repeat;\n  opacity: 0.8;\n  padding: 24px 24px;\n  margin: 0 0 -4px;\n}\n\n.fourth-contnet-font-fam {\n  font-family: \"Poppins\";\n}\n\n/* scroll bar modify */\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n/* body {\n  overflow-y: scroll; \n}\nbody::-webkit-scrollbar {\n    display: none;\n} */\n\n::-webkit-scrollbar {\n  width: 6px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 20px !important;\n}\n\n/* scroll bar modify */\n\n.menuhome {\n  position: relative;\n}\n\n.header-sidebar-coontnet {\n  position: absolute;\n  width: 100%;\n}\n\n.MuiAutocomplete-root.MuiAutocomplete-hasClearIcon.form-control.input-groups.font-normal.rounded-md.text-gray-700.bg-white.border.border-solid.border-gray-300.css-1qqsdnr-MuiAutocomplete-root {\n  padding: 0;\n  height: 40px;\n  border: none !important;\n}\n\n.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-fullWidth.MuiInputBase-formControl.MuiInputBase-adornedEnd.MuiAutocomplete-inputRoot.css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root {\n  padding: 2px;\n  border-radius: 0 !important;\n}\n\n.MuiAutocomplete-root.form-control.input-groups.font-normal.rounded-md.text-gray-700.bg-white.border.border-solid.border-gray-300.css-1qqsdnr-MuiAutocomplete-root {\n  padding: 0 !important;\n  height: 40px !important;\n  border: none !important;\n  border-radius: 30px 0px 0px 30px !important;\n  outline: none;\n}\n\n.searchsec\n  .css-1qqsdnr-MuiAutocomplete-root\n  .MuiOutlinedInput-root\n  .MuiAutocomplete-input {\n  padding: 11px 13px !important;\n}\n\n.css-1qqsdnr-MuiAutocomplete-root .MuiOutlinedInput-root {\n  padding: 1px !important;\n}\n\nbutton#mui-p-80405-T-1 {\n  font-family: \"Rajdhani\", sans-serif !important;\n  font-weight: bold;\n}\n\n.css-nwrfgk-MuiButtonBase-root-MuiTab-root {\n  color: black !important;\n  font-weight: 500;\n  font-size: 17px !important;\n  line-height: 1.25;\n  padding: 12px 16px;\n  font-weight: bold !important;\n  font-family: \"Rajdhani\", sans-serif !important;\n}\n\n.css-1aquho2-MuiTabs-indicator {\n  background-color: #42c1f4 !important;\n  font-family: \"Rajdhani\", sans-serif !important;\n}\n\n.org-div {\n  float: left;\n  width: 100%;\n}\n\n.searchsec fieldset.MuiOutlinedInput-notchedOutline {\n  border-color: none !important;\n  border-radius: 0;\n}\n\n.searchsec .search_bar button:hover {\n  background: none !important;\n}\n\n.searchsec .MuiButtonBase-root.MuiIconButton-root.MuiIconButton-sizeMedium {\n  background: none;\n}\n\n.search_bar input:focus {\n  border: none;\n}\n\n.searchsec fieldset.MuiOutlinedInput-notchedOutline {\n  border-radius: 50px 0 0 50px !important;\n}\n\ni.fa-solid.fa-arrow-right {\n  padding: 0px 6px;\n}\n\n.lkjDVC {\n  min-width: 322px;\n  max-width: 600px !important;\n  height: 48px;\n  border: dashed 2px #0a6ae7;\n  padding: 8px 16px 8px 8px;\n  border-radius: 5px;\n  cursor: pointer;\n  -webkit-box-flex: 0;\n  -webkit-flex-grow: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n}\n\n.css-1qqsdnr-MuiAutocomplete-root\n  .MuiAutocomplete-inputRoot\n  .MuiAutocomplete-input {\n  width: 0;\n  min-width: 30px;\n  height: 31px !important;\n}\n\n/* .MuiTabs-flexContainer.css-heg063-MuiTabs-flexContainer {\n  margin-left: 25px;\n} */\n.searchsec .MuiOutlinedInput-root .MuiAutocomplete-input {\n  padding: 7.5px 4px 7.5px 20px !important;\n}\n\n/* .we .css-13xfq8m-MuiTabPanel-root {\n  padding-top: 29px !important;\n} */\n\n.about-us-content td {\n  padding: 12px;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 35px;\n  font-family: \"Poppins\";\n  width: 50% !important;\n}\n\n.about-us-content img {\n  border-radius: 14px;\n  width: 100% !important;\n}\n\n/* .about-us-content h2 {\n  font-size: 21px !important;\n  font-family: \"Rajdhani\", sans-serif;\n  text-align: center;\n  font-weight: bold;\n} */\n\n.about-us-content table {\n  border-color: #f0f8ff00 !important;\n}\n\n.font-fam-contnet {\n  font-family: \"Rajdhani\", sans-serif;\n  font-size: 16px !important;\n}\n\n.popins-font-fam {\n  font-family: poppins !important;\n  font-size: 15px !important;\n}\n\n/* .inputCntnr.error {\n  border: 2px solid #d10d0dbf;\n  border-radius: 7px;\n} */\n\ntextarea.eventTitleInput-desc {\n  width: 100%;\n  height: 200px !important;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  /* margin-bottom: 19px; */\n  margin-top: 6px;\n  padding: 6px;\n}\n\n.css-1u3bzj6-MuiFormControl-root-MuiTextField-root {\n  width: 100% !important;\n  height: 50% !important;\n}\n\n.css-nxo287-MuiInputBase-input-MuiOutlinedInput-input {\n  padding: 13px 14px !important;\n}\n\nlabel[data-shrink=\"false\"]\n  + .MuiInputBase-formControl\n  .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input {\n  padding: 10px 14px !important;\n}\n\n.blogs_forms11 {\n  width: 80% !important;\n}\n\n.switch-box {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 34px;\n}\n\n.switch-box input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider-toggle {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\n.slider-toggle:before {\n  position: absolute;\n  content: \"\";\n  height: 26px;\n  width: 26px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\ninput:checked + .slider-toggle {\n  background-color: #2164f3;\n}\n\ninput:focus + .slider-toggle {\n  box-shadow: 0 0 1px #42c1f4;\n}\n\ninput:checked + .slider-toggle:before {\n  -webkit-transform: translateX(26px);\n  -ms-transform: translateX(26px);\n  transform: translateX(26px);\n}\n\n/* Rounded sliders */\n.slider-toggle.round {\n  border-radius: 34px;\n}\n\n.slider-toggle.round:before {\n  border-radius: 50%;\n}\n\n.MuiBox-root.css-0 {\n  padding-bottom: 12px !important;\n}\n\n.css-13xfq8m-MuiTabPanel-root {\n  padding: 0 !important;\n}\n\n/* 9 march */\n\n/* .feedbackAboutAreaMainD.events-search-feed {\n  width: 80%;\n} */\n\n.css-vqmohf-MuiButtonBase-root-MuiRadio-root.Mui-checked {\n  color: #193ad2 !important;\n}\n\n.react-slideshow-container .default-nav:first-of-type {\n  margin-right: 0px !important;\n  border-right: 14;\n  border-top: 0;\n  padding: 3px 10px 3px 7px !important;\n  left: 20px !important;\n}\n\n.react-slideshow-container .default-nav:last-of-type {\n  margin-left: 0px !important;\n  right: 20px !important;\n\n  padding: 3px 10px 3px 7px !important;\n}\n\n.react-slideshow-container .default-nav {\n  height: 30px;\n  background: rgb(255 255 255 / 30%);\n  width: 30px;\n  border: 0;\n  text-align: center;\n  color: #fff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ReactCollapse--collapse {\n  transition: height 500ms;\n}\n\n/* .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation24.MuiDialog-paper.MuiDialog-paperScrollPaper.MuiDialog-paperWidthSm.css-1t1j96h-MuiPaper-root-MuiDialog-paper {\n  width: 100%;\n  height: auto;\n} */\n\n.crop-contnet {\n  height: 0 max-content;\n  height: auto;\n  height: 0;\n  margin-left: -13px;\n  margin-top: 11px;\n}\n\ntextarea.event-desc-contnet {\n  width: 100%;\n  height: 200px !important;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  /* margin-bottom: 19px; */\n  margin-top: 6px;\n  padding: 6px;\n}\n\ni.fa.fa-search.text-black.text-md {\n  font-size: 17px;\n  padding-left: 4px;\n}\n\n.aero-angle-dowun {\n  transform: rotate(177deg);\n  height: 22px;\n}\n\ni.fas.fa-angle-down {\n  margin-left: 8px;\n  font-size: 19px;\n}\n\n.slider-image-div {\n  height: auto;\n  padding: 0 25px;\n}\n\n.evetns-search-image img {\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  object-fit: cover;\n  object-position: top;\n}\n\n.evetns-search-image {\n  height: 200px;\n  overflow: hidden;\n}\n\np.leading-relaxed11.file-search {\n  font-size: 12px !important;\n  line-height: 22px !important;\n}\n\nh1.title-font-blogs.events-search-title {\n  font-size: 19px;\n  /* margin-bottom: 2px !important; */\n}\n\np.post_meta_item11.post_date {\n  font-family: \"Rajdhani\", sans-serif;\n  font-weight: 700;\n}\n\ni.fas.fa-solid.fa-calendar-days {\n  font-size: 16px;\n  margin-right: 8px;\n}\n\ni.fa-solid.fa-globe {\n  margin-right: 8px;\n}\n\n.back-img-photo {\n  background-image: url(https://images.unsplash.com/photo-1499336315816-097655dcfbda?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=crop&amp;w=2710&amp;q=80);\n  background-size: cover;\n  width: 100%;\n  background-repeat: no-repeat;\n}\n\nsection.back-image-logo12 {\n  height: 100% !important;\n}\n\nmain.profile-page-thoughts {\n  margin-top: 33%;\n}\n\nmain.profile-page-thought-de {\n  margin-top: 27%;\n  margin-bottom: 3%;\n}\n\n.bell-tottal-count {\n  position: relative;\n}\n\nspan.total-noti-count {\n  position: absolute;\n  top: -7px;\n  left: 10px;\n  background: #ee2d2df2;\n  color: white;\n  border-radius: 20px;\n  height: 22px;\n  padding: 0px 5px;\n}\n\n.close-btn-back-profile {\n  float: right;\n  margin-bottom: 16px;\n}\n\n.profilePic-admin-image {\n  position: absolute;\n  top: -68px !important;\n  right: 13px;\n}\n\nlabel.upload-profileImg.absolute {\n  right: 18px;\n  bottom: 6px;\n}\n\n.notification-alert {\n  position: absolute;\n  width: 34%;\n  padding: 0px;\n  right: 0;\n  top: 85px;\n}\n\ni.fas.fa-caret-up {\n  font-size: 41px;\n  position: absolute;\n  bottom: -13px;\n  left: 38%;\n  color: #8080803d;\n}\n\nh1.see-all-noti-page {\n  margin-top: 21px;\n  border: 1px solid #8080804d;\n  padding: 9px 9px;\n  border-radius: 4px;\n}\n\n.fighting-imges-disussion {\n  min-height: 100vh !important;\n}\n\ni.far.fa-comment-dots.text-black {\n  font-size: 19px !important;\n}\n\n/* i.fa.fa-search {\n  font-size: 17px;\n} */\n\n.travel-div {\n  font-size: 36px;\n  text-align: center;\n  /* padding: 73px 0px; */\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 400;\n  font-family: poppins !important;\n}\n\n.the-martial-nexus {\n  text-align: center;\n  margin-left: 17px;\n  font-family: \"Rajdhani\", sans-serif;\n}\n\n.the-martial-nexus.uppercase h1 {\n  line-height: 22px;\n}\n\n/* .text-div-nexus {\n  width: 60%;\n  padding-left: 12%;\n} */\n\n/* .search-bar-for-event {\n  width: 40%;\n} */\n\n/* .typing-key-event {\n  top: 24%;\n} */\n\n.text-div-nexus {\n  /* width: 60%; */\n  /* padding-left: 12%; */\n  text-align: center;\n}\n\n.typing-key-event {\n  top: 15% !important;\n}\n\nbutton.tags-button-events {\n  background: #0743b1;\n  color: white;\n  font-weight: bold;\n  margin: 0px 10px;\n  width: 60px;\n  padding: 5px;\n  border-radius: 20px;\n  margin-top: 8px;\n}\n\n.insta-user img {\n  width: 6%;\n  object-fit: cover;\n}\n\n.insta-user {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.border-replay-comment {\n  border: 1px solid #80808070;\n  border-right: 2px solid var(--newCommunityTheme-line);\n  display: block;\n  height: 100%;\n  width: 50%;\n}\n\n.border-line-replay {\n  position: absolute;\n  height: calc(89% - 68%);\n\n  margin-left: 12px;\n}\n\n.social-media-text {\n  margin-left: 30px;\n}\n\narticle.comment-article {\n  margin-left: -44px;\n}\n\n.comment-text-pera {\n  margin-left: 47px !important;\n}\n\n.comment-art-box {\n  position: relative;\n}\n\n.border-replay-comment1 {\n  border: 1px solid #80808070;\n  border-right: 2px solid var(--newCommunityTheme-line);\n  display: block;\n  height: 100%;\n  width: 100%;\n}\n\n.border-line-replay1 {\n  position: absolute;\n  height: calc(100% - 0%);\n  margin-left: 12px;\n  width: 0;\n  top: 55px;\n  left: -20px;\n}\n\n.border-line-replay2 {\n  position: absolute;\n  height: calc(90% - 0%);\n  margin-left: 12px;\n  width: 0;\n  top: 55px;\n  left: -20px;\n}\n\n.border-replay-comment2 {\n  border: 1px solid #80808070;\n  border-right: 2px solid var(--newCommunityTheme-line);\n  display: block;\n  height: 100%;\n  width: 100%;\n}\n\n.deletion-dialog-delete\n  .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation24 {\n  max-width: 400px !important;\n  width: 100%;\n}\n\nbutton.delte-btn-dialog {\n  width: 100px;\n  background: #f75151;\n  color: white;\n  font-weight: 400;\n  padding: 5px 0px;\n  border-radius: 5px;\n}\n\nbutton.cancel-btn-dialog {\n  width: 100px;\n  background: #3360f7;\n  color: white;\n  font-weight: 400;\n  padding: 5px 0px;\n  border-radius: 5px;\n}\n\nbutton.save_profilepic {\n  width: 100px;\n  background: #3360f7;\n  color: white;\n  font-weight: 400;\n  padding: 7px 0px;\n  border-radius: 5px;\n}\n\nbutton.save_profilepic-btn {\n  width: 100px;\n  color: #3360f7;\n  font-weight: 400;\n  padding: 5px 0px;\n  border-radius: 5px;\n  border: 2px solid #3360f7;\n  margin-left: 12px;\n  margin-right: 12px;\n}\n\nbutton.deletion-btn-open-popup {\n  width: 120px;\n  background: #f04040c4;\n  color: white;\n  font-weight: 400;\n  padding: 7px 0px;\n  border-radius: 5px;\n}\n\n.profile-submit-buttons {\n  margin: 0px 26px;\n}\n\n.user-profile_discussion img {\n  width: 150px !important;\n  height: 150px !important;\n  object-fit: cover !important;\n}\n\n.discussion-cards-home {\n  width: 100% !important;\n  height: 265px !important;\n  min-height: 100% !important;\n}\n\nbutton.crop-contnet {\n  right: -35px;\n  top: -9px !important;\n  color: #808080a6;\n}\n\ni.fa.fa-edit.text-lg.text-gray-800 {\n  color: #808080cf;\n}\n\n.search-bar-usersearch {\n  /* position: absolute !important;\n  top: 12% !important; */\n  width: 100% !important;\n  left: 12%;\n}\n\n.search-userpopup {\n  position: absolute;\n  top: 26px;\n  left: 35px;\n}\n\n.input-group-user-search.searchsec {\n  width: 56%;\n}\n\n.search-bar-usersearch {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n}\n\n.searchsec1 .MuiAutocomplete-root.form-control.input-groups.font-normal {\n  width: 400px;\n}\n\nbutton.my-post-section {\n  background: #1e40afe3;\n  margin: 6px 11px;\n  padding: 6px 8px;\n  width: 118px;\n  border-radius: 6px;\n  color: white;\n}\n\n.search-input-users {\n  text-align: center;\n}\n\ninput.newSearchActInputPp {\n  width: 50% !important;\n  border-radius: 5px;\n  padding: 10px 9px;\n  border: 1px solid #8080806b;\n}\n\n/* phone number flag css */\n\n.react-tel-input .selected-flag .flag {\n  position: absolute;\n  top: 50% !important;\n  margin-top: -12px !important;\n}\n\n.react-tel-input .form-control {\n  font-size: 16px;\n  background: #ffffff;\n  border: 1px solid #cacaca8a;\n  border-radius: 0px !important;\n  width: 238px !important;\n  outline: none;\n  padding: 9px 50px !important;\n  /* transition: box-shadow ease .25s,border-color ease .25s; */\n  color: #495057;\n}\n\n.react-tel-input .form-control:focus {\n  background-color: #fff;\n  border-color: #1365bd !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.react-tel-input .selected-flag:before {\n  content: \"\";\n  display: block;\n  position: absolute;\n\n  border-radius: 4px 2px 2px 4px;\n  border: 1px solid transparent;\n  transition: box-shadow ease 0.25s, border-color ease 0.25s;\n  height: 0 !important;\n}\n\n/* phone number flag css */\n.follower-total-count {\n  cursor: pointer;\n}\n\nbutton.search-users-popup-btn {\n  background: #1266e5db;\n  color: white;\n  width: 114px;\n  padding: 5px 1px;\n  font-weight: 300;\n  font-family: poppins;\n  border-radius: 4px;\n}\n\n.search-users-popup {\n  float: right !important;\n}\n\n.common-tabs-posts {\n  height: 100% !important;\n}\n\n.btn-box-delete-info {\n  right: -42px !important;\n  top: 31px !important;\n}\n\n.searchsec button:hover {\n  background: #1e40af;\n}\n\n.no-posts-found {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 60px;\n}\n\n.terms-privacy-fight {\n  font-family: poppins !important;\n}\n\n.common-text-font-fam {\n  font-family: \"Rajdhani\", sans-serif;\n}\n\n.no-posts-found h1 {\n  font-size: 27px;\n  font-weight: 500;\n}\n\n/* canvas.mapboxgl-canvas {\n  width: 1256px !important;\n  height: 400px !important;\n} */\n\n.show-hide-password {\n  position: absolute;\n  bottom: 8px;\n  right: 11px;\n}\n\ninput.mapboxgl-ctrl-geocoder--input {\n  padding-left: 30px !important;\n}\n\n.filter-sort-by {\n  /* width: 25%; */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.eventSearchbar\n  fieldset.MuiOutlinedInput-notchedOutline.css-1d3z3hw-MuiOutlinedInput-notchedOutline {\n  /* FONT-VARIANT: JIS04; */\n  border-radius: 0 !important;\n}\n\n.eventSearchbar\n  .css-1qqsdnr-MuiAutocomplete-root\n  .MuiOutlinedInput-root\n  .MuiAutocomplete-input {\n  padding: 2.5px 1px 4.5px 7px;\n}\n\nbutton.search-enter-btn {\n  padding: 13px !important;\n  height: 40px !important;\n}\n\n.input-group.eventSearchbar {\n  margin-top: 36px;\n  margin-right: 12px;\n}\n\n.css-nwrfgk-MuiButtonBase-root-MuiTab-root.Mui-selected {\n  background-color: rgb(36 101 199) !important;\n  color: white !important;\n  border-color: rgb(36 101 199);\n  font-size: 17px;\n  font-weight: bold;\n  font-family: \"Rajdhani\", sans-serif !important;\n}\n\nbutton.all_jobs_poject_buttonnewdiv.active1 {\n  /* background: rgb(36 101 199); */\n  color: white;\n  font-size: 15px;\n  /* width: 101px; */\n  padding: 8px 10px;\n  font-weight: 500;\n  font-family: \"Poppins\";\n  /* margin-right: 12px; */\n  border: 0px solid rgb(36 101 199);\n}\n\nbutton.all_jobs_poject_buttonnewdiv {\n  color: rgb(30 64 175);\n  font-size: 14px;\n  padding: 8px 10px;\n  font-weight: 700;\n  font-family: \"Poppins\";\n  /* margin-right: 12px; */\n  border: 1px solid;\n}\n\n.aero-down-icon {\n  margin-top: -13px !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* margin-right: 15px; */\n}\n\ni.fas.fa-caret-down.aeroafflian {\n  font-size: 32px;\n  color: rgb(30 64 175);\n}\n\n.mactching-div {\n  text-align: center;\n  padding: 12px 12px;\n  color: white;\n  font-size: 17px;\n  font-family: \"Poppins\";\n  font-weight: 400;\n  margin-bottom: 12px;\n}\n\ni.fa.fa-search.search-user-icon {\n  position: absolute;\n  top: -5px;\n  right: 207px;\n  color: #808080c2;\n  z-index: 30;\n}\n\n.search-user-btn input {\n  border: 1px solid gray;\n  padding: 10px 31px;\n  border-radius: 30px;\n  position: absolute;\n  right: 0px;\n  top: -22px;\n  width: 100%;\n}\n\n/* .user-search-div {\n  position: absolute;\n  width: 35%;\n  right: 29%;\n  top: 98px;\n} */\n\n.user-search-div {\n  position: absolute;\n  width: 30%;\n  right: 35%;\n  top: 95px;\n}\n\ni.fas.fa-sort-down {\n  font-size: 20px;\n  margin-left: 14px;\n  height: 27px;\n}\n\ntextarea.thougt-textarea {\n  height: 200px !important;\n}\n\np.poem-word {\n  height: 166px !important;\n}\n\n.upcoming-evetns-near {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\nbutton.terms-privacy-fight:active {\n  background: #1e40af !important;\n}\n\n.slider-image-div img {\n  height: 620px;\n  object-fit: cover;\n  border-radius: 10px;\n}\n\n.transparent-image {\n  position: absolute;\n  bottom: 0;\n  padding: 170px 0px;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n\ntextarea.w-full.px-3.py-2.border.border-slate-400.placeholder-text-sm.rounded {\n  height: 100px !important;\n}\n\n.search-bar-for-event {\n  /* width: 40%; */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0px 357px;\n}\n\n.recent-searhces {\n  display: flex;\n  align-items: center;\n  margin: 0px 3px;\n  font-family: poppins !important;\n}\n\n.event-tabele-data {\n  width: 100%;\n  margin: 0 auto;\n  padding: 0;\n}\n\n/* .event-tabele-data::-webkit-scrollbar {\n  width: 1em;\n}\n \n.event-tabele-data::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n \n.event-tabele-data::-webkit-scrollbar-thumb {\n  background-color: darkgrey;\n  outline: 1px solid slategrey;\n} */\n\n/* 21 March 2023 */\n\n.css-1qqsdnr-MuiAutocomplete-root\n  .MuiOutlinedInput-root\n  .MuiAutocomplete-input {\n  /* padding: 7.5px 4px 7.5px 6px; */\n  border-radius: 64px 0px 0px 64px !important;\n}\n\n/* .dataTables_length.bs-select {\n  margin: -17px !important;\n} */\n\nbutton.search-enter-btn:hover {\n  background-color: #1e40af !important;\n}\n\na.mapboxgl-ctrl-logo {\n  display: none !important;\n}\n\n.mapboxgl-ctrl-attrib-inner {\n  display: none !important;\n}\n\nbutton.mapboxgl-popup-close-button {\n  padding: 2px 10px !important;\n}\n\n/* 21 March 2023 */\n\n/* .eventSearchbar input#tags-outlined {\n  height: 12px !important;\n} */\n\n.DAMSidebar li span {\n  display: none;\n  transition: 1s;\n}\n\n.DAMSidebar {\n  width: 80px;\n  transition: 1s;\n}\n\n.DAMSidebar .whitespace-nowrap {\n  display: none;\n  transition: 1s;\n}\n\n.sidebarmenu2 {\n  transition: 0.5s;\n}\n\n.logo_sec {\n  width: 35%;\n}\n\n.search-user-btn {\n  width: 30%;\n}\n\n.userid12 {\n  width: 35%;\n  display: flex;\n  justify-content: end;\n}\n\n.wordbreadkdiv {\n  word-wrap: break-word !important;\n}\n\n.eidt-profile {\n  position: absolute;\n  right: 51px;\n  top: -9px;\n  color: #007eff;\n  cursor: pointer;\n}\n\n.event-tags-div\n  .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-fullWidth.MuiInputBase-formControl.MuiInputBase-adornedEnd.MuiAutocomplete-inputRoot.css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root {\n  padding: 0 !important;\n  margin: 0 !important;\n  height: 53px;\n}\n\nimg.fight-finder-ligo {\n  width: 100%;\n  max-width: 200px;\n}\n\ndiv#search-event-boxx {\n  max-height: 400px;\n  overflow-y: scroll;\n}\n\ni.fa.fa-ellipsis-v {\n  cursor: pointer;\n}\n\n.scroll-top-btn {\n  position: fixed;\n  bottom: 80px;\n  right: 20px;\n  background: no-repeat !important;\n  border: none;\n  outline: none;\n  cursor: pointer;\n}\n\ni.fas.fa-arrow-up.aero-scroll {\n  font-size: 30px;\n  background: white;\n  padding: 5px 7px;\n  border-radius: 24px;\n  color: black;\n}\n\n.fighter-images-events1.neweventsadd {\n  height: 280px !important;\n  border-radius: 11px !important;\n}\n\n.eventsbak.bgblack-trasn {\n  border-radius: 8px !important;\n}\n\n.flex.flex-col.p-6.mx-auto.max-w-lg.text-gray-900.bg-white.rounded-lg.border.border-gray-100.shadow.w-full.my-ideas {\n  height: 280px !important;\n  border-radius: 11px;\n}\n\n.text-div-nexus {\n  margin-top: 25px !important;\n}\n\n.grid.grid-cols-2.gap-4.skillstag {\n  align-items: center !important;\n}\n\np.common-text-font-fam.text-black-800.font-medium.text-lg {\n  font-size: 13px !important;\n  color: #000000c2 !important;\n  text-align: center !important;\n}\n\nbutton.scroll-top-btn {\n  z-index: 999 !important;\n}\n\n.Home-events-img11.Publiceventde.resize-image {\n  height: 200px !important;\n}\n\ni.fa.fa-home {\n  font-size: 22px;\n}\n\ni.fa.fa-home.text-lg.mr-2.text-gray-600 {\n  font-size: 18px !important;\n}\n\nh4.common-text-font-fam.text-white.sm\\:text-3xl.md\\:text-5xl.font-bold {\n  font-size: 90px !important;\n}\n\n.w-full.p-3.mt-2.bg-white.rounded.shadow.flex.flex-shrink-0 {\n  display: flex;\n  align-items: center;\n}\n\nimg.rounded-full.max-w-none.w-12.h-12.mr-4 {\n  margin: 0px 0px !important;\n}\n\n.grid.grid-cols-1.gap-2.box-border.mx-4 {\n  margin-bottom: 50px;\n}\n\n.eveantag1212 .MuiOutlinedInput-root .MuiAutocomplete-input {\n  border-radius: 4px !important;\n  margin-right: 4px;\n}\n\n.eveantag1212 .MuiOutlinedInput-root {\n  height: 48px !important;\n  width: 100% !important;\n}\n\ntextarea.block.p-2\\.5.w-full.text-sm.text-gray-900.bg-gray-50.rounded-lg.border.border-gray-300.focus\\:ring-blue-500.focus\\:border-blue-500.bg-white.dark\\:border-gray-600.dark\\:placeholder-gray-400.dark\\:text-black.dark\\:focus\\:ring-blue-500.dark\\:focus\\:border-blue-500 {\n  height: 150px !important;\n}\n\nbutton.affilian-post-btn {\n  color: white;\n  padding: 7px 37px;\n  border-radius: 5px;\n  width: 167px;\n}\n\n.mapboxgl-popup-content {\n  position: relative;\n  background: #fff;\n  border-radius: 3px;\n  box-shadow: 0 1px 2px rgb(0 0 0/10%);\n  padding: 10px 10px 15px;\n  pointer-events: auto;\n  width: 100px !important;\n  text-align: center !important;\n  font-family: \"Poppins\";\n}\n\n.save_profilepic-btn.close-prfile11 {\n  position: relative;\n}\n\nbutton.save_profilepic-btn.close-prfile {\n  position: absolute;\n  top: -38px;\n  left: 133px;\n}\n\n.swal-modal.errorAlert {\n  height: 230px;\n}\n\n.successLogout {\n  width: 107px;\n  border: none;\n  background: #7867c1;\n  color: #fff;\n  padding: 10px 0;\n  border-radius: 8px;\n  margin: 13px;\n  font-size: 16px;\n  cursor: pointer;\n  font-family: \"poppins\";\n}\n\n.successfullyButton {\n  background: #1f92b5;\n  font-weight: 300;\n  font-family: \"Poppins\";\n  display: inline-block;\n  text-decoration: none;\n}\n\nimg.logo-dashboard {\n  width: 139px;\n}\n\na.successfullyButton {\n  padding: 10px;\n  color: #1e22aa;\n  text-transform: capitalize;\n\n  display: inline-block;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border-radius: 8px;\n  margin: 20px auto 0;\n\n  color: white;\n}\n\nimg.dashboardImg {\n  width: 300px;\n}\n\n.dashboardDiv {\n  display: flex;\n  justify-content: center;\n  margin: 20px;\n}\n\n.update {\n  width: 13%;\n}\n\n.dash {\n  margin: 10px;\n}\n\n.filesDiv {\n  display: flex;\n  justify-content: space-between;\n  height: 34px;\n}\n\nbutton.del {\n  height: 23px;\n  margin: 14px;\n  color: #42c1f4;\n  border-radius: 13px;\n  border: 0px;\n}\n\n#file-input-area {\n  display: none;\n}\n\n.button {\n  background-color: #007bff;\n  border: none;\n  color: white;\n  padding: 10px 40px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 16px;\n  cursor: pointer;\n  border-radius: 10px;\n  font-family: \"poppins\";\n}\n\ntext.recharts-text.recharts-cartesian-axis-tick-value {\n  font-size: 13px;\n}\n\n.chatmapdiv {\n  padding: 20px 20px 10px 0px;\n}\n\np.fileName {\n  display: flex;\n  justify-content: center;\n  background: white;\n  border-radius: 4px;\n  padding: 6px;\n}\n\n#membershipHeading {\n  font-family: \"poppins\";\n  padding: 10px 0;\n  font-size: 20px;\n  font-weight: 600;\n  font-family: \"poppins\";\n}\nh3.price {\n  padding-bottom: 13px;\n  font-weight: 500;\n  color: #7867c1;\n  font-size: 18px;\n}\np.errorMsg {\n  margin: 0 !important;\n  font-size: 13px;\n  color: #e31e00;\n  font-family: poppins;\n}\n\n.divGraph {\n  background-color: white;\n  border-radius: 10px;\n}\n\n.chartDiv {\n  background: white;\n  padding: 30px 32px 24px 0px;\n  border-radius: 10px;\n  position: relative;\n}\n\nbutton.del.btnSS {\n  float: right;\n  background: #42c1f4;\n  color: white;\n}\n\n/* select.method-select {\n  border: none;\n  padding: 4px;\n  margin: 11px;\n  border-radius: 12px;\n  color: #42c1f4;\n  outline: none !important;\n} */\n\np.count {\n  color: #42c1f4;\n  display: flex;\n  align-items: center;\n}\n\nimg.error-page {\n  width: 60%;\n  display: flex;\n  justify-content: center;\n  margin: auto;\n  margin-top: 32px;\n}\n\na.hover-primary.subs {\n  margin-right: 10px;\n}\n\np#notfound {\n  font-size: 34px;\n  font-family: \"Poppins\";\n  text-align: center;\n  margin-top: 115px;\n}\n\nselect.custom-select.custom-select-sm.form-control.form-control-sm {\n  width: 168px;\n  margin-bottom: 22px !important;\n}\n\n.userlistdiv {\n  width: 60%;\n  margin: auto;\n  background: white;\n  padding: 26px;\n  border-radius: 10px;\n}\n\ntable.table.table-bordered.table-sm.table-striped.dataTable {\n  margin: auto;\n  width: 100%;\n}\n\n/* .thanktexthome.userlist {\n  width: 60%;\n  margin: auto;\n} */\n\n.thanktexthome.userlist {\n  margin: auto;\n  padding: 0px 130px;\n}\n\n/* ul.pagination {\n  width: 60%;\n  margin: auto;\n  margin-top: 20px;\n} */\n\nli.page-item {\n  display: inline-block;\n  margin-left: 17px;\n  cursor: pointer;\n}\n\nbutton.del.add {\n  width: 30px;\n}\n\nrect.recharts-brush-slide {\n  fill-opacity: 1;\n}\n\n.dataresult {\n  display: flex;\n}\n\n.datashow {\n  width: 30%;\n  position: relative;\n}\n\n.result {\n  width: 70%;\n}\n\n/* data result */\n.dataresult {\n  margin: 12px;\n}\n\n.datashow {\n  width: 21%;\n  background: white;\n  padding: 35px;\n  border-radius: 5px 0px 0px 5px;\n  box-shadow: 2px 1px 11px 3px;\n}\n/* h2.dataheading {\n  display: flex;\n  justify-content: center;\n  color: #16414a;\n  font-size: 39px;\n} */\n\nh2.dataheading {\n  display: flex;\n  justify-content: center;\n  color: gray;\n  font-size: 40px;\n  font-weight: 700;\n}\n\nbutton.btnchange {\n  border: none;\n  color: gray;\n  font-size: 25px;\n  font-weight: 400;\n  font-family: \"Poppins\";\n}\n\n/* p.dataText {\n  font-size: 13px;\n  margin: 2px;\n  color: #8d9191;\n} */\np.dataText {\n  font-size: 14px;\n  margin: 2px;\n  color: #8d9191;\n  font-family: \"Poppins\";\n}\n.Data-plotting {\n  display: flex;\n  background: white;\n  margin-left: 10px;\n  padding: 12px;\n  border-radius: 0px 5px 5px 0px;\n  box-shadow: 2px 1px 11px 3px;\n}\n.graphplot {\n  width: 90%;\n}\n.graphdetail {\n  width: 31%;\n  /* display: flex;\n  justify-content: center;\n  align-items: self-end; */\n}\n.graphdetail > div {\n  height: 40px;\n  padding-left: 13px;\n  margin-top: 270px;\n  display: flex;\n  justify-content: center;\n}\n.confidenceContainer {\n  display: flex;\n}\n.clustergraph {\n  height: 380px;\n}\n.confidence {\n  width: 50%;\n  background: white;\n  margin-left: 10px;\n  margin-top: 10px;\n  box-shadow: 2px 1px 11px 3px;\n  height: 460px;\n}\n.clusterPlot {\n  background: white;\n  margin-top: 10px;\n  margin-left: 10px;\n  width: 50%;\n  border-radius: 0px 5px 5px 0px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 2px 1px 11px 3px;\n}\n\nh2.corelate {\n  margin-bottom: 95px;\n}\n.addpagelink {\n  position: absolute;\n  bottom: 13px;\n  left: 20px;\n}\n.addpagelink a {\n  list-style: none;\n  color: grey;\n  text-decoration: none;\n}\nlabel.fileupload {\n  border-radius: 5px;\n\n  font-size: 14px;\n  border: 1.2px solid #7e6dc9;\n  padding: 1px 6px;\n  color: white;\n  background: #7867c1;\n  margin: 2px;\n}\n.dropzone-content {\n  display: flex;\n  flex-direction: row;\n}\n\n.dataText {\n  font-size: 12px;\n  margin-left: 8px;\n  color: gray;\n}\nselect.method-select {\n  border: 1px solid gray;\n  padding: 0 13px;\n  width: 150px;\n  border-radius: 3px;\n  color: gray;\n  background: white;\n  outline: none !important;\n}\np.dataToggle {\n  color: gray;\n  font-size: 13px;\n}\n/* toggle button */\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 22px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 17px;\n  width: 17px;\n  left: 4px;\n  bottom: 2px;\n  background-color: white;\n  transition: 0.4s;\n}\n\ninput:checked + .slider {\n  background-color: #2196f3;\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px #2196f3;\n}\n\ninput:checked + .slider:before {\n  -webkit-transform: translateX(26px);\n  -ms-transform: translateX(26px);\n  transform: translateX(26px);\n}\n\n/* Rounded sliders */\n.slider.round {\n  border-radius: 34px;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}\n.clusterPlot {\n  padding: 6px;\n  /* padding-top: 20px; */\n}\n.toggledec {\n  display: flex;\n  align-items: center;\n}\ninput.confiInput {\n  width: 50px;\n  padding: 5px;\n  border: none;\n  border-radius: 3px;\n  text-align: center;\n  margin: 0px;\n  color: #42c1f4;\n}\nbutton.del {\n  height: 23px;\n  margin: 0px;\n  color: white;\n  border-radius: 5px;\n  border: 1px solid gray;\n  background: #7867c1;\n}\n\nbutton.submitbtn {\n  background: #7867c1;\n  border-radius: 5px;\n  border: 2px solid #9788d8;\n  color: white;\n  padding: 5px 16px;\n  font-size: 23px;\n  font-family: \"poppins\";\n}\n\n.leftsideimport {\n  display: flex;\n}\n\n.addfiledata {\n  padding-left: 100px;\n}\n\n.headerstyle a {\n  list-style: none;\n  color: grey;\n  text-decoration: none;\n  font-size: 25px;\n}\n.headerstyle {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0px 8px 17px -10px;\n}\n.containeraddfile {\n  width: 82%;\n  box-shadow: 0px 1px 11px 1px;\n  margin: auto;\n  /* padding: 0px; */\n}\n\n.leftsideimport {\n  background: white;\n}\n.containeraddfile {\n  background: white;\n}\n\nh2.dataheading {\n  margin: 0px;\n  /* margin-bottom: 30px; */\n}\n\n.dashboardpage {\n  background: #42c1f440;\n}\n\n.homepage {\n  background: #42c1f4;\n  padding: 40px 0;\n  height: 100vh;\n}\n\n.action-btnss {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\ni.fa.fa-solid.fa-check {\n  color: #10c910;\n  font-size: 22px;\n}\n\ni.fa.fa-solid.fa-times {\n  color: red;\n  font-size: 22px;\n}\n\n.dataTables_length.bs-select {\n  width: 102px !important;\n}\n\n.setting-action-btn {\n  display: flex;\n  justify-content: center;\n}\n.table-responsive tr {\n  padding: 10px 0 !important;\n  width: 100%;\n  font-family: poppins !important;\n  height: 53px;\n}\n/* .setting-action-btn {\n  height: 53px;\n} */\n\ni.fa.fa-gear {\n  font-size: 21px;\n  /* pointer-events: initial; */\n  cursor: pointer;\n}\n\nul.pagination {\n  /* width: 60%; */\n  margin: auto;\n  margin-top: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.active > .page-link,\n.page-link.active {\n  background-color: #948ed1;\n  border-color: var(--bs-pagination-active-border-color);\n  padding: 5px 18px;\n  color: white;\n  font-size: 18px;\n  border-radius: 11px;\n}\n\n.main-upload-data {\n  display: flex;\n  gap: 13px;\n  align-items: center;\n  height: 100px;\n}\n\nh2.number-lenght.text-red-800 {\n  background: #7867c1;\n  /* width: 40px; */\n  padding: 9px 22px;\n  border-radius: 27px;\n  color: white;\n  font-family: \"Poppins\";\n}\n\n.oneinputtitle {\n  margin-top: 39px;\n}\n\n.straoght-border {\n  border: 3px solid;\n  width: 59px;\n  transform: (14deg 7deg);\n  transform: rotate(90deg);\n  margin-left: -4px;\n  color: #7867c1b5;\n}\n.dropzone-part {\n  padding-top: 16px;\n  padding-bottom: 8;\n}\n\nselect.method-select {\n  border: 1px solid gray;\n  margin-top: 12px;\n\n  width: 100%;\n  border-radius: 3px;\n  color: gray;\n  background: white;\n  font-family: \"Poppins\";\n  outline: none !important;\n}\n\n/**\n * The switch widget!\n * Usage:\n *   <input type=\"checkbox\" switch[=\"type\"] id=\"toggleSwitch\" />\n *   <label for=\"toggleSwitch\" data-on-label=\"On\" data-off-label=\"Off\"></label>\n */\n\n/*\n  * Copyright (c) 2013 Thibaut Courouble\n  * http://www.cssflow.com\n  *\n  * Licensed under the MIT License:\n  * https://www.opensource.org/licenses/mit-license.php\n  */\n\n.switch {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  width: 56px;\n  height: 20px;\n\n  background-color: white;\n  border-radius: 18px;\n  box-shadow: inset 0 -1px white, inset 0 1px 1px rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n  background-image: -webkit-linear-gradient(top, #eeeeee, white 25px);\n  background-image: -moz-linear-gradient(top, #eeeeee, white 25px);\n  background-image: -o-linear-gradient(top, #eeeeee, white 25px);\n  background-image: linear-gradient(to bottom, #eeeeee, white 25px);\n}\n\n.switch-input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n}\n\n.switch-label {\n  position: relative;\n  border: 2px solid gray;\n  display: block;\n  height: inherit;\n  font-size: 10px;\n  text-transform: uppercase;\n  background: #808080e1;\n  border-radius: inherit;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.12),\n    inset 0 0 2px rgba(0, 0, 0, 0.15);\n  -webkit-transition: 0.15s ease-out;\n  -moz-transition: 0.15s ease-out;\n  -o-transition: 0.15s ease-out;\n  transition: 0.15s ease-out;\n  -webkit-transition-property: opacity background;\n  -moz-transition-property: opacity background;\n  -o-transition-property: opacity background;\n  transition-property: opacity background;\n}\n.switch-label:before,\n.switch-label:after {\n  position: absolute;\n  top: 50%;\n  margin-top: -0.5em;\n  line-height: 1;\n  -webkit-transition: inherit;\n  -moz-transition: inherit;\n  -o-transition: inherit;\n  transition: inherit;\n}\n.switch-label:before {\n  content: attr(data-off);\n  right: 11px;\n  color: #aaa;\n  text-shadow: 0 1px rgba(255, 255, 255, 0.5);\n}\n.switch-label:after {\n  content: attr(data-on);\n  left: 11px;\n  color: white;\n  text-shadow: 0 1px rgba(0, 0, 0, 0.2);\n  opacity: 0;\n}\n.switch-input:checked ~ .switch-label {\n  background: #7867c1;\n  /* box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15), inset 0 0 3px rgba(0, 0, 0, 0.2); */\n}\n.switch-input:checked ~ .switch-label:before {\n  opacity: 0;\n}\n.switch-input:checked ~ .switch-label:after {\n  opacity: 1;\n}\n\n.switch-handle {\n  position: absolute;\n  border: 2px solid gray;\n  top: 4px;\n  left: 6px;\n  width: 0;\n  height: 13px;\n  background: white;\n  border-radius: 10px;\n  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);\n  background-image: -webkit-linear-gradient(top, white 40%, #f0f0f0);\n  background-image: -moz-linear-gradient(top, white 40%, #f0f0f0);\n  background-image: -o-linear-gradient(top, white 40%, #f0f0f0);\n  background-image: linear-gradient(to bottom, white 40%, #f0f0f0);\n  -webkit-transition: left 0.15s ease-out;\n  -moz-transition: left 0.15s ease-out;\n  -o-transition: left 0.15s ease-out;\n  transition: left 0.15s ease-out;\n}\n.switch-handle:before {\n  border: 2px solid gray;\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin: -6px 0 0 -2px;\n\n  width: 12px;\n  height: 12px;\n  background: #f9f9f9;\n  border-radius: 6px;\n  box-shadow: inset 0 1px rgba(0, 0, 0, 0.02);\n  background-image: -webkit-linear-gradient(top, #eeeeee, white);\n  background-image: -moz-linear-gradient(top, #eeeeee, white);\n  background-image: -o-linear-gradient(top, #eeeeee, white);\n  background-image: linear-gradient(to bottom, #eeeeee, white);\n}\n.switch-input:checked ~ .switch-handle {\n  left: 40px;\n  box-shadow: -1px 1px 5px rgba(0, 0, 0, 0.2);\n}\n\n.switch-green > .switch-input:checked ~ .switch-label {\n  background: #4fb845;\n}\n\nlabel.select-toggle-btn {\n  margin-right: 50px;\n  color: gray;\n  font-family: \"Poppins\";\n}\n\n.plus-minus-input {\n  display: flex;\n  /* align-items: center; */\n}\n\nspan.count-persanttage {\n  border-top: 1px solid gray;\n  border-bottom: 1px solid gray;\n  padding: 2px 14px;\n  background: white;\n}\n\nbutton.decrement-button {\n  color: white;\n  font-size: 26px;\n  border-radius: 3px;\n  border: none;\n  width: 30px;\n  height: 30px;\n  background: #7867c1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbutton.increment-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-size: 26px;\n  border-radius: 3px;\n  border: none;\n  width: 30px !important;\n  height: 30px;\n  background: #7867c1;\n}\n\nbutton.submitbtn {\n  background: #7867c1;\n  border-radius: 15px;\n  border: 2px solid #aa9ede;\n  color: white;\n  padding: 5px 12px;\n  font-size: 33px;\n  font-family: \"poppins\";\n  font-weight: 700;\n  font-family: \"Poppins\";\n}\n\n.main-graph-image {\n  background: white;\n  height: 100vh;\n}\n\n.heading h1 {\n  text-align: center;\n  color: rgb(128 128 128 / 75%);\n  font-family: \"Poppins\";\n  margin-top: 0;\n  font-size: 38px;\n  font-weight: 500;\n  padding: 24px 0 0;\n  font-weight: bold;\n}\n\n.main-graph-image {\n  height: 100vh !important;\n  background-repeat: no-repeat !important;\n  background-size: cover !important;\n  padding: 0px 66px;\n}\nbutton {\n  border: none;\n  color: gray;\n  font-size: 16px;\n}\n/* button.btnchange {\n  border: none;\n  color: gray;\n  font-size: 16px;\n} */\np.dataTitle {\n  color: #7867c1;\n  font-size: 30px;\n  margin: 10px 0px 10px 0px;\n  font-family: \"Poppins\";\n}\n.layout-dashboard-main {\n  background: white;\n  height: 100vh;\n}\n.icondown {\n  width: 31px;\n  height: 31px;\n  margin-left: 5px;\n  cursor: \"pointer\";\n  float: right;\n  /* display: flex; */\n  /* align-items: center; */\n  /* justify-content: center; */\n  /* text-align: center; */\n  margin: 0 20px;\n  position: relative;\n  z-index: 999;\n}\n.clusterGraph {\n  width: 100%;\n}\n.main_navbar_header {\n  padding: 8px 28px;\n  box-shadow: 0px -4px 11px 4px;\n}\n/* .loginsigin {\n  position: absolute;\n  width: 200px;\n  background: #fff;\n  padding: 10px;\n  right: 0;\n  top: 55px;\n  border-top: 4px solid #FC2D60;\n  z-index: 9999;\n  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);\n} */\n\n.loginsigin a {\n  width: 100%;\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 19px;\n  color: #a0a0a0;\n}\n.loginsigin li {\n  width: 100%;\n  margin: 3px;\n}\n.loginsigin li:hover {\n  width: 100%;\n  background: unset;\n  box-shadow: unset;\n  margin: 0;\n}\nli.user-header-div.Activediv {\n  list-style: none;\n}\n\nimg.mr-2.profileIcons {\n  margin-right: 6px;\n}\nimg.mr-2.logout {\n  margin-right: 8px;\n}\nli.user-header-div {\n  list-style: none;\n}\n.profileIcons {\n  width: 20px;\n  margin-right: 5px;\n}\nimg.logout {\n  margin-right: 9px;\n}\n.loginsigin {\n  position: absolute;\n  width: 200px;\n  background: #fff;\n  padding: 13px;\n  right: 28px;\n  top: 46px;\n  border-top: 4px solid #7867c1;\n  z-index: 9999;\n  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);\n  list-style: none;\n  text-align: justify;\n  padding-left: 20px;\n}\na.hover-primary {\n  color: #7867c1;\n  font-size: 14px;\n  text-decoration: none;\n  font-weight: 600;\n  /* margin-top: 7px; */\n  display: inline-block;\n  text-transform: capitalize;\n  font-family: \"Poppins\";\n}\nimg.imgPro {\n  margin-top: 11px;\n  width: 26px;\n}\n.main-geoThara-div {\n  margin: 70px 0;\n}\n.elementor-widget-container {\n  color: #4ac0ef;\n  font-family: \"Rubik\", Sans-serif;\n  font-size: 45px;\n  font-weight: 600;\n  line-height: 50px;\n}\n.changing-content {\n  color: #7867c1;\n  font-family: \"Rubik\", Sans-serif;\n  font-size: 45px;\n  font-weight: 600;\n  line-height: 50px;\n}\n.test-1 {\n  font-family: \"Poppins\", Sans-serif;\n  font-size: 18px;\n  font-weight: 400;\n}\n.slider-image-div img {\n  width: 100%;\n  /* height: auto; */\n}\n.trenddetection {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.react-slideshow-container .default-nav {\n  background: none !important;\n}\n.react-slideshow-container svg {\n  fill: #fff !important;\n}\n.topdiv {\n  height: 520px;\n  overflow: hidden;\n  position: relative;\n}\n\n.newlogomenu {\n  display: flex;\n}\n.newlogo {\n  width: 150px;\n}\n.container {\n  margin: 0 auto;\n}\n.logomenu {\n  width: 100%;\n  display: flex;\n  padding: 0 40px;\n  align-items: end;\n  justify-content: center;\n}\n.newlogomenu {\n  display: flex;\n  max-width: 1130px;\n  margin: 0 auto;\n}\n.logomenu li {\n  list-style: none;\n  padding: 0 18px;\n}\n.logonavbar {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  padding: 20px 10px;\n  z-index: 999;\n  border-top: 1px solid #fff;\n  margin-top: 44px;\n}\n.logomenu a {\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: #fff;\n}\np.emailtext {\n  /* position: absolute; */\n  /* right: 0; */\n  /* margin: 0 auto; */\n  color: #fff;\n  /* padding: 10px 0 30px; */\n  /* display: inline-block; */\n  /* width: 100%; */\n}\n.container-text {\n  text-align: right;\n  width: 90%;\n  /* margin: 0 auto; */\n  float: left;\n  padding: 9px 0;\n  position: absolute;\n  z-index: 999;\n}\n.tobtext {\n  position: absolute;\n  top: 50%;\n  width: 100%;\n}\n.tobtext h1 {\n  color: #ffffff;\n  font-family: \"DM Sans\", Sans-serif;\n  font-size: 47px;\n  font-weight: 700;\n  line-height: 100px;\n  padding: 0 66px;\n}\n.Services {\n  object-fit: cover;\n  background-repeat: no-repeat;\n  padding: 50px 0 80px;\n}\n.allServices {\n  display: flex;\n}\n.Services1 {\n  width: 30.5%;\n  background: #fff;\n  text-align: center;\n  padding: 80px 30px;\n  border-radius: 15px;\n}\n.Services-icon {\n  width: 4%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\nimg.Services-icon-img {\n  width: 130px;\n  margin: 0 auto;\n  padding: 20px;\n}\nh2.nuber {\n  color: #6ec1e4;\n  font-size: 35px;\n  font-weight: 700;\n}\nh3.datatext {\n  font-family: \"Rubik\", Sans-serif;\n  font-size: 25px;\n  font-weight: 700;\n  font-style: italic;\n  letter-spacing: 0px;\n  color: #7867c1;\n  margin: 7px 0 10px;\n}\np.Services-test {\n  font-family: \"Rubik\", Sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  font-style: italic;\n  color: #7867c1;\n}\nh1.Servicestitle {\n  color: #ffffff;\n  font-family: \"Rubik\", Sans-serif;\n  font-size: 45px;\n  font-weight: 600;\n  margin-bottom: 50px;\n}\n.Services-top {\n  padding: 0 65px;\n}\n.result {\n  width: 78%;\n}\n.datashow {\n  width: 30%;\n  position: relative;\n  background: white;\n  padding: 35px;\n  border-radius: 5px 0px 0px 5px;\n  box-shadow: 2px 1px 11px 3px;\n}\n.Contactsecdiv {\n  display: flex;\n  width: 100%;\n  margin: 85px 0;\n}\n.Contactsecdiv-text {\n  width: 50%;\n  display: flex;\n  align-items: center;\n}\n.Contactsecdiv-img {\n  width: 50%;\n}\n.Contactsecdiv-img img {\n  width: 100%;\n}\nh1.Contacttitle {\n  color: #4ac0ef;\n  font-family: \"Rubik\", Sans-serif;\n  font-size: 45px;\n  font-weight: 600;\n  line-height: 50px;\n}\nh2.contactlink {\n  font-size: 24px;\n  color: #7867c1;\n  margin: 6px 0 0;\n}\n.Contactsecdiv-img img {\n  border-radius: 10px;\n}\n.bottomsec {\n  background: #01102d;\n  padding: 60px 0;\n}\n.footer-text {\n  width: 33.33%;\n}\n.footer-logo {\n  width: 33%;\n  display: flex;\n  align-items: center;\n}\n.footer {\n  display: flex;\n}\n.footer-logo img {\n  width: 220px;\n}\n.footer-text p {\n  text-align: left;\n  color: #ffffff;\n  font-family: \"Poppins\", Sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  padding-bottom: 20px;\n}\n.scrolled .logonavbar {\n  position: fixed;\n  background: #000;\n  top: -50px;\n}\nh2.createplay-title {\n  font-size: 26px;\n  color: #7867c1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation24 {\n  max-width: 350px !important;\n  width: 100%;\n  padding: 0px 10px;\n}\nbutton.MuiButtonBase-root.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.canceButtonnewPop.css-1e6y48t-MuiButtonBase-root-MuiButton-root {\n  color: #42c1f4;\n  padding-bottom: 8px;\n  font-size: 16px;\n}\n.MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {\n  width: 73px;\n  color: #7867c1;\n  border: 1px solid #7867c1;\n}\nh2.add-title {\n  color: #7867c1;\n  font-size: 27px;\n  display: flex;\n  justify-content: center;\n  padding-bottom: 27px;\n}\n.allpage {\n  background: white;\n  border-radius: 5px;\n}\n.allpage {\n  background: white;\n  border-radius: 5px;\n  padding: 15px;\n}\n.dataTables_length.bs-select {\n  color: #7867c1;\n}\n\ni.fas.fa-2x.fa-sharp.fa-regular.fa-circle-down {\n  color: #7867c1;\n}\n\n.clustergraph svg.recharts-surface {\n  margin-top: 41px;\n  height: 380px !important;\n}\n\n/* .clusterGraph.third svg.recharts-surface {\n  margin-top: -78px !important;\n} */\n\n/* .graphplot.firstgraph {\n  width: 300% !important;\n} */\n\nbutton.i-contnet-btn {\n  background: #7867c1;\n  color: white;\n  padding: 1px 16px;\n  border-radius: 12px;\n}\n.Data-plotting .graphplot {\n  width: 300%;\n}\n.icondown11 {\n  display: flex;\n  height: 98%;\n  align-items: end;\n}\n.icondown474 {\n  margin: -5px 11px 0;\n}\n/* neww csss */\n\n.select-steps-contnet {\n  font-size: 29px;\n  font-weight: 300;\n\n  color: rgba(128, 128, 128, 0.86);\n  font-family: \"Poppins\", sans-serif;\n}\n\n.border-steps {\n  color: #9082cc;\n  border: 3px solid;\n}\n\n.rounded-border-contnet {\n  background: #7867c1 !important;\n  width: 50px;\n  height: 50px;\n  border: 1px solid #7867c1;\n  color: white;\n  font-size: 22px;\n  font-family: \"Poppins\";\n}\n\n.upload-data-inputdata {\n  margin-top: 30px !important;\n}\n\n.spaceonright {\n  display: flex;\n  justify-content: center;\n  align-items: end;\n  position: absolute !important;\n  left: 43%;\n  top: 95%;\n}\nbutton.togglebtn {\n  display: none;\n}\n.logo-m {\n  display: none;\n}\n.mobl {\n  display: none;\n}\n\n.foldermainDisplayDivsec {\n  width: 100% !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\na.Auth-button.back-btn {\n  margin: 0 auto;\n}\n\n.show-hide-password {\n  display: none !important;\n}\n\n.newgraph-div {\n  display: flex;\n  background: #80808036;\n  padding: 44px 0px 0px 0px;\n  box-shadow: 0px 3px 8px -3px;\n}\n\n/* button.all_graph_buttonnewdiv {\n  width: 140px;\n  background: #80808094;\n  color: black;\n  font-family: poppins;\n  font-size: 21px;\n  text-align: center;\n  padding: 5px 8px;\n  border-radius: 10px 10px 0px 0px;\n  font-weight: 400;\n} */\n\n/* button.all_graph_buttonnewdiv {\n  width: 140px;\n  background: #80808094;\n  color: black;\n  font-family: poppins;\n  font-size: 21px;\n  text-align: center;\n  padding: 5px 8px;\n  border-radius: 10px 10px 0px 0px;\n  font-weight: 400;\n} */\n\n.otherdiv-main-divv {\n  display: flex;\n  gap: 20px;\n  padding-top: 50px;\n}\n\n/* .responsive-graph-second {\n  width: 35%;\n} */\n\n.second-valuelinechart {\n  width: 430px;\n}\n\nbutton.all_graph_buttonnewdiv.active {\n  background: #42c1f4;\n  color: white;\n}\n\n.responsive-graphd-first {\n  width: 65%;\n  margin-top: 50px;\n}\n\nh1.varable-div {\n  font-size: 25px;\n  font-family: poppins;\n  color: #5a5858;\n}\n\ninput:checked {\n  background-color: #7c65be;\n}\n\ninput:checked ~ span:last-child {\n  --tw-translate-x: 1.75rem; /* translate-x-7 */\n}\n\nspan.diagnostic.mr-3 {\n  font-size: 24px;\n  font-family: poppins;\n  color: #5e5a5a;\n}\n\nspan.diagnostic-trend.mr-3 {\n  padding: 3px;\n  background-color: #7c65be;\n  font-size: 20px;\n  font-family: poppins;\n  color: #e5e7eb;\n  border-radius: 7px;\n}\n\ninput.toggle-new-swith {\n  width: 58px;\n  height: 30px;\n  border: none;\n  outline: none;\n}\n\n.progress-bar {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  background-color: #7c65be;\n  /* transition: height 0.3s ease-in-out; */\n}\n\n.progress-wrap {\n  position: relative;\n  height: 166px;\n  width: 30px;\n  background-color: #7c65be;\n  margin-top: 19px;\n  border: 2px solid #7c65be;\n  border-radius: 5px;\n}\n\n.progress-barprogress-text {\n  margin-left: 41px;\n}\n\n.progressbar-div {\n  display: flex;\n  gap: 14px;\n}\n\n.liner-trned {\n  margin-top: 14px;\n}\n\n.lner-progress-trend {\n  padding: 5px 0px;\n  font-size: 17px;\n  font-family: poppins;\n  color: #444141;\n  cursor: pointer;\n}\n\n.pie-chart-container {\n  width: 75px;\n  height: 75px;\n  position: relative;\n  border-radius: 50%;\n  overflow: hidden;\n  cursor: pointer;\n  border: 3px solid white;\n}\n\n.progress-bar11 {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  background: #7c65be;\n}\n.progress11 {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  border: 1px;\n  height: 100%;\n  background-color: #e5dbdbad;\n  transition: clip-path 0.3s ease-in-out;\n}\n/* Optional: Styling for the chart border */\n.pie-chart-container::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  border: 2px solid #ccc;\n  box-sizing: border-box;\n}\n\n.cirlce-progress {\n  background: #80808085;\n  padding: 6px 7px 12px 6px;\n  border-radius: 12px;\n}\n\nspan.percantage-cion {\n  font-size: 30px;\n  margin-left: 7px;\n}\n\n.lner-progress-trend.stpepercan {\n  margin: -26px -3px -14px 0px;\n}\n\n.prog-number {\n  font-size: 45px;\n  margin: -8px 0px 0px 0px;\n\n  font-family: poppins;\n  color: #5e5a5a;\n}\n.pieChart .recharts-wrapper svg {\n  width: 60px;\n  height: 60px;\n}\n/* *************************** */\n\n.slider-container {\n  --label: 2.75rem;\n  --width: 100% !important;\n  --thumb: clamp(3rem, calc(2.28rem + 3.18vw), 3.88rem);\n  inline-size: var(--width);\n  aspect-ratio: 10.665 / 1;\n  display: grid;\n  padding-inline: var(--space);\n  border-radius: 0;\n  /* margin-left: 14px; */\n  position: relative;\n}\n.input-slider {\n  place-self: center;\n  border-radius: 0;\n  width: calc(var(--width) - 1rem);\n  appearance: none;\n  outline: none;\n  border: none;\n  border-top: 2px solid #5e5a5a;\n  height: 0;\n}\n\n.input-slider:focus {\n  border: 1px solid !important;\n}\n\n.input-slider::-webkit-slider-thumb {\n  appearance: none;\n  width: var(--thumb);\n  height: var(--thumb);\n  cursor: pointer;\n  position: relative;\n  z-index: 2;\n  margin-top: -18px !important;\n  width: 0;\n  height: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-top: 15px solid #7c65be;\n}\n\n.input-slider::-moz-range-thumb {\n  appearance: none;\n  width: var(--thumb);\n  height: var(--thumb);\n  background-color: #000;\n  border-radius: 50%;\n  cursor: pointer;\n  position: relative;\n  z-index: 2;\n}\n\n.input-slider::-webkit-slider-thumb:before {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  border-left: 6px solid #fff;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1;\n}\n\n.input-slider::-moz-range-thumb:before {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  border-left: 6px solid #fff;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1;\n}\n\n.numeric-sliderrange {\n  background: #bdbdbd;\n  padding-top: 22px;\n  padding-bottom: 22px;\n  padding-right: 11px;\n  padding-left: 11px;\n  border-radius: 12px;\n}\n\n.center-border-style {\n  display: flex;\n  justify-content: center;\n}\n\nh2.value-cahrtdiv {\n  font-size: 46px;\n  padding: 8px 25px;\n  font-family: poppins;\n  /* width: 98px; */\n  text-align: center;\n  /* margin-left: -13px; */\n  color: #5e5a5a;\n}\n\n.numeric-sliderrange.second-div {\n  padding: 0;\n}\n\n.first-valuelinechart {\n  width: 23%;\n}\n\n/* .second-valuelinechart {\n  width: 60%;\n} */\n\n.numariclinechart {\n  position: relative;\n}\n\n.numer-border {\n  color: black;\n  background: black;\n  width: 38px;\n  height: 2px;\n  transform: rotate(90deg);\n  position: absolute;\n  bottom: 31px;\n}\n\n.second.numer-border {\n  width: 50px;\n  position: absolute;\n  right: 50%;\n  left: 42%;\n  background: #5e5a5a;\n  top: 50%;\n}\n\n.third.numer-border {\n  position: absolute;\n  right: 0px;\n  background: #5e5a5a;\n  top: 50%;\n}\n\n.first.numer-border {\n  position: absolute;\n  left: 0px;\n  background: #5e5a5a;\n  top: 50%;\n}\n\n.inner-div {\n  position: absolute;\n  top: 0;\n  width: 26px;\n  height: 20px;\n  border-radius: 3px;\n  margin-left: 0.1px;\n  background: #fff;\n  transition: top 3s ease;\n  transform-origin: top;\n  pointer-events: none;\n}\n.responsive-graphd-first .recharts-surface {\n  width: 100% !important;\n}\n\n.mapboxgl-ctrl-geocoder.mapboxgl-ctrl {\n  display: flex;\n  align-items: center;\n}\n\n/* Add map box */\n\n.mapboxgl-ctrl-geocoder {\n  position: absolute;\n  top: 200px;\n  right: 10px;\n  z-index: 1;\n}\n\n/* input.mapboxgl-ctrl-geocoder--input {\n  padding: 9px 0px;\n  display: none;\n} */\n\n/* svg.mapboxgl-ctrl-geocoder--icon.mapboxgl-ctrl-geocoder--icon-search {\n  position: absolute;\n  left: 7px;\n  width: 19px;\n  display: none;\n}\n\n.mapboxgl-ctrl-geocoder--pin-right {\n  display: none;\n}\n\ncanvas.mapboxgl-canvas {\n  width: 1500px !important;\n  margin-top: 35px;\n} */\n\n.mapboxgl-canvas-container.mapboxgl-interactive.mapboxgl-touch-drag-pan.mapboxgl-touch-zoom-rotate {\n  display: flex;\n  justify-content: center;\n  background-color: white;\n}\n\n.mapboxgl-marker.mapboxgl-marker-anchor-center {\n  transform: none !important;\n}\n\n.select-country-maindiv {\n  display: flex;\n  justify-content: center;\n  position: absolute;\n  left: 50px;\n  z-index: 9999;\n}\n\nselect.select-country-box {\n  padding: 11px 14px;\n  margin-top: 25px;\n  border-radius: 9px;\n  border: 1px solid gray;\n  margin-bottom: 30px;\n}\n\n.section-80 {\n  width: 50%;\n  height: 100%;\n  background-color: yellow;\n\n  /* Add any other styling you need */\n}\n\n.section-20 {\n  width: 20%;\n  height: 100%;\n  background-color: green;\n\n  /* Add any other styling you need */\n}\n\n.sub-section {\n  width: 100%;\n  height: 50%;\n  background-color: red;\n  /* Add any other styling you need */\n}\n\n/* new cs 21 aug  */\n\n.vediopage {\n  width: 70%;\n}\n\n.main-vediopage {\n  display: flex;\n  gap: 6px;\n  width: 100%;\n  align-items: center;\n  /* height: 100vh !important; */\n}\n\ni.fas.fa-robot.robotai {\n  font-size: 30px;\n  border: 1px solid white;\n  padding: 11px 9px;\n  border-radius: 30px;\n  background: #7867c1;\n  color: white;\n}\n\ninput.helpaiinput {\n  width: 100%;\n  padding: 7px 8px;\n  border-radius: 12px;\n  background: #cac8c8;\n}\n\ni.material-icons.sednaiicon {\n  font-size: 31px;\n  background: #cac8c8;\n  padding: 4px 9px;\n  border-radius: 8px;\n  color: #7240d6;\n}\n/* img.social-media-iconss {\n  width: 90px;\n} */\n\nh1.expoort-heading {\n  text-align: center;\n  margin-top: 25px;\n  margin-bottom: 12px;\n  font-family: \"Poppins\";\n  color: #5c5a5a;\n  font-size: 35px;\n}\n\nh1.count-downtime {\n  background: #8080802b;\n  text-align: center;\n  padding: 0px 7px;\n  border-radius: 56px;\n  display: flex;\n  justify-content: center;\n  width: 190px;\n  font-size: 40px;\n  color: gray;\n  font-weight: 300;\n}\n\nh1.count-downtime {\n  background: #8080802b;\n  text-align: center;\n  border-radius: 56px;\n  display: flex;\n  justify-content: center;\n  width: 230px;\n  font-size: 45px;\n  color: gray;\n  font-weight: 300;\n}\n\n.socialmediagridicon {\n  display: flex;\n  gap: 11px;\n}\n\ni.fa.fa-download.downloadicon {\n  font-size: 42px;\n  background: #141414;\n  padding: 14px 13px;\n  border-radius: 43px;\n  width: 67px;\n  color: white;\n}\n\nimg.social-media-iconss {\n  width: 90px;\n  height: 67px;\n  object-fit: contain;\n}\n\n.timer-countai {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 38px;\n}\n\n.mapboxgl-ctrl.mapboxgl-ctrl-group {\n  margin-top: 45rem !important;\n  margin-right: 1rem !important;\n}\n\n.mapboxgl-ctrl-geocoder.mapboxgl-ctrl {\n  display: flex;\n  align-items: center;\n  position: absolute;\n  right: 12px;\n  top: 16px;\n}\n\n/* .map-vedioshow {\n  width: 1290px !important;\n  height: 740px !important;\n  border-radius: 30px !important;\n} */\n\nimg.vedioshow-gif {\n  width: 1290px !important;\n  height: 740px !important;\n  object-fit: cover !important;\n  /* border-radius: 30px !important; */\n}\n\n/* new cs 21 aug  */\n\nul.recharts-default-legend {\n  margin-top: 40px !important;\n  margin-left: 50px !important;\n}\n\n.right_sidee {\n  height: 360px;\n  overflow: scroll;\n}\n\n.player-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-top: 14px !important;\n  transition: opacity 2s ease-in !important;\n  opacity: 0;\n  position: absolute;\n  top: 150px;\n  width: 70%;\n}\n\n.mapbox-show {\n  height: 90vh;\n  transition: opacity 2s ease-out; /* Add transition property */\n  opacity: 1;\n}\n\n.map-vedioshow {\n  max-width: 100%;\n  height: auto;\n}\n\nsvg.sendmessagevedio {\n  background: #cac8c8;\n  border-radius: 8px;\n  color: #7867c1;\n  width: 45px;\n  height: 45px;\n  padding: 4px 5px;\n}\n\n.chatpast-sectionlist {\n  height: 230px;\n  overflow: overlay;\n}\n\ninput.edit-timervideo {\n  font-size: 41px;\n  text-align: center;\n  width: 226px;\n  border-radius: 40px;\n  padding: 4px 6px;\n}\n\n.main-geofont-fam {\n  font-family: \"Poppins\";\n}\n\nbody {\n  font-family: \"Poppins\" !important;\n}\n\n/* 4-22-2024 css */\n.videosec img {\n  margin: 0 auto;\n  width: 100%;\n}\np.emailtext {\n  margin: unset;\n}\n\n.info-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  font-size: 14px;\n  font-weight: bold;\n  color: #7867c1 !important;\n  background-color: #e0e0e0;\n  border-radius: 50%;\n  cursor: pointer;\n  margin-left: 8px;\n  box-shadow: 0 3px 4px rgba(0, 0, 0, 0.2);\n  transition: transform 0.2s, box-shadow 0.2s;\n  position: relative;\n  top: -5px;\n}\n\n.info-icon:hover {\n  transform: scale(1.1);\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n}\n\n.info-icon:active {\n  transform: scale(1);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
